import * as s from "react";
import { useState as vo, useRef as ep, useCallback as Ss, useEffect as Ia, forwardRef as Rs, createElement as Hn, useLayoutEffect as tp } from "react";
import { jsx as l, jsxs as I, Fragment as ve } from "react/jsx-runtime";
import * as yt from "react-dom";
function Ns(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = Ns(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function Es() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = Ns(e)) && (n && (n += " "), n += t);
  return n;
}
const go = "-", rp = (e) => {
  const t = op(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (i) => {
      const c = i.split(go);
      return c[0] === "" && c.length !== 1 && c.shift(), Ps(c, t) || np(i);
    },
    getConflictingClassGroupIds: (i, c) => {
      const d = r[i] || [];
      return c && n[i] ? [...d, ...n[i]] : d;
    }
  };
}, Ps = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), o = n ? Ps(e.slice(1), n) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(go);
  return (i = t.validators.find(({
    validator: c
  }) => c(a))) == null ? void 0 : i.classGroupId;
}, Da = /^\[(.+)\]$/, np = (e) => {
  if (Da.test(e)) {
    const t = Da.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, op = (e) => {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return sp(Object.entries(e.classGroups), r).forEach(([a, i]) => {
    Gn(i, n, a, t);
  }), n;
}, Gn = (e, t, r, n) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : ka(t, o);
      a.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (ap(o)) {
        Gn(o(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(([a, i]) => {
      Gn(i, ka(t, a), r, n);
    });
  });
}, ka = (e, t) => {
  let r = e;
  return t.split(go).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, ap = (e) => e.isThemeGetter, sp = (e, t) => t ? e.map(([r, n]) => {
  const o = n.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([i, c]) => [t + i, c])) : a);
  return [r, o];
}) : e, ip = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const o = (a, i) => {
    r.set(a, i), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let i = r.get(a);
      if (i !== void 0)
        return i;
      if ((i = n.get(a)) !== void 0)
        return o(a, i), i;
    },
    set(a, i) {
      r.has(a) ? r.set(a, i) : o(a, i);
    }
  };
}, Ts = "!", cp = (e) => {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, n = t.length === 1, o = t[0], a = t.length, i = (c) => {
    const d = [];
    let u = 0, p = 0, f;
    for (let b = 0; b < c.length; b++) {
      let w = c[b];
      if (u === 0) {
        if (w === o && (n || c.slice(b, b + a) === t)) {
          d.push(c.slice(p, b)), p = b + a;
          continue;
        }
        if (w === "/") {
          f = b;
          continue;
        }
      }
      w === "[" ? u++ : w === "]" && u--;
    }
    const m = d.length === 0 ? c : c.substring(p), v = m.startsWith(Ts), g = v ? m.substring(1) : m, h = f && f > p ? f - p : void 0;
    return {
      modifiers: d,
      hasImportantModifier: v,
      baseClassName: g,
      maybePostfixModifierPosition: h
    };
  };
  return r ? (c) => r({
    className: c,
    parseClassName: i
  }) : i;
}, lp = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}, dp = (e) => ({
  cache: ip(e.cacheSize),
  parseClassName: cp(e),
  ...rp(e)
}), up = /\s+/, fp = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: o
  } = t, a = [], i = e.trim().split(up);
  let c = "";
  for (let d = i.length - 1; d >= 0; d -= 1) {
    const u = i[d], {
      modifiers: p,
      hasImportantModifier: f,
      baseClassName: m,
      maybePostfixModifierPosition: v
    } = r(u);
    let g = !!v, h = n(g ? m.substring(0, v) : m);
    if (!h) {
      if (!g) {
        c = u + (c.length > 0 ? " " + c : c);
        continue;
      }
      if (h = n(m), !h) {
        c = u + (c.length > 0 ? " " + c : c);
        continue;
      }
      g = !1;
    }
    const b = lp(p).join(":"), w = f ? b + Ts : b, y = w + h;
    if (a.includes(y))
      continue;
    a.push(y);
    const x = o(h, g);
    for (let C = 0; C < x.length; ++C) {
      const S = x[C];
      a.push(w + S);
    }
    c = u + (c.length > 0 ? " " + c : c);
  }
  return c;
};
function pp() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = _s(t)) && (n && (n += " "), n += r);
  return n;
}
const _s = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = _s(e[n])) && (r && (r += " "), r += t);
  return r;
};
function mp(e, ...t) {
  let r, n, o, a = i;
  function i(d) {
    const u = t.reduce((p, f) => f(p), e());
    return r = dp(u), n = r.cache.get, o = r.cache.set, a = c, c(d);
  }
  function c(d) {
    const u = n(d);
    if (u)
      return u;
    const p = fp(d, r);
    return o(d, p), p;
  }
  return function() {
    return a(pp.apply(null, arguments));
  };
}
const ee = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, Ms = /^\[(?:([a-z-]+):)?(.+)\]$/i, hp = /^\d+\/\d+$/, vp = /* @__PURE__ */ new Set(["px", "full", "screen"]), gp = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, bp = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, wp = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, yp = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, xp = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, De = (e) => ut(e) || vp.has(e) || hp.test(e), Fe = (e) => xt(e, "length", _p), ut = (e) => !!e && !Number.isNaN(Number(e)), Pn = (e) => xt(e, "number", ut), Mt = (e) => !!e && Number.isInteger(Number(e)), Cp = (e) => e.endsWith("%") && ut(e.slice(0, -1)), W = (e) => Ms.test(e), Ve = (e) => gp.test(e), Sp = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Rp = (e) => xt(e, Sp, As), Np = (e) => xt(e, "position", As), Ep = /* @__PURE__ */ new Set(["image", "url"]), Pp = (e) => xt(e, Ep, Ap), Tp = (e) => xt(e, "", Mp), At = () => !0, xt = (e, t, r) => {
  const n = Ms.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}, _p = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  bp.test(e) && !wp.test(e)
), As = () => !1, Mp = (e) => yp.test(e), Ap = (e) => xp.test(e), Ip = () => {
  const e = ee("colors"), t = ee("spacing"), r = ee("blur"), n = ee("brightness"), o = ee("borderColor"), a = ee("borderRadius"), i = ee("borderSpacing"), c = ee("borderWidth"), d = ee("contrast"), u = ee("grayscale"), p = ee("hueRotate"), f = ee("invert"), m = ee("gap"), v = ee("gradientColorStops"), g = ee("gradientColorStopPositions"), h = ee("inset"), b = ee("margin"), w = ee("opacity"), y = ee("padding"), x = ee("saturate"), C = ee("scale"), S = ee("sepia"), R = ee("skew"), E = ee("space"), T = ee("translate"), M = () => ["auto", "contain", "none"], O = () => ["auto", "hidden", "clip", "visible", "scroll"], D = () => ["auto", W, t], L = () => [W, t], H = () => ["", De, Fe], k = () => ["auto", ut, W], B = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], $ = () => ["solid", "dashed", "dotted", "double", "none"], z = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], F = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], _ = () => ["", "0", W], U = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], K = () => [ut, W];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [At],
      spacing: [De, Fe],
      blur: ["none", "", Ve, W],
      brightness: K(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Ve, W],
      borderSpacing: L(),
      borderWidth: H(),
      contrast: K(),
      grayscale: _(),
      hueRotate: K(),
      invert: _(),
      gap: L(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Cp, Fe],
      inset: D(),
      margin: D(),
      opacity: K(),
      padding: L(),
      saturate: K(),
      scale: K(),
      sepia: _(),
      skew: K(),
      space: L(),
      translate: L()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", W]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ve]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": U()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": U()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...B(), W]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: O()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": O()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": O()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: M()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": M()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": M()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [h]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Mt, W]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: D()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", W]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: _()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: _()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Mt, W]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [At]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Mt, W]
        }, W]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": k()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": k()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [At]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Mt, W]
        }, W]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": k()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": k()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", W]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", W]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [m]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [m]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [m]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...F()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...F(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...F(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [E]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [E]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", W, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [W, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [W, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Ve]
        }, Ve]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [W, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [W, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [W, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [W, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Ve, Fe]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Pn]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [At]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", W]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", ut, Pn]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", De, W]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", W]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", W]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...$(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", De, Fe]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", De, W]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: L()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", W]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", W]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...B(), Np]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Rp]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Pp]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [v]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [c]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [c]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [c]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [c]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [c]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [c]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [c]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [c]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [c]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...$(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [c]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [c]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: $()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...$()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [De, W]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [De, Fe]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: H()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [De, Fe]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Ve, Tp]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [At]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...z(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [d]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Ve, W]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [p]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [d]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [p]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", W]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: K()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", W]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: K()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", W]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Mt, W]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [T]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [T]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [R]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [R]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", W]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", W]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": L()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": L()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": L()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": L()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": L()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": L()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": L()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": L()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": L()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": L()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": L()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": L()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": L()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": L()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": L()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": L()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": L()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": L()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", W]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [De, Fe, Pn]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Dp = /* @__PURE__ */ mp(Ip);
function N(...e) {
  return Dp(Es(e));
}
function PS(e) {
  const { value: t, defaultValue: r, onChange: n } = e, o = t !== void 0, [a, i] = vo(r), c = ep(o ? t : a);
  c.current = o ? t : a;
  const d = Ss(
    (u) => {
      o || i(u), n == null || n(u);
    },
    [o, n]
  );
  return [c.current, d];
}
const Oa = "bizpandit-ui-theme";
function La() {
  return typeof window > "u" ? "light" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function $a(e) {
  const t = document.documentElement;
  t.classList.toggle("dark", e === "dark"), t.setAttribute("data-theme", e);
}
function kp(e = "system") {
  const [t, r] = vo(() => typeof window > "u" ? e : localStorage.getItem(Oa) ?? e), n = t === "system" ? La() : t;
  Ia(() => {
    $a(n);
  }, [n]), Ia(() => {
    if (t !== "system") return;
    const a = window.matchMedia("(prefers-color-scheme: dark)"), i = () => $a(La());
    return a.addEventListener("change", i), () => a.removeEventListener("change", i);
  }, [t]);
  const o = Ss((a) => {
    r(a);
    try {
      localStorage.setItem(Oa, a);
    } catch {
    }
  }, []);
  return { theme: t, resolvedTheme: n, setTheme: o };
}
const Fa = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Va = Es, me = (e, t) => (r) => {
  var n;
  if ((t == null ? void 0 : t.variants) == null) return Va(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: o, defaultVariants: a } = t, i = Object.keys(o).map((u) => {
    const p = r == null ? void 0 : r[u], f = a == null ? void 0 : a[u];
    if (p === null) return null;
    const m = Fa(p) || Fa(f);
    return o[u][m];
  }), c = r && Object.entries(r).reduce((u, p) => {
    let [f, m] = p;
    return m === void 0 || (u[f] = m), u;
  }, {}), d = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((u, p) => {
    let { class: f, className: m, ...v } = p;
    return Object.entries(v).every((g) => {
      let [h, b] = g;
      return Array.isArray(b) ? b.includes({
        ...a,
        ...c
      }[h]) : {
        ...a,
        ...c
      }[h] === b;
    }) ? [
      ...u,
      f,
      m
    ] : u;
  }, []);
  return Va(e, i, d, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
}, Op = me("mx-auto w-full px-4 sm:px-6 lg:px-8", {
  variants: {
    size: {
      sm: "max-w-2xl",
      md: "max-w-4xl",
      lg: "max-w-6xl",
      xl: "max-w-7xl",
      full: "max-w-none"
    }
  },
  defaultVariants: { size: "xl" }
}), Lp = s.forwardRef(
  ({ className: e, size: t, ...r }, n) => /* @__PURE__ */ l(
    "div",
    {
      ref: n,
      className: N(Op({ size: t }), e),
      ...r
    }
  )
);
Lp.displayName = "Container";
const $p = me("flex", {
  variants: {
    direction: {
      vertical: "flex-col",
      horizontal: "flex-row"
    },
    gap: {
      none: "gap-0",
      xs: "gap-1",
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8"
    },
    align: {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      stretch: "items-stretch"
    },
    justify: {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between",
      around: "justify-around"
    },
    wrap: {
      wrap: "flex-wrap",
      nowrap: "flex-nowrap"
    }
  },
  defaultVariants: {
    direction: "vertical",
    gap: "md",
    align: "stretch",
    justify: "start",
    wrap: "nowrap"
  }
}), Fp = s.forwardRef(
  ({ className: e, direction: t, gap: r, align: n, justify: o, wrap: a, as: i = "div", ...c }, d) => /* @__PURE__ */ l(
    i,
    {
      ref: d,
      className: N(
        $p({ direction: t, gap: r, align: n, justify: o, wrap: a }),
        e
      ),
      ...c
    }
  )
);
Fp.displayName = "Stack";
const Vp = me("grid", {
  variants: {
    cols: {
      1: "grid-cols-1",
      2: "grid-cols-1 sm:grid-cols-2",
      3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
      4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
      6: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-6",
      12: "grid-cols-4 sm:grid-cols-6 lg:grid-cols-12"
    },
    gap: {
      none: "gap-0",
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8"
    }
  },
  defaultVariants: { cols: "3", gap: "md" }
}), Bp = s.forwardRef(
  ({ className: e, cols: t, gap: r, ...n }, o) => /* @__PURE__ */ l(
    "div",
    {
      ref: o,
      className: N(Vp({ cols: t, gap: r }), e),
      ...n
    }
  )
);
Bp.displayName = "Grid";
const zp = me("flex", {
  variants: {
    direction: {
      row: "flex-row",
      col: "flex-col",
      "row-reverse": "flex-row-reverse",
      "col-reverse": "flex-col-reverse"
    },
    align: {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      stretch: "items-stretch",
      baseline: "items-baseline"
    },
    justify: {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between",
      around: "justify-around",
      evenly: "justify-evenly"
    },
    gap: {
      none: "gap-0",
      xs: "gap-1",
      sm: "gap-2",
      md: "gap-4",
      lg: "gap-6",
      xl: "gap-8"
    },
    wrap: {
      wrap: "flex-wrap",
      nowrap: "flex-nowrap"
    }
  },
  defaultVariants: {
    direction: "row",
    align: "center",
    justify: "start",
    gap: "none",
    wrap: "nowrap"
  }
}), Hp = s.forwardRef(
  ({ className: e, direction: t, align: r, justify: n, gap: o, wrap: a, as: i = "div", ...c }, d) => /* @__PURE__ */ l(
    i,
    {
      ref: d,
      className: N(
        zp({ direction: t, align: r, justify: n, gap: o, wrap: a }),
        e
      ),
      ...c
    }
  )
);
Hp.displayName = "Flex";
function Ba(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Gp(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((o) => {
      const a = Ba(o, t);
      return !r && typeof a == "function" && (r = !0), a;
    });
    if (r)
      return () => {
        for (let o = 0; o < n.length; o++) {
          const a = n[o];
          typeof a == "function" ? a() : Ba(e[o], null);
        }
      };
  };
}
function V(...e) {
  return s.useCallback(Gp(...e), e);
}
// @__NO_SIDE_EFFECTS__
function Ge(e) {
  const t = s.forwardRef((r, n) => {
    let { children: o, ...a } = r, i = null, c = !1;
    const d = [];
    za(o) && typeof dr == "function" && (o = dr(o._payload)), s.Children.forEach(o, (m) => {
      var v;
      if (Yp(m)) {
        c = !0;
        const g = m;
        let h = "child" in g.props ? g.props.child : g.props.children;
        za(h) && typeof dr == "function" && (h = dr(h._payload)), i = Up(g, h), d.push((v = i == null ? void 0 : i.props) == null ? void 0 : v.children);
      } else
        d.push(m);
    }), i ? i = s.cloneElement(i, void 0, d) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !c && s.Children.count(o) === 1 && s.isValidElement(o) && (i = o)
    );
    const u = i ? jp(i) : void 0, p = V(n, u);
    if (!i) {
      if (o || o === 0)
        throw new Error(
          c ? Qp(e) : Zp(e)
        );
      return o;
    }
    const f = Kp(a, i.props ?? {});
    return i.type !== s.Fragment && (f.ref = n ? p : u), s.cloneElement(i, f);
  });
  return t.displayName = `${e}.Slot`, t;
}
var Is = /* @__PURE__ */ Ge("Slot"), Ds = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function ks(e) {
  const t = (r) => "child" in r ? r.children(r.child) : r.children;
  return t.displayName = `${e}.Slottable`, t.__radixId = Ds, t;
}
var Wp = /* @__PURE__ */ ks("Slottable"), Up = (e, t) => {
  if ("child" in e.props) {
    const r = e.props.child;
    return s.isValidElement(r) ? s.cloneElement(r, void 0, e.props.children(r.props.children)) : null;
  }
  return s.isValidElement(t) ? t : null;
};
function Kp(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? o && a ? r[n] = (...c) => {
      const d = a(...c);
      return o(...c), d;
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...a } : n === "className" && (r[n] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function jp(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
function Yp(e) {
  return s.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Ds;
}
var Xp = Symbol.for("react.lazy");
function za(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === Xp && "_payload" in e && qp(e._payload);
}
function qp(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
var Zp = (e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, Qp = (e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, dr = s[" use ".trim().toString()], Jp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], A = Jp.reduce((e, t) => {
  const r = /* @__PURE__ */ Ge(`Primitive.${t}`), n = s.forwardRef((o, a) => {
    const { asChild: i, ...c } = o, d = i ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(d, { ...c, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function bo(e, t) {
  e && yt.flushSync(() => e.dispatchEvent(t));
}
var em = "Separator", Ha = "horizontal", tm = ["horizontal", "vertical"], Os = s.forwardRef((e, t) => {
  const { decorative: r, orientation: n = Ha, ...o } = e, a = rm(n) ? n : Ha, c = r ? { role: "none" } : { "aria-orientation": a === "vertical" ? a : void 0, role: "separator" };
  return /* @__PURE__ */ l(
    A.div,
    {
      "data-orientation": a,
      ...c,
      ...o,
      ref: t
    }
  );
});
Os.displayName = em;
function rm(e) {
  return tm.includes(e);
}
var Ls = Os;
const nm = s.forwardRef(({ className: e, orientation: t = "horizontal", decorative: r = !0, ...n }, o) => /* @__PURE__ */ l(
  Ls,
  {
    ref: o,
    orientation: t,
    decorative: r,
    className: N(
      "shrink-0 bg-border",
      t === "horizontal" ? "h-px w-full" : "h-full w-px",
      e
    ),
    ...n
  }
));
nm.displayName = Ls.displayName;
var oe = globalThis != null && globalThis.document ? s.useLayoutEffect : () => {
};
function om(e, t) {
  return s.useReducer((r, n) => t[r][n] ?? r, e);
}
var ne = (e) => {
  const { present: t, children: r } = e, n = am(t), o = typeof r == "function" ? r({ present: n.isPresent }) : s.Children.only(r), a = sm(n.ref, im(o));
  return typeof r == "function" || n.isPresent ? s.cloneElement(o, { ref: a }) : null;
};
ne.displayName = "Presence";
function am(e) {
  const [t, r] = s.useState(), n = s.useRef(null), o = s.useRef(e), a = s.useRef("none"), i = s.useRef(void 0), c = e ? "mounted" : "unmounted", [d, u] = om(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    d === "mounted" ? (a.current = i.current ?? It(n.current), i.current = void 0) : a.current = "none";
  }, [d]), oe(() => {
    const p = n.current, f = o.current;
    if (f !== e) {
      const v = a.current, g = It(p);
      e ? (i.current = g, u("MOUNT")) : g === "none" || (p == null ? void 0 : p.display) === "none" ? u("UNMOUNT") : u(f && v !== g ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, u]), oe(() => {
    if (t) {
      let p;
      const f = t.ownerDocument.defaultView ?? window, m = (g) => {
        const b = It(n.current).includes(CSS.escape(g.animationName));
        if (g.target === t && b && (u("ANIMATION_END"), !o.current)) {
          const w = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = w);
          });
        }
      }, v = (g) => {
        g.target === t && (a.current = It(n.current));
      };
      return t.addEventListener("animationstart", v), t.addEventListener("animationcancel", m), t.addEventListener("animationend", m), () => {
        f.clearTimeout(p), t.removeEventListener("animationstart", v), t.removeEventListener("animationcancel", m), t.removeEventListener("animationend", m);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(d),
    ref: s.useCallback((p) => {
      if (p) {
        const f = getComputedStyle(p);
        n.current = f, i.current = It(f);
      } else
        n.current = null;
      r(p);
    }, [])
  };
}
function Ga(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function sm(...e) {
  const t = s.useRef(e);
  return t.current = e, s.useCallback((r) => {
    const n = t.current;
    let o = !1;
    const a = n.map((i) => {
      const c = Ga(i, r);
      return !o && typeof c == "function" && (o = !0), c;
    });
    if (o)
      return () => {
        for (let i = 0; i < a.length; i++) {
          const c = a[i];
          typeof c == "function" ? c() : Ga(n[i], null);
        }
      };
  }, []);
}
function It(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function im(e) {
  var n, o;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
function ae(e, t = []) {
  let r = [];
  function n(a, i) {
    const c = s.createContext(i);
    c.displayName = a + "Context";
    const d = r.length;
    r = [...r, i];
    const u = (f) => {
      var w;
      const { scope: m, children: v, ...g } = f, h = ((w = m == null ? void 0 : m[e]) == null ? void 0 : w[d]) || c, b = s.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ l(h.Provider, { value: b, children: v });
    };
    u.displayName = a + "Provider";
    function p(f, m, v = {}) {
      var w;
      const { optional: g = !1 } = v, h = ((w = m == null ? void 0 : m[e]) == null ? void 0 : w[d]) || c, b = s.useContext(h);
      if (b) return b;
      if (i !== void 0) return i;
      if (!g)
        throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [u, p];
  }
  const o = () => {
    const a = r.map((i) => s.createContext(i));
    return function(c) {
      const d = (c == null ? void 0 : c[e]) || a;
      return s.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: d } }),
        [c, d]
      );
    };
  };
  return o.scopeName = e, [n, cm(o, ...t)];
}
function cm(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = n.reduce((c, { useScope: d, scopeName: u }) => {
        const f = d(a)[`__scope${u}`];
        return { ...c, ...f };
      }, {});
      return s.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function te(e) {
  const t = s.useRef(e);
  return s.useEffect(() => {
    t.current = e;
  }), s.useMemo(() => ((...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }), []);
}
var lm = s.createContext(void 0);
function Le(e) {
  const t = s.useContext(lm);
  return e || t || "ltr";
}
function Ot(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
function P(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), r === !1 || !o || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function dm(e, t) {
  return s.useReducer((r, n) => t[r][n] ?? r, e);
}
var wo = "ScrollArea", [$s] = ae(wo), [um, ge] = $s(wo), Fs = s.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: r,
      type: n = "hover",
      dir: o,
      scrollHideDelay: a = 600,
      ...i
    } = e, [c, d] = s.useState(null), [u, p] = s.useState(null), [f, m] = s.useState(null), [v, g] = s.useState(null), [h, b] = s.useState(null), [w, y] = s.useState(0), [x, C] = s.useState(0), [S, R] = s.useState(!1), [E, T] = s.useState(!1), M = V(t, d), O = Le(o);
    return /* @__PURE__ */ l(
      um,
      {
        scope: r,
        type: n,
        dir: O,
        scrollHideDelay: a,
        scrollArea: c,
        viewport: u,
        onViewportChange: p,
        content: f,
        onContentChange: m,
        scrollbarX: v,
        onScrollbarXChange: g,
        scrollbarXEnabled: S,
        onScrollbarXEnabledChange: R,
        scrollbarY: h,
        onScrollbarYChange: b,
        scrollbarYEnabled: E,
        onScrollbarYEnabledChange: T,
        onCornerWidthChange: y,
        onCornerHeightChange: C,
        children: /* @__PURE__ */ l(
          A.div,
          {
            dir: O,
            ...i,
            ref: M,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": x + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Fs.displayName = wo;
var Vs = "ScrollAreaViewport", Bs = s.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, children: n, nonce: o, ...a } = e, i = ge(Vs, r), c = s.useRef(null), d = V(t, c, i.onViewportChange);
    return /* @__PURE__ */ I(ve, { children: [
      /* @__PURE__ */ l(fm, { nonce: o }),
      /* @__PURE__ */ l(
        A.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...a,
          ref: d,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ l("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: n })
        }
      )
    ] });
  }
);
Bs.displayName = Vs;
var fm = s.memo(
  ({ nonce: e }) => /* @__PURE__ */ l(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
      },
      nonce: e
    }
  ),
  (e, t) => e.nonce === t.nonce
), _e = "ScrollAreaScrollbar", zs = s.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, o = ge(_e, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: i } = o, c = e.orientation === "horizontal";
    return s.useEffect(() => (c ? a(!0) : i(!0), () => {
      c ? a(!1) : i(!1);
    }), [c, a, i]), o.type === "hover" ? /* @__PURE__ */ l(pm, { ...n, ref: t, forceMount: r }) : o.type === "scroll" ? /* @__PURE__ */ l(mm, { ...n, ref: t, forceMount: r }) : o.type === "auto" ? /* @__PURE__ */ l(Hs, { ...n, ref: t, forceMount: r }) : o.type === "always" ? /* @__PURE__ */ l(yo, { ...n, ref: t, "data-state": "visible" }) : null;
  }
);
zs.displayName = _e;
var pm = s.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, o = ge(_e, e.__scopeScrollArea), [a, i] = s.useState(!1);
  return s.useEffect(() => {
    const c = o.scrollArea;
    let d = 0;
    if (c) {
      const u = () => {
        window.clearTimeout(d), i(!0);
      }, p = () => {
        d = window.setTimeout(() => i(!1), o.scrollHideDelay);
      };
      return c.addEventListener("pointerenter", u), c.addEventListener("pointerleave", p), () => {
        window.clearTimeout(d), c.removeEventListener("pointerenter", u), c.removeEventListener("pointerleave", p);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ l(ne, { present: r || a, children: /* @__PURE__ */ l(
    Hs,
    {
      "data-state": a ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), mm = s.forwardRef((e, t) => {
  const { forceMount: r, ...n } = e, o = ge(_e, e.__scopeScrollArea), a = e.orientation === "horizontal", i = zr(() => d("SCROLL_END"), 100), [c, d] = dm("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return s.useEffect(() => {
    if (c === "idle") {
      const u = window.setTimeout(() => d("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(u);
    }
  }, [c, o.scrollHideDelay, d]), s.useEffect(() => {
    const u = o.viewport, p = a ? "scrollLeft" : "scrollTop";
    if (u) {
      let f = u[p];
      const m = () => {
        const v = u[p];
        f !== v && (d("SCROLL"), i()), f = v;
      };
      return u.addEventListener("scroll", m), () => u.removeEventListener("scroll", m);
    }
  }, [o.viewport, a, d, i]), /* @__PURE__ */ l(ne, { present: r || c !== "hidden", children: /* @__PURE__ */ l(
    yo,
    {
      "data-state": c === "hidden" ? "hidden" : "visible",
      ...n,
      ref: t,
      onPointerEnter: P(e.onPointerEnter, () => d("POINTER_ENTER")),
      onPointerLeave: P(e.onPointerLeave, () => d("POINTER_LEAVE"))
    }
  ) });
}), Hs = s.forwardRef((e, t) => {
  const r = ge(_e, e.__scopeScrollArea), { forceMount: n, ...o } = e, [a, i] = s.useState(!1), c = e.orientation === "horizontal", d = zr(() => {
    if (r.viewport) {
      const u = r.viewport.offsetWidth < r.viewport.scrollWidth, p = r.viewport.offsetHeight < r.viewport.scrollHeight;
      i(c ? u : p);
    }
  }, 10);
  return mt(r.viewport, d), mt(r.content, d), /* @__PURE__ */ l(ne, { present: n || a, children: /* @__PURE__ */ l(
    yo,
    {
      "data-state": a ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), yo = s.forwardRef((e, t) => {
  const { orientation: r = "vertical", ...n } = e, o = ge(_e, e.__scopeScrollArea), a = s.useRef(null), i = s.useRef(0), [c, d] = s.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), u = js(c.viewport, c.content), p = {
    ...n,
    sizes: c,
    onSizesChange: d,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (m) => a.current = m,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (m) => i.current = m
  };
  function f(m, v) {
    return ym(m, i.current, c, v);
  }
  return r === "horizontal" ? /* @__PURE__ */ l(
    hm,
    {
      ...p,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && a.current) {
          const m = o.viewport.scrollLeft, v = Wa(m, c, o.dir);
          a.current.style.transform = `translate3d(${v}px, 0, 0)`;
        }
      },
      onWheelScroll: (m) => {
        o.viewport && (o.viewport.scrollLeft = m);
      },
      onDragScroll: (m) => {
        o.viewport && (o.viewport.scrollLeft = f(m, o.dir));
      }
    }
  ) : r === "vertical" ? /* @__PURE__ */ l(
    vm,
    {
      ...p,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && a.current) {
          const m = o.viewport.scrollTop, v = Wa(m, c);
          a.current.style.transform = `translate3d(0, ${v}px, 0)`;
        }
      },
      onWheelScroll: (m) => {
        o.viewport && (o.viewport.scrollTop = m);
      },
      onDragScroll: (m) => {
        o.viewport && (o.viewport.scrollTop = f(m));
      }
    }
  ) : null;
}), hm = s.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...o } = e, a = ge(_e, e.__scopeScrollArea), [i, c] = s.useState(), d = s.useRef(null), u = V(t, d, a.onScrollbarXChange);
  return s.useEffect(() => {
    d.current && c(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ l(
    Ws,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: u,
      sizes: r,
      style: {
        bottom: 0,
        left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Br(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.x),
      onDragScroll: (p) => e.onDragScroll(p.x),
      onWheelScroll: (p, f) => {
        if (a.viewport) {
          const m = a.viewport.scrollLeft + p.deltaX;
          e.onWheelScroll(m), Xs(m, f) && p.preventDefault();
        }
      },
      onResize: () => {
        d.current && a.viewport && i && n({
          content: a.viewport.scrollWidth,
          viewport: a.viewport.offsetWidth,
          scrollbar: {
            size: d.current.clientWidth,
            paddingStart: Pr(i.paddingLeft),
            paddingEnd: Pr(i.paddingRight)
          }
        });
      }
    }
  );
}), vm = s.forwardRef((e, t) => {
  const { sizes: r, onSizesChange: n, ...o } = e, a = ge(_e, e.__scopeScrollArea), [i, c] = s.useState(), d = s.useRef(null), u = V(t, d, a.onScrollbarYChange);
  return s.useEffect(() => {
    d.current && c(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ l(
    Ws,
    {
      "data-orientation": "vertical",
      ...o,
      ref: u,
      sizes: r,
      style: {
        top: 0,
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Br(r) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.y),
      onDragScroll: (p) => e.onDragScroll(p.y),
      onWheelScroll: (p, f) => {
        if (a.viewport) {
          const m = a.viewport.scrollTop + p.deltaY;
          e.onWheelScroll(m), Xs(m, f) && p.preventDefault();
        }
      },
      onResize: () => {
        d.current && a.viewport && i && n({
          content: a.viewport.scrollHeight,
          viewport: a.viewport.offsetHeight,
          scrollbar: {
            size: d.current.clientHeight,
            paddingStart: Pr(i.paddingTop),
            paddingEnd: Pr(i.paddingBottom)
          }
        });
      }
    }
  );
}), [gm, Gs] = $s(_e), Ws = s.forwardRef((e, t) => {
  const {
    __scopeScrollArea: r,
    sizes: n,
    hasThumb: o,
    onThumbChange: a,
    onThumbPointerUp: i,
    onThumbPointerDown: c,
    onThumbPositionChange: d,
    onDragScroll: u,
    onWheelScroll: p,
    onResize: f,
    ...m
  } = e, v = ge(_e, r), [g, h] = s.useState(null), b = V(t, h), w = s.useRef(null), y = s.useRef(""), x = v.viewport, C = n.content - n.viewport, S = te(p), R = te(d), E = zr(f, 10);
  function T(M) {
    if (w.current) {
      const O = M.clientX - w.current.left, D = M.clientY - w.current.top;
      u({ x: O, y: D });
    }
  }
  return s.useEffect(() => {
    const M = (O) => {
      const D = O.target;
      (g == null ? void 0 : g.contains(D)) && S(O, C);
    };
    return document.addEventListener("wheel", M, { passive: !1 }), () => document.removeEventListener("wheel", M, { passive: !1 });
  }, [x, g, C, S]), s.useEffect(R, [n, R]), mt(g, E), mt(v.content, E), /* @__PURE__ */ l(
    gm,
    {
      scope: r,
      scrollbar: g,
      hasThumb: o,
      onThumbChange: te(a),
      onThumbPointerUp: te(i),
      onThumbPositionChange: R,
      onThumbPointerDown: te(c),
      children: /* @__PURE__ */ l(
        A.div,
        {
          ...m,
          ref: b,
          style: { position: "absolute", ...m.style },
          onPointerDown: P(e.onPointerDown, (M) => {
            M.button === 0 && (M.target.setPointerCapture(M.pointerId), w.current = g.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", v.viewport && (v.viewport.style.scrollBehavior = "auto"), T(M));
          }),
          onPointerMove: P(e.onPointerMove, T),
          onPointerUp: P(e.onPointerUp, (M) => {
            const O = M.target;
            O.hasPointerCapture(M.pointerId) && O.releasePointerCapture(M.pointerId), document.body.style.webkitUserSelect = y.current, v.viewport && (v.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), Er = "ScrollAreaThumb", Us = s.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, o = Gs(Er, e.__scopeScrollArea);
    return /* @__PURE__ */ l(ne, { present: r || o.hasThumb, children: /* @__PURE__ */ l(bm, { ref: t, ...n }) });
  }
), bm = s.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: r, style: n, ...o } = e, a = ge(Er, r), i = Gs(Er, r), { onThumbPositionChange: c } = i, d = V(t, i.onThumbChange), u = s.useRef(void 0), p = zr(() => {
      u.current && (u.current(), u.current = void 0);
    }, 100);
    return s.useEffect(() => {
      const f = a.viewport;
      if (f) {
        const m = () => {
          if (p(), !u.current) {
            const v = xm(f, c);
            u.current = v, c();
          }
        };
        return c(), f.addEventListener("scroll", m), () => f.removeEventListener("scroll", m);
      }
    }, [a.viewport, p, c]), /* @__PURE__ */ l(
      A.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...o,
        ref: d,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...n
        },
        onPointerDownCapture: P(e.onPointerDownCapture, (f) => {
          const v = f.target.getBoundingClientRect(), g = f.clientX - v.left, h = f.clientY - v.top;
          i.onThumbPointerDown({ x: g, y: h });
        }),
        onPointerUp: P(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
Us.displayName = Er;
var xo = "ScrollAreaCorner", Ks = s.forwardRef(
  (e, t) => {
    const r = ge(xo, e.__scopeScrollArea), n = !!(r.scrollbarX && r.scrollbarY);
    return r.type !== "scroll" && n ? /* @__PURE__ */ l(wm, { ...e, ref: t }) : null;
  }
);
Ks.displayName = xo;
var wm = s.forwardRef((e, t) => {
  const { __scopeScrollArea: r, ...n } = e, o = ge(xo, r), [a, i] = s.useState(0), [c, d] = s.useState(0), u = !!(a && c), { onCornerWidthChange: p, onCornerHeightChange: f } = o;
  return mt(o.scrollbarX, () => {
    var v;
    const m = ((v = o.scrollbarX) == null ? void 0 : v.offsetHeight) || 0;
    o.onCornerHeightChange(m), d(m);
  }), mt(o.scrollbarY, () => {
    var v;
    const m = ((v = o.scrollbarY) == null ? void 0 : v.offsetWidth) || 0;
    o.onCornerWidthChange(m), i(m);
  }), s.useEffect(() => () => {
    p(0), f(0);
  }, [p, f]), u ? /* @__PURE__ */ l(
    A.div,
    {
      ...n,
      ref: t,
      style: {
        width: a,
        height: c,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Pr(e) {
  return e ? parseInt(e, 10) : 0;
}
function js(e, t) {
  const r = e / t;
  return isNaN(r) ? 0 : r;
}
function Br(e) {
  const t = js(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, n = (e.scrollbar.size - r) * t;
  return Math.max(n, 18);
}
function ym(e, t, r, n = "ltr") {
  const o = Br(r), a = o / 2, i = t || a, c = o - i, d = r.scrollbar.paddingStart + i, u = r.scrollbar.size - r.scrollbar.paddingEnd - c, p = r.content - r.viewport, f = n === "ltr" ? [0, p] : [p * -1, 0];
  return Ys([d, u], f)(e);
}
function Wa(e, t, r = "ltr") {
  const n = Br(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - o, i = t.content - t.viewport, c = a - n, d = r === "ltr" ? [0, i] : [i * -1, 0], u = Ot(e, d);
  return Ys([0, i], [0, c])(u);
}
function Ys(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function Xs(e, t) {
  return e > 0 && e < t;
}
var xm = (e, t = () => {
}) => {
  let r = { left: e.scrollLeft, top: e.scrollTop }, n = 0;
  return (function o() {
    const a = { left: e.scrollLeft, top: e.scrollTop }, i = r.left !== a.left, c = r.top !== a.top;
    (i || c) && t(), r = a, n = window.requestAnimationFrame(o);
  })(), () => window.cancelAnimationFrame(n);
};
function zr(e, t) {
  const r = te(e), n = s.useRef(0);
  return s.useEffect(() => () => window.clearTimeout(n.current), []), s.useCallback(() => {
    window.clearTimeout(n.current), n.current = window.setTimeout(r, t);
  }, [r, t]);
}
function mt(e, t) {
  const r = te(t);
  oe(() => {
    let n = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(n), n = window.requestAnimationFrame(r);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(n), o.unobserve(e);
      };
    }
  }, [e, r]);
}
var qs = Fs, Cm = Bs, Ua = zs, Ka = Us, Sm = Ks;
const Rm = s.forwardRef(({ className: e, children: t, orientation: r = "vertical", ...n }, o) => /* @__PURE__ */ I(
  qs,
  {
    ref: o,
    className: N("relative overflow-hidden", e),
    ...n,
    children: [
      /* @__PURE__ */ l(Cm, { className: "h-full w-full rounded-[inherit]", children: t }),
      (r === "vertical" || r === "both") && /* @__PURE__ */ l(
        Ua,
        {
          orientation: "vertical",
          className: "flex touch-none select-none border-l border-l-transparent p-px transition-colors w-2.5",
          children: /* @__PURE__ */ l(Ka, { className: "relative flex-1 rounded-full bg-border" })
        }
      ),
      (r === "horizontal" || r === "both") && /* @__PURE__ */ l(
        Ua,
        {
          orientation: "horizontal",
          className: "flex touch-none select-none border-t border-t-transparent p-px transition-colors h-2.5 flex-col",
          children: /* @__PURE__ */ l(Ka, { className: "relative flex-1 rounded-full bg-border" })
        }
      ),
      /* @__PURE__ */ l(Sm, {})
    ]
  }
));
Rm.displayName = qs.displayName;
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nm = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Zs = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim();
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Em = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pm = Rs(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: o = "",
    children: a,
    iconNode: i,
    ...c
  }, d) => Hn(
    "svg",
    {
      ref: d,
      ...Em,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(t) : r,
      className: Zs("lucide", o),
      ...c
    },
    [
      ...i.map(([u, p]) => Hn(u, p)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const re = (e, t) => {
  const r = Rs(
    ({ className: n, ...o }, a) => Hn(Pm, {
      ref: a,
      iconNode: t,
      className: Zs(`lucide-${Nm(e)}`, n),
      ...o
    })
  );
  return r.displayName = `${e}`, r;
};
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qs = re("ArrowDown", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tm = re("ArrowUpDown", [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Js = re("ArrowUp", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _m = re("CalendarDays", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nt = re("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bt = re("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ei = re("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zt = re("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mm = re("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Am = re("CircleCheck", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Im = re("CircleX", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ti = re("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ri = re("Ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dm = re("EyeOff", [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const km = re("Eye", [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Om = re("Inbox", [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ja = re("Info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lm = re("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $m = re("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fm = re("Monitor", [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vm = re("Moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bm = re("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zm = re("Sun", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hm = re("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ht = re("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), Gm = me(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primary-foreground hover:opacity-90",
        secondary: "bg-secondary text-secondary-foreground hover:opacity-90",
        outline: "border border-input bg-transparent hover:bg-accent hover:text-accent-foreground",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        destructive: "bg-destructive text-destructive-foreground hover:opacity-90",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        sm: "h-9 px-3 text-sm",
        md: "h-11 px-5 text-base",
        lg: "h-12 px-6 text-base",
        icon: "h-11 w-11"
      },
      fullWidth: {
        true: "w-full"
      }
    },
    defaultVariants: { variant: "primary", size: "md" }
  }
), Co = s.forwardRef(
  ({
    className: e,
    variant: t,
    size: r,
    fullWidth: n,
    asChild: o = !1,
    loading: a = !1,
    leftIcon: i,
    rightIcon: c,
    disabled: d,
    children: u,
    ...p
  }, f) => /* @__PURE__ */ I(
    o ? Is : "button",
    {
      ref: f,
      className: N(Gm({ variant: t, size: r, fullWidth: n }), e),
      disabled: d || a,
      "aria-busy": a || void 0,
      ...p,
      children: [
        a ? /* @__PURE__ */ l(Lm, { className: "animate-spin", "aria-hidden": !0 }) : i,
        /* @__PURE__ */ l(Wp, { children: u }),
        !a && c
      ]
    }
  )
);
Co.displayName = "Button";
const Wm = me(
  "inline-flex items-center justify-center rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primary-foreground hover:opacity-90",
        secondary: "bg-secondary text-secondary-foreground hover:opacity-90",
        outline: "border border-input bg-transparent hover:bg-accent hover:text-accent-foreground",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        destructive: "bg-destructive text-destructive-foreground hover:opacity-90"
      },
      size: {
        sm: "h-8 w-8 [&_svg]:size-4",
        md: "h-11 w-11 [&_svg]:size-5",
        lg: "h-12 w-12 [&_svg]:size-6"
      },
      shape: {
        square: "rounded-lg",
        circle: "rounded-full"
      }
    },
    defaultVariants: { variant: "ghost", size: "md", shape: "square" }
  }
), ht = s.forwardRef(
  ({ className: e, variant: t, size: r, shape: n, icon: o, ...a }, i) => /* @__PURE__ */ l(
    "button",
    {
      ref: i,
      className: N(Wm({ variant: t, size: r, shape: n }), e),
      ...a,
      children: o
    }
  )
);
ht.displayName = "IconButton";
const Um = s.forwardRef(
  ({ className: e, orientation: t = "horizontal", children: r, ...n }, o) => /* @__PURE__ */ l(
    "div",
    {
      ref: o,
      role: "group",
      className: N(
        "inline-flex",
        t === "horizontal" ? "flex-row" : "flex-col",
        "[&>button]:rounded-none [&>button]:focus-visible:z-10",
        t === "horizontal" ? "[&>button:first-child]:rounded-l-lg [&>button:last-child]:rounded-r-lg [&>button:not(:first-child)]:-ml-px" : "[&>button:first-child]:rounded-t-lg [&>button:last-child]:rounded-b-lg [&>button:not(:first-child)]:-mt-px",
        e
      ),
      ...n,
      children: r
    }
  )
);
Um.displayName = "ButtonGroup";
const Hr = s.forwardRef(
  ({ className: e, type: t = "text", leftIcon: r, rightIcon: n, invalid: o, disabled: a, ...i }, c) => r || n ? /* @__PURE__ */ I("div", { className: "relative flex items-center", children: [
    r && /* @__PURE__ */ l("span", { className: "pointer-events-none absolute left-3 flex items-center text-muted-foreground [&_svg]:size-4", children: r }),
    /* @__PURE__ */ l(
      "input",
      {
        ref: c,
        type: t,
        disabled: a,
        "aria-invalid": o || void 0,
        className: N(
          "flex h-11 w-full min-w-0 rounded-lg border border-input bg-transparent px-3 py-2 text-base",
          "shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none",
          "focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          r && "pl-9",
          n && "pr-9",
          o && "border-destructive focus-visible:ring-destructive",
          e
        ),
        ...i
      }
    ),
    n && /* @__PURE__ */ l("span", { className: "absolute right-3 flex items-center text-muted-foreground [&_svg]:size-4", children: n })
  ] }) : /* @__PURE__ */ l(
    "input",
    {
      ref: c,
      type: t,
      disabled: a,
      "aria-invalid": o || void 0,
      className: N(
        "flex h-11 w-full min-w-0 rounded-lg border border-input bg-transparent px-3 py-2 text-base",
        "shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none",
        "focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        o && "border-destructive focus-visible:ring-destructive",
        e
      ),
      ...i
    }
  )
);
Hr.displayName = "Input";
const Km = s.forwardRef(
  ({ className: e, invalid: t, ...r }, n) => /* @__PURE__ */ l(
    "textarea",
    {
      ref: n,
      "aria-invalid": t || void 0,
      className: N(
        "flex min-h-24 w-full rounded-lg border border-input bg-transparent px-3 py-2 text-base shadow-sm",
        "transition-colors placeholder:text-muted-foreground focus-visible:outline-none",
        "focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        t && "border-destructive focus-visible:ring-destructive",
        e
      ),
      ...r
    }
  )
);
Km.displayName = "Textarea";
const jm = s.forwardRef(
  ({ className: e, ...t }, r) => {
    const [n, o] = s.useState(!1);
    return /* @__PURE__ */ l(
      Hr,
      {
        ref: r,
        type: n ? "text" : "password",
        className: e,
        rightIcon: /* @__PURE__ */ l(
          "button",
          {
            type: "button",
            tabIndex: 0,
            onClick: () => o((a) => !a),
            "aria-label": n ? "Hide password" : "Show password",
            className: N("pointer-events-auto rounded-sm text-muted-foreground hover:text-foreground"),
            children: n ? /* @__PURE__ */ l(Dm, { className: "size-4" }) : /* @__PURE__ */ l(km, { className: "size-4" })
          }
        ),
        ...t
      }
    );
  }
);
jm.displayName = "PasswordInput";
const Ym = s.forwardRef(
  ({ className: e, value: t, onClear: r, ...n }, o) => {
    const a = typeof t == "string" ? t.length > 0 : !!t;
    return /* @__PURE__ */ l(
      Hr,
      {
        ref: o,
        type: "search",
        value: t,
        leftIcon: /* @__PURE__ */ l(Bm, {}),
        rightIcon: a && r ? /* @__PURE__ */ l(
          "button",
          {
            type: "button",
            onClick: r,
            "aria-label": "Clear search",
            className: N("pointer-events-auto rounded-sm text-muted-foreground hover:text-foreground"),
            children: /* @__PURE__ */ l(Ht, { className: "size-4" })
          }
        ) : void 0,
        className: N("[&::-webkit-search-cancel-button]:appearance-none", e),
        ...n
      }
    );
  }
);
Ym.displayName = "SearchInput";
const Xm = s.forwardRef(
  ({
    length: e = 6,
    value: t,
    defaultValue: r = "",
    onChange: n,
    onComplete: o,
    disabled: a,
    invalid: i,
    mask: c = !1,
    className: d,
    name: u,
    "aria-label": p = "One-time passcode"
  }, f) => {
    const m = t !== void 0, [v, g] = s.useState(r), h = (m ? t : v).padEnd(e, " ").split("").slice(0, e), b = s.useRef([]);
    function w(S) {
      m || g(S), n == null || n(S), S.replace(/\s/g, "").length === e && (o == null || o(S));
    }
    function y(S, R) {
      var O;
      const E = R.replace(/[^0-9a-zA-Z]/g, "").slice(-1), T = (m ? t : v).padEnd(e, " ").split("");
      T[S] = E || " ";
      const M = T.join("");
      w(M), E && S < e - 1 && ((O = b.current[S + 1]) == null || O.focus());
    }
    function x(S, R) {
      var T, M, O;
      const E = (m ? t : v).padEnd(e, " ").split("");
      R.key === "Backspace" ? (E[S] !== " " ? (E[S] = " ", w(E.join(""))) : S > 0 && ((T = b.current[S - 1]) == null || T.focus()), R.preventDefault()) : R.key === "ArrowLeft" && S > 0 ? (M = b.current[S - 1]) == null || M.focus() : R.key === "ArrowRight" && S < e - 1 && ((O = b.current[S + 1]) == null || O.focus());
    }
    function C(S) {
      var E;
      S.preventDefault();
      const R = S.clipboardData.getData("text").replace(/[^0-9a-zA-Z]/g, "").slice(0, e);
      w(R.padEnd(e, " ")), (E = b.current[Math.min(R.length, e - 1)]) == null || E.focus();
    }
    return /* @__PURE__ */ I("div", { ref: f, role: "group", "aria-label": p, className: N("flex gap-2", d), children: [
      h.map((S, R) => /* @__PURE__ */ l(
        "input",
        {
          ref: (E) => {
            b.current[R] = E;
          },
          type: c ? "password" : "text",
          inputMode: "text",
          autoComplete: R === 0 ? "one-time-code" : "off",
          maxLength: 1,
          disabled: a,
          "aria-invalid": i || void 0,
          value: S === " " ? "" : S,
          onChange: (E) => y(R, E.target.value),
          onKeyDown: (E) => x(R, E),
          onPaste: C,
          className: N(
            "h-12 w-11 rounded-lg border border-input bg-transparent text-center text-lg font-semibold shadow-sm",
            "transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
            "disabled:cursor-not-allowed disabled:opacity-50",
            i && "border-destructive focus-visible:ring-destructive"
          )
        },
        R
      )),
      u && /* @__PURE__ */ l("input", { type: "hidden", name: u, value: (m ? t : v).trim() })
    ] });
  }
);
Xm.displayName = "OTPInput";
var qm = s[" useInsertionEffect ".trim().toString()] || oe;
function ie({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  },
  caller: n
}) {
  const [o, a, i] = Zm({
    defaultProp: t,
    onChange: r
  }), c = e !== void 0, d = c ? e : o;
  {
    const p = s.useRef(e !== void 0);
    s.useEffect(() => {
      const f = p.current;
      f !== c && console.warn(
        `${n} is changing from ${f ? "controlled" : "uncontrolled"} to ${c ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), p.current = c;
    }, [c, n]);
  }
  const u = s.useCallback(
    (p) => {
      var f;
      if (c) {
        const m = Qm(p) ? p(e) : p;
        m !== e && ((f = i.current) == null || f.call(i, m));
      } else
        a(p);
    },
    [c, e, a, i]
  );
  return [d, u];
}
function Zm({
  defaultProp: e,
  onChange: t
}) {
  const [r, n] = s.useState(e), o = s.useRef(r), a = s.useRef(t);
  return qm(() => {
    a.current = t;
  }, [t]), s.useEffect(() => {
    var i;
    o.current !== r && ((i = a.current) == null || i.call(a, r), o.current = r);
  }, [r, o]), [r, n, a];
}
function Qm(e) {
  return typeof e == "function";
}
function Gt(e) {
  const t = s.useRef({ value: e, previous: e });
  return s.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Wt(e) {
  const [t, r] = s.useState(void 0);
  return oe(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, c;
        if ("borderBoxSize" in a) {
          const d = a.borderBoxSize, u = Array.isArray(d) ? d[0] : d;
          i = u.inlineSize, c = u.blockSize;
        } else
          i = e.offsetWidth, c = e.offsetHeight;
        r({ width: i, height: c });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
var Gr = "Checkbox", [Jm] = ae(Gr), [eh, So] = Jm(Gr);
function th(e) {
  const {
    __scopeCheckbox: t,
    checked: r,
    children: n,
    defaultChecked: o,
    disabled: a,
    form: i,
    name: c,
    onCheckedChange: d,
    required: u,
    value: p = "on",
    // @ts-expect-error
    internal_do_not_use_render: f
  } = e, [m, v] = ie({
    prop: r,
    defaultProp: o ?? !1,
    onChange: d,
    caller: Gr
  }), [g, h] = s.useState(null), [b, w] = s.useState(null), y = s.useRef(!1), x = g ? !!i || !!g.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), C = {
    checked: m,
    disabled: a,
    setChecked: v,
    control: g,
    setControl: h,
    name: c,
    form: i,
    value: p,
    hasConsumerStoppedPropagationRef: y,
    required: u,
    defaultChecked: He(o) ? !1 : o,
    isFormControl: x,
    bubbleInput: b,
    setBubbleInput: w
  };
  return /* @__PURE__ */ l(
    eh,
    {
      scope: t,
      ...C,
      children: rh(f) ? f(C) : n
    }
  );
}
var ni = "CheckboxTrigger", oi = s.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: r, ...n }, o) => {
    const {
      control: a,
      value: i,
      disabled: c,
      checked: d,
      required: u,
      setControl: p,
      setChecked: f,
      hasConsumerStoppedPropagationRef: m,
      isFormControl: v,
      bubbleInput: g
    } = So(ni, e), h = V(o, p), b = s.useRef(d);
    return s.useEffect(() => {
      const w = a == null ? void 0 : a.form;
      if (w) {
        const y = () => f(b.current);
        return w.addEventListener("reset", y), () => w.removeEventListener("reset", y);
      }
    }, [a, f]), /* @__PURE__ */ l(
      A.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": He(d) ? "mixed" : d,
        "aria-required": u,
        "data-state": li(d),
        "data-disabled": c ? "" : void 0,
        disabled: c,
        value: i,
        ...n,
        ref: h,
        onKeyDown: P(t, (w) => {
          w.key === "Enter" && w.preventDefault();
        }),
        onClick: P(r, (w) => {
          f((y) => He(y) ? !0 : !y), g && v && (m.current = w.isPropagationStopped(), m.current || w.stopPropagation());
        })
      }
    );
  }
);
oi.displayName = ni;
var Ro = s.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: r,
      name: n,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: c,
      value: d,
      onCheckedChange: u,
      form: p,
      ...f
    } = e;
    return /* @__PURE__ */ l(
      th,
      {
        __scopeCheckbox: r,
        checked: o,
        defaultChecked: a,
        disabled: c,
        required: i,
        onCheckedChange: u,
        name: n,
        form: p,
        value: d,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ I(ve, { children: [
          /* @__PURE__ */ l(
            oi,
            {
              ...f,
              ref: t,
              __scopeCheckbox: r
            }
          ),
          m && /* @__PURE__ */ l(
            ci,
            {
              __scopeCheckbox: r
            }
          )
        ] })
      }
    );
  }
);
Ro.displayName = Gr;
var ai = "CheckboxIndicator", si = s.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: r, forceMount: n, ...o } = e, a = So(ai, r);
    return /* @__PURE__ */ l(
      ne,
      {
        present: n || He(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ l(
          A.span,
          {
            "data-state": li(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
si.displayName = ai;
var ii = "CheckboxBubbleInput", ci = s.forwardRef(
  ({ __scopeCheckbox: e, ...t }, r) => {
    const {
      control: n,
      hasConsumerStoppedPropagationRef: o,
      checked: a,
      defaultChecked: i,
      required: c,
      disabled: d,
      name: u,
      value: p,
      form: f,
      bubbleInput: m,
      setBubbleInput: v
    } = So(ii, e), g = V(r, v), h = Gt(a), b = Wt(n);
    s.useEffect(() => {
      const y = m;
      if (!y) return;
      const x = window.HTMLInputElement.prototype, S = Object.getOwnPropertyDescriptor(
        x,
        "checked"
      ).set, R = !o.current;
      if (h !== a && S) {
        const E = new Event("click", { bubbles: R });
        y.indeterminate = He(a), S.call(y, He(a) ? !1 : a), y.dispatchEvent(E);
      }
    }, [m, h, a, o]);
    const w = s.useRef(He(a) ? !1 : a);
    return /* @__PURE__ */ l(
      A.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: i ?? w.current,
        required: c,
        disabled: d,
        name: u,
        value: p,
        form: f,
        ...t,
        tabIndex: -1,
        ref: g,
        style: {
          ...t.style,
          ...b,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
ci.displayName = ii;
function rh(e) {
  return typeof e == "function";
}
function He(e) {
  return e === "indeterminate";
}
function li(e) {
  return He(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const nh = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  Ro,
  {
    ref: r,
    className: N(
      "peer h-5 w-5 shrink-0 rounded-md border border-input shadow-sm transition-colors",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary",
      "data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground data-[state=indeterminate]:border-primary",
      e
    ),
    ...t,
    children: /* @__PURE__ */ l(si, { className: "flex items-center justify-center text-current", children: t.checked === "indeterminate" ? /* @__PURE__ */ l($m, { className: "size-3.5" }) : /* @__PURE__ */ l(nt, { className: "size-3.5" }) })
  }
));
nh.displayName = Ro.displayName;
function ot(e) {
  const t = e + "CollectionProvider", [r, n] = ae(t), [o, a] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (h) => {
    const { scope: b, children: w } = h, y = s.useRef(null), x = s.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l(o, { scope: b, itemMap: x, collectionRef: y, children: w });
  };
  i.displayName = t;
  const c = e + "CollectionSlot", d = /* @__PURE__ */ Ge(c), u = s.forwardRef(
    (h, b) => {
      const { scope: w, children: y } = h, x = a(c, w), C = V(b, x.collectionRef);
      return /* @__PURE__ */ l(d, { ref: C, children: y });
    }
  );
  u.displayName = c;
  const p = e + "CollectionItemSlot", f = "data-radix-collection-item", m = /* @__PURE__ */ Ge(p), v = s.forwardRef(
    (h, b) => {
      const { scope: w, children: y, ...x } = h, C = s.useRef(null), S = V(b, C), R = a(p, w);
      return s.useEffect(() => (R.itemMap.set(C, { ref: C, ...x }), () => void R.itemMap.delete(C))), /* @__PURE__ */ l(m, { [f]: "", ref: S, children: y });
    }
  );
  v.displayName = p;
  function g(h) {
    const b = a(e + "CollectionConsumer", h);
    return s.useCallback(() => {
      const y = b.collectionRef.current;
      if (!y) return [];
      const x = Array.from(y.querySelectorAll(`[${f}]`));
      return Array.from(b.itemMap.values()).sort(
        (R, E) => x.indexOf(R.ref.current) - x.indexOf(E.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: u, ItemSlot: v },
    g,
    n
  ];
}
var oh = s[" useId ".trim().toString()] || (() => {
}), ah = 0;
function ce(e) {
  const [t, r] = s.useState(oh());
  return oe(() => {
    r((n) => n ?? String(ah++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var Tn = !1;
function sh() {
  const [e, t] = s.useState(Tn);
  return s.useEffect(() => {
    Tn || (Tn = !0, t(!0));
  }, []), e;
}
var di = s[" useSyncExternalStore ".trim().toString()];
function ih() {
  return () => {
  };
}
function ch() {
  return di(
    ih,
    () => !0,
    () => !1
  );
}
var lh = typeof di == "function" ? ch : sh, _n = "rovingFocusGroup.onEntryFocus", dh = { bubbles: !1, cancelable: !0 }, Ut = "RovingFocusGroup", [Wn, ui, uh] = ot(Ut), [fh, je] = ae(
  Ut,
  [uh]
), [ph, mh] = fh(Ut), fi = s.forwardRef(
  (e, t) => /* @__PURE__ */ l(Wn.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l(Wn.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l(hh, { ...e, ref: t }) }) })
);
fi.displayName = Ut;
var hh = s.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: n,
    loop: o = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: c,
    onCurrentTabStopIdChange: d,
    onEntryFocus: u,
    preventScrollOnEntryFocus: p = !1,
    ...f
  } = e, m = s.useRef(null), v = V(t, m), g = Le(a), [h, b] = ie({
    prop: i,
    defaultProp: c ?? null,
    onChange: d,
    caller: Ut
  }), [w, y] = s.useState(!1), x = te(u), C = ui(r), S = s.useRef(!1), [R, E] = s.useState(0);
  return s.useEffect(() => {
    const T = m.current;
    if (T)
      return T.addEventListener(_n, x), () => T.removeEventListener(_n, x);
  }, [x]), /* @__PURE__ */ l(
    ph,
    {
      scope: r,
      orientation: n,
      dir: g,
      loop: o,
      currentTabStopId: h,
      onItemFocus: s.useCallback(
        (T) => b(T),
        [b]
      ),
      onItemShiftTab: s.useCallback(() => y(!0), []),
      onFocusableItemAdd: s.useCallback(
        () => E((T) => T + 1),
        []
      ),
      onFocusableItemRemove: s.useCallback(
        () => E((T) => T - 1),
        []
      ),
      children: /* @__PURE__ */ l(
        A.div,
        {
          tabIndex: w || R === 0 ? -1 : 0,
          "data-orientation": n,
          ...f,
          ref: v,
          style: { outline: "none", ...e.style },
          onMouseDown: P(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: P(e.onFocus, (T) => {
            const M = !S.current;
            if (T.target === T.currentTarget && M && !w) {
              const O = new CustomEvent(_n, dh);
              if (T.currentTarget.dispatchEvent(O), !O.defaultPrevented) {
                const D = C().filter(($) => $.focusable), L = D.find(($) => $.active), H = D.find(($) => $.id === h), B = [L, H, ...D].filter(
                  Boolean
                ).map(($) => $.ref.current);
                hi(B, p);
              }
            }
            S.current = !1;
          }),
          onBlur: P(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), pi = "RovingFocusGroupItem", mi = s.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: n = !0,
      active: o = !1,
      tabStopId: a,
      children: i,
      ...c
    } = e, d = ce(), u = a || d, p = mh(pi, r), f = p.currentTabStopId === u, m = ui(r), { onFocusableItemAdd: v, onFocusableItemRemove: g, currentTabStopId: h } = p, b = lh();
    return oe(() => {
      if (!(!b || !n))
        return v(), () => g();
    }, [b, n, v, g]), s.useEffect(() => {
      if (!(b || !n))
        return v(), () => g();
    }, [b, n, v, g]), /* @__PURE__ */ l(
      Wn.ItemSlot,
      {
        scope: r,
        id: u,
        focusable: n,
        active: o,
        children: /* @__PURE__ */ l(
          A.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": p.orientation,
            ...c,
            ref: t,
            onMouseDown: P(e.onMouseDown, (w) => {
              n ? p.onItemFocus(u) : w.preventDefault();
            }),
            onFocus: P(e.onFocus, () => p.onItemFocus(u)),
            onKeyDown: P(e.onKeyDown, (w) => {
              if (w.key === "Tab" && w.shiftKey) {
                p.onItemShiftTab();
                return;
              }
              if (w.target !== w.currentTarget) return;
              const y = bh(w, p.orientation, p.dir);
              if (y !== void 0) {
                if (w.metaKey || w.ctrlKey || w.altKey || w.shiftKey) return;
                w.preventDefault();
                let C = m().filter((S) => S.focusable).map((S) => S.ref.current);
                if (y === "last") C.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && C.reverse();
                  const S = C.indexOf(w.currentTarget);
                  C = p.loop ? wh(C, S + 1) : C.slice(S + 1);
                }
                setTimeout(() => hi(C));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: f, hasTabStop: h != null }) : i
          }
        )
      }
    );
  }
);
mi.displayName = pi;
var vh = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function gh(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function bh(e, t, r) {
  const n = gh(e.key, r);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return vh[n];
}
function hi(e, t = !1) {
  const r = document.activeElement;
  for (const n of e)
    if (n === r || (n.focus({ preventScroll: t }), document.activeElement !== r)) return;
}
function wh(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var Wr = fi, Ur = mi, No = "Radio", [yh, vi] = ae(No), [xh, Kr] = yh(No);
function gi(e) {
  const {
    __scopeRadio: t,
    checked: r = !1,
    children: n,
    disabled: o,
    form: a,
    name: i,
    onCheck: c,
    required: d,
    value: u = "on",
    // @ts-expect-error
    internal_do_not_use_render: p
  } = e, [f, m] = s.useState(null), [v, g] = s.useState(null), h = s.useRef(!1), b = f ? !!a || !!f.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), w = {
    checked: r,
    disabled: o,
    required: d,
    name: i,
    form: a,
    value: u,
    control: f,
    setControl: m,
    hasConsumerStoppedPropagationRef: h,
    isFormControl: b,
    bubbleInput: v,
    setBubbleInput: g,
    onCheck: () => c == null ? void 0 : c()
  };
  return /* @__PURE__ */ l(xh, { scope: t, ...w, children: Sh(p) ? p(w) : n });
}
var bi = "RadioTrigger", Eo = s.forwardRef(
  ({ __scopeRadio: e, onClick: t, ...r }, n) => {
    const {
      checked: o,
      disabled: a,
      value: i,
      setControl: c,
      onCheck: d,
      hasConsumerStoppedPropagationRef: u,
      isFormControl: p,
      bubbleInput: f
    } = Kr(bi, e), m = V(n, c);
    return /* @__PURE__ */ l(
      A.button,
      {
        type: "button",
        role: "radio",
        "aria-checked": o,
        "data-state": Ci(o),
        "data-disabled": a ? "" : void 0,
        disabled: a,
        value: i,
        ...r,
        ref: m,
        onClick: P(t, (v) => {
          o || d(), f && p && (u.current = v.isPropagationStopped(), u.current || v.stopPropagation());
        })
      }
    );
  }
);
Eo.displayName = bi;
var Ch = s.forwardRef(
  (e, t) => {
    const { __scopeRadio: r, name: n, checked: o, required: a, disabled: i, value: c, onCheck: d, form: u, ...p } = e;
    return /* @__PURE__ */ l(
      gi,
      {
        __scopeRadio: r,
        checked: o,
        disabled: i,
        required: a,
        onCheck: d,
        name: n,
        form: u,
        value: c,
        internal_do_not_use_render: ({ isFormControl: f }) => /* @__PURE__ */ I(ve, { children: [
          /* @__PURE__ */ l(
            Eo,
            {
              ...p,
              ref: t,
              __scopeRadio: r
            }
          ),
          f && /* @__PURE__ */ l(
            Po,
            {
              __scopeRadio: r
            }
          )
        ] })
      }
    );
  }
);
Ch.displayName = No;
var wi = "RadioIndicator", yi = s.forwardRef(
  (e, t) => {
    const { __scopeRadio: r, forceMount: n, ...o } = e, a = Kr(wi, r);
    return /* @__PURE__ */ l(ne, { present: n || a.checked, children: /* @__PURE__ */ l(
      A.span,
      {
        "data-state": Ci(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
yi.displayName = wi;
var xi = "RadioBubbleInput", Po = s.forwardRef(
  ({ __scopeRadio: e, ...t }, r) => {
    const {
      control: n,
      checked: o,
      required: a,
      disabled: i,
      name: c,
      value: d,
      form: u,
      bubbleInput: p,
      setBubbleInput: f,
      hasConsumerStoppedPropagationRef: m
    } = Kr(xi, e), v = V(r, f), g = Gt(o), h = Wt(n);
    s.useEffect(() => {
      const w = p;
      if (!w) return;
      const y = window.HTMLInputElement.prototype, C = Object.getOwnPropertyDescriptor(
        y,
        "checked"
      ).set, S = !m.current;
      if (g !== o && C) {
        const R = new Event("click", { bubbles: S });
        C.call(w, o), w.dispatchEvent(R);
      }
    }, [p, g, o, m]);
    const b = s.useRef(o);
    return /* @__PURE__ */ l(
      A.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: b.current,
        required: a,
        disabled: i,
        name: c,
        value: d,
        form: u,
        ...t,
        tabIndex: -1,
        ref: v,
        style: {
          ...t.style,
          ...h,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
Po.displayName = xi;
function Sh(e) {
  return typeof e == "function";
}
function Ci(e) {
  return e ? "checked" : "unchecked";
}
var Rh = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], jr = "RadioGroup", [Nh] = ae(jr, [
  je,
  vi
]), Si = je(), Yr = vi(), [Eh, Ph] = Nh(jr), To = s.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: r,
      name: n,
      form: o,
      defaultValue: a,
      value: i,
      required: c = !1,
      disabled: d = !1,
      orientation: u,
      dir: p,
      loop: f = !0,
      onValueChange: m,
      ...v
    } = e, g = Si(r), h = Le(p), [b, w] = ie({
      prop: i,
      defaultProp: a ?? null,
      onChange: m,
      caller: jr
    }), [y, x] = s.useState(null), C = V(t, x), S = s.useRef(b);
    return s.useEffect(() => {
      const R = o ? y == null ? void 0 : y.ownerDocument.getElementById(o) : y == null ? void 0 : y.closest("form");
      if (R instanceof HTMLFormElement) {
        const E = () => w(S.current);
        return R.addEventListener("reset", E), () => R.removeEventListener("reset", E);
      }
    }, [y, o, w]), /* @__PURE__ */ l(
      Eh,
      {
        scope: r,
        name: n,
        form: o,
        required: c,
        disabled: d,
        value: b,
        onValueChange: w,
        children: /* @__PURE__ */ l(
          Wr,
          {
            asChild: !0,
            ...g,
            orientation: u,
            dir: h,
            loop: f,
            children: /* @__PURE__ */ l(
              A.div,
              {
                role: "radiogroup",
                "aria-required": c,
                "aria-orientation": u,
                "data-disabled": d ? "" : void 0,
                dir: h,
                ...v,
                ref: C
              }
            )
          }
        )
      }
    );
  }
);
To.displayName = jr;
var Th = "RadioGroupItem", _h = "RadioGroupItemProvider", Ri = "RadioGroupItemTrigger", Mh = "RadioGroupItemBubbleInput";
function Ah(e) {
  const {
    __scopeRadioGroup: t,
    value: r,
    disabled: n,
    children: o,
    // @ts-expect-error
    internal_do_not_use_render: a
  } = e, i = Ph(_h, t), c = Yr(t), d = i.disabled || n;
  return /* @__PURE__ */ l(
    gi,
    {
      ...c,
      checked: i.value === r,
      disabled: d,
      required: i.required,
      name: i.name,
      form: i.form,
      value: r,
      onCheck: () => i.onValueChange(r),
      internal_do_not_use_render: a,
      children: o
    }
  );
}
var Ni = s.forwardRef((e, t) => {
  const { __scopeRadioGroup: r, ...n } = e, o = Si(r), a = Yr(r), { checked: i, disabled: c } = Kr(Ri, a.__scopeRadio), d = s.useRef(null), u = V(t, d), p = s.useRef(!1);
  return s.useEffect(() => {
    const f = (v) => {
      Rh.includes(v.key) && (p.current = !0);
    }, m = () => p.current = !1;
    return document.addEventListener("keydown", f), document.addEventListener("keyup", m), () => {
      document.removeEventListener("keydown", f), document.removeEventListener("keyup", m);
    };
  }, []), /* @__PURE__ */ l(
    Ur,
    {
      asChild: !0,
      ...o,
      focusable: !c,
      active: i,
      children: /* @__PURE__ */ l(
        Eo,
        {
          ...a,
          ...n,
          ref: u,
          onKeyDown: P(n.onKeyDown, (f) => {
            f.key === "Enter" && f.preventDefault();
          }),
          onFocus: P(n.onFocus, () => {
            var f;
            p.current && ((f = d.current) == null || f.click());
          })
        }
      )
    }
  );
});
Ni.displayName = Ri;
var _o = s.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: r, value: n, disabled: o, ...a } = e;
    return /* @__PURE__ */ l(
      Ah,
      {
        __scopeRadioGroup: r,
        value: n,
        disabled: o,
        internal_do_not_use_render: ({ isFormControl: i }) => /* @__PURE__ */ I(ve, { children: [
          /* @__PURE__ */ l(
            Ni,
            {
              ...a,
              ref: t,
              __scopeRadioGroup: r
            }
          ),
          i && /* @__PURE__ */ l(
            Ei,
            {
              __scopeRadioGroup: r
            }
          )
        ] })
      }
    );
  }
);
_o.displayName = Th;
var Ei = s.forwardRef((e, t) => {
  const { __scopeRadioGroup: r, ...n } = e, o = Yr(r);
  return /* @__PURE__ */ l(Po, { ...o, ...n, ref: t });
});
Ei.displayName = Mh;
var Ih = "RadioGroupIndicator", Pi = s.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: r, ...n } = e, o = Yr(r);
    return /* @__PURE__ */ l(yi, { ...o, ...n, ref: t });
  }
);
Pi.displayName = Ih;
const Dh = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(To, { ref: r, className: N("grid gap-2", e), ...t }));
Dh.displayName = To.displayName;
const kh = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  _o,
  {
    ref: r,
    className: N(
      "aspect-square h-5 w-5 rounded-full border border-input shadow-sm transition-colors",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:border-primary",
      e
    ),
    ...t,
    children: /* @__PURE__ */ l(Pi, { className: "flex items-center justify-center", children: /* @__PURE__ */ l("span", { className: "h-2.5 w-2.5 rounded-full bg-primary" }) })
  }
));
kh.displayName = _o.displayName;
var Xr = "Switch", [Oh] = ae(Xr), [Lh, Mo] = Oh(Xr);
function $h(e) {
  const {
    __scopeSwitch: t,
    checked: r,
    children: n,
    defaultChecked: o,
    disabled: a,
    form: i,
    name: c,
    onCheckedChange: d,
    required: u,
    value: p = "on",
    // @ts-expect-error
    internal_do_not_use_render: f
  } = e, [m, v] = ie({
    prop: r,
    defaultProp: o ?? !1,
    onChange: d,
    caller: Xr
  }), [g, h] = s.useState(null), [b, w] = s.useState(null), y = s.useRef(!1), x = g ? !!i || !!g.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), C = {
    checked: m,
    setChecked: v,
    disabled: a,
    control: g,
    setControl: h,
    name: c,
    form: i,
    value: p,
    hasConsumerStoppedPropagationRef: y,
    required: u,
    defaultChecked: o,
    isFormControl: x,
    bubbleInput: b,
    setBubbleInput: w
  };
  return /* @__PURE__ */ l(Lh, { scope: t, ...C, children: Fh(f) ? f(C) : n });
}
var Ti = "SwitchTrigger", _i = s.forwardRef(
  ({ __scopeSwitch: e, onClick: t, ...r }, n) => {
    const {
      control: o,
      form: a,
      value: i,
      disabled: c,
      checked: d,
      required: u,
      setControl: p,
      setChecked: f,
      hasConsumerStoppedPropagationRef: m,
      isFormControl: v,
      bubbleInput: g
    } = Mo(Ti, e), h = V(n, p), b = s.useRef(d);
    return s.useEffect(() => {
      const w = a ? o == null ? void 0 : o.ownerDocument.getElementById(a) : o == null ? void 0 : o.form;
      if (w instanceof HTMLFormElement) {
        const y = () => f(b.current);
        return w.addEventListener("reset", y), () => w.removeEventListener("reset", y);
      }
    }, [o, a, f]), /* @__PURE__ */ l(
      A.button,
      {
        type: "button",
        role: "switch",
        "aria-checked": d,
        "aria-required": u,
        "data-state": ki(d),
        "data-disabled": c ? "" : void 0,
        disabled: c,
        value: i,
        ...r,
        ref: h,
        onClick: P(t, (w) => {
          f((y) => !y), g && v && (m.current = w.isPropagationStopped(), m.current || w.stopPropagation());
        })
      }
    );
  }
);
_i.displayName = Ti;
var Ao = s.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: r,
      name: n,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: c,
      value: d,
      onCheckedChange: u,
      form: p,
      ...f
    } = e;
    return /* @__PURE__ */ l(
      $h,
      {
        __scopeSwitch: r,
        checked: o,
        defaultChecked: a,
        disabled: c,
        required: i,
        onCheckedChange: u,
        name: n,
        form: p,
        value: d,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ I(ve, { children: [
          /* @__PURE__ */ l(
            _i,
            {
              ...f,
              ref: t,
              __scopeSwitch: r
            }
          ),
          m && /* @__PURE__ */ l(
            Di,
            {
              __scopeSwitch: r
            }
          )
        ] })
      }
    );
  }
);
Ao.displayName = Xr;
var Mi = "SwitchThumb", Ai = s.forwardRef(
  (e, t) => {
    const { __scopeSwitch: r, ...n } = e, o = Mo(Mi, r);
    return /* @__PURE__ */ l(
      A.span,
      {
        "data-state": ki(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    );
  }
);
Ai.displayName = Mi;
var Ii = "SwitchBubbleInput", Di = s.forwardRef(
  ({ __scopeSwitch: e, ...t }, r) => {
    const {
      control: n,
      hasConsumerStoppedPropagationRef: o,
      checked: a,
      defaultChecked: i,
      required: c,
      disabled: d,
      name: u,
      value: p,
      form: f,
      bubbleInput: m,
      setBubbleInput: v
    } = Mo(Ii, e), g = V(r, v), h = Gt(a), b = Wt(n);
    s.useEffect(() => {
      const y = m;
      if (!y) return;
      const x = window.HTMLInputElement.prototype, S = Object.getOwnPropertyDescriptor(
        x,
        "checked"
      ).set, R = !o.current;
      if (h !== a && S) {
        const E = new Event("click", { bubbles: R });
        S.call(y, a), y.dispatchEvent(E);
      }
    }, [m, h, a, o]);
    const w = s.useRef(a);
    return /* @__PURE__ */ l(
      A.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: i ?? w.current,
        required: c,
        disabled: d,
        name: u,
        value: p,
        form: f,
        ...t,
        tabIndex: -1,
        ref: g,
        style: {
          ...t.style,
          ...b,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
Di.displayName = Ii;
function Fh(e) {
  return typeof e == "function";
}
function ki(e) {
  return e ? "checked" : "unchecked";
}
const Vh = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  Ao,
  {
    ref: r,
    className: N(
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent",
      "shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-primary data-[state=unchecked]:bg-muted",
      e
    ),
    ...t,
    children: /* @__PURE__ */ l(
      Ai,
      {
        className: N(
          "pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-transform",
          "data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
Vh.displayName = Ao.displayName;
var Bh = "Label", Oi = s.forwardRef((e, t) => /* @__PURE__ */ l(
  A.label,
  {
    ...e,
    ref: t,
    onMouseDown: (r) => {
      var o;
      r.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
    }
  }
));
Oi.displayName = Bh;
var Li = Oi;
const zh = s.forwardRef(({ className: e, required: t, children: r, ...n }, o) => /* @__PURE__ */ I(
  Li,
  {
    ref: o,
    className: N(
      "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      e
    ),
    ...n,
    children: [
      r,
      t && /* @__PURE__ */ l("span", { className: "ml-0.5 text-destructive", children: "*" })
    ]
  }
));
zh.displayName = Li.displayName;
var Hh = "DismissableLayer", Un = "dismissableLayer.update", Gh = "dismissableLayer.pointerDownOutside", Wh = "dismissableLayer.focusOutside", Ya, Io = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set(),
  // Outside elements that belong to a layer's own dismiss affordance (eg, a
  // dialog overlay). Pressing them should dismiss the layer regardless of
  // whether or not they stop propagation.
  //
  // See https://github.com/radix-ui/primitives/issues/3346
  dismissableSurfaces: /* @__PURE__ */ new Set()
}), Ye = s.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      deferPointerDownOutside: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      onFocusOutside: i,
      onInteractOutside: c,
      onDismiss: d,
      ...u
    } = e, p = s.useContext(Io), [f, m] = s.useState(null), v = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, g] = s.useState({}), h = V(t, m), b = Array.from(p.layers), [w] = [
      ...p.layersWithOutsidePointerEventsDisabled
    ].slice(-1), y = w ? b.indexOf(w) : -1, x = f ? b.indexOf(f) : -1, C = p.layersWithOutsidePointerEventsDisabled.size > 0, S = x >= y, R = s.useRef(!1), E = Yh(
      (D) => {
        a == null || a(D), c == null || c(D), D.defaultPrevented || d == null || d();
      },
      {
        ownerDocument: v,
        deferPointerDownOutside: n,
        isDeferredPointerDownOutsideRef: R,
        dismissableSurfaces: p.dismissableSurfaces,
        shouldHandlePointerDownOutside: s.useCallback(
          (D) => {
            if (!(D instanceof Node))
              return !1;
            const L = [...p.branches].some(
              (H) => H.contains(D)
            );
            return S && !L;
          },
          [p.branches, S]
        )
      }
    ), T = Xh((D) => {
      if (n && R.current)
        return;
      const L = D.target;
      [...p.branches].some((k) => k.contains(L)) || (i == null || i(D), c == null || c(D), D.defaultPrevented || d == null || d());
    }, v), M = f ? x === b.length - 1 : !1, O = te((D) => {
      D.key === "Escape" && (o == null || o(D), !D.defaultPrevented && d && (D.preventDefault(), d()));
    });
    return s.useEffect(() => {
      if (M)
        return v.addEventListener("keydown", O, { capture: !0 }), () => v.removeEventListener("keydown", O, { capture: !0 });
    }, [v, M, O]), s.useEffect(() => {
      if (f)
        return r && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (Ya = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(f)), p.layers.add(f), Xa(), () => {
          r && (p.layersWithOutsidePointerEventsDisabled.delete(f), p.layersWithOutsidePointerEventsDisabled.size === 0 && (v.body.style.pointerEvents = Ya));
        };
    }, [f, v, r, p]), s.useEffect(() => () => {
      f && (p.layers.delete(f), p.layersWithOutsidePointerEventsDisabled.delete(f), Xa());
    }, [f, p]), s.useEffect(() => {
      const D = () => g({});
      return document.addEventListener(Un, D), () => document.removeEventListener(Un, D);
    }, []), /* @__PURE__ */ l(
      A.div,
      {
        ...u,
        ref: h,
        style: {
          pointerEvents: C ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: P(e.onFocusCapture, T.onFocusCapture),
        onBlurCapture: P(e.onBlurCapture, T.onBlurCapture),
        onPointerDownCapture: P(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
Ye.displayName = Hh;
var Uh = "DismissableLayerBranch", $i = s.forwardRef((e, t) => {
  const r = s.useContext(Io), n = s.useRef(null), o = V(t, n);
  return s.useEffect(() => {
    const a = n.current;
    if (a)
      return r.branches.add(a), () => {
        r.branches.delete(a);
      };
  }, [r.branches]), /* @__PURE__ */ l(A.div, { ...e, ref: o });
});
$i.displayName = Uh;
function Kh() {
  const e = s.useContext(Io), [t, r] = s.useState(null);
  return s.useEffect(() => {
    if (t)
      return e.dismissableSurfaces.add(t), () => {
        e.dismissableSurfaces.delete(t);
      };
  }, [t, e.dismissableSurfaces]), r;
}
var jh = () => !0;
function Yh(e, t) {
  const {
    ownerDocument: r = globalThis == null ? void 0 : globalThis.document,
    deferPointerDownOutside: n = !1,
    isDeferredPointerDownOutsideRef: o,
    dismissableSurfaces: a,
    shouldHandlePointerDownOutside: i = jh
  } = t, c = te(e), d = s.useRef(!1), u = s.useRef(!1), p = s.useRef(/* @__PURE__ */ new Map()), f = s.useRef(() => {
  });
  return s.useEffect(() => {
    function m() {
      u.current = !1, o.current = !1, p.current.clear();
    }
    function v() {
      return Array.from(p.current.values()).some(Boolean);
    }
    function g(x) {
      if (!u.current)
        return;
      const C = x.target;
      C instanceof Node && [...a].some((R) => R.contains(C)) || p.current.set(x.type, !0), x.type === "click" && window.setTimeout(() => {
        u.current && f.current();
      }, 0);
    }
    function h(x) {
      u.current && p.current.set(x.type, !1);
    }
    const b = (x) => {
      if (x.target && !d.current) {
        let C = function() {
          r.removeEventListener("click", f.current);
          const R = v();
          m(), R || Fi(
            Gh,
            c,
            S,
            { discrete: !0 }
          );
        };
        if (!i(x.target)) {
          r.removeEventListener("click", f.current), m(), d.current = !1;
          return;
        }
        const S = { originalEvent: x };
        u.current = !0, o.current = n && x.button === 0, p.current.clear(), !n || x.button !== 0 ? C() : (r.removeEventListener("click", f.current), f.current = C, r.addEventListener("click", f.current, { once: !0 }));
      } else
        r.removeEventListener("click", f.current), m();
      d.current = !1;
    }, w = [
      "pointerup",
      "mousedown",
      "mouseup",
      "touchstart",
      "touchend",
      "click"
    ];
    for (const x of w)
      r.addEventListener(x, g, !0), r.addEventListener(x, h);
    const y = window.setTimeout(() => {
      r.addEventListener("pointerdown", b);
    }, 0);
    return () => {
      window.clearTimeout(y), r.removeEventListener("pointerdown", b), r.removeEventListener("click", f.current);
      for (const x of w)
        r.removeEventListener(x, g, !0), r.removeEventListener(x, h);
    };
  }, [
    r,
    c,
    n,
    o,
    a,
    i
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => d.current = !0
  };
}
function Xh(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = te(e), n = s.useRef(!1);
  return s.useEffect(() => {
    const o = (a) => {
      a.target && !n.current && Fi(Wh, r, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Xa() {
  const e = new CustomEvent(Un);
  document.dispatchEvent(e);
}
function Fi(e, t, r, { discrete: n }) {
  const o = r.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? bo(o, a) : o.dispatchEvent(a);
}
var qh = Ye, Zh = $i, ur = 0, Ne = null;
function qr() {
  s.useEffect(() => {
    Ne || (Ne = { start: qa(), end: qa() });
    const { start: e, end: t } = Ne;
    return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), ur++, () => {
      ur === 1 && (Ne == null || Ne.start.remove(), Ne == null || Ne.end.remove(), Ne = null), ur = Math.max(0, ur - 1);
    };
  }, []);
}
function qa() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Mn = "focusScope.autoFocusOnMount", An = "focusScope.autoFocusOnUnmount", Za = { bubbles: !1, cancelable: !0 }, Qh = "FocusScope", Kt = s.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...i
  } = e, [c, d] = s.useState(null), u = te(o), p = te(a), f = s.useRef(null), m = V(t, d), v = s.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  s.useEffect(() => {
    if (n) {
      let h = function(x) {
        if (v.paused || !c) return;
        const C = x.target;
        c.contains(C) ? f.current = C : Be(f.current, { select: !0 });
      }, b = function(x) {
        if (v.paused || !c) return;
        const C = x.relatedTarget;
        C !== null && (c.contains(C) || Be(f.current, { select: !0 }));
      }, w = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && Be(c);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", b);
      const y = new MutationObserver(w);
      return c && y.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", b), y.disconnect();
      };
    }
  }, [n, c, v.paused]), s.useEffect(() => {
    if (c) {
      Ja.add(v);
      const h = document.activeElement;
      if (!c.contains(h)) {
        const w = new CustomEvent(Mn, Za);
        c.addEventListener(Mn, u), c.dispatchEvent(w), w.defaultPrevented || (Jh(ov(Vi(c)), { select: !0 }), document.activeElement === h && Be(c));
      }
      return () => {
        c.removeEventListener(Mn, u), setTimeout(() => {
          const w = new CustomEvent(An, Za);
          c.addEventListener(An, p), c.dispatchEvent(w), w.defaultPrevented || Be(h ?? document.body, { select: !0 }), c.removeEventListener(An, p), Ja.remove(v);
        }, 0);
      };
    }
  }, [c, u, p, v]);
  const g = s.useCallback(
    (h) => {
      if (!r && !n || v.paused) return;
      const b = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, w = document.activeElement;
      if (b && w) {
        const y = h.currentTarget, [x, C] = ev(y);
        x && C ? !h.shiftKey && w === C ? (h.preventDefault(), r && Be(x, { select: !0 })) : h.shiftKey && w === x && (h.preventDefault(), r && Be(C, { select: !0 })) : w === y && h.preventDefault();
      }
    },
    [r, n, v.paused]
  );
  return /* @__PURE__ */ l(A.div, { tabIndex: -1, ...i, ref: m, onKeyDown: g });
});
Kt.displayName = Qh;
function Jh(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (Be(n, { select: t }), document.activeElement !== r) return;
}
function ev(e) {
  const t = Vi(e), r = Qa(t, e), n = Qa(t.reverse(), e);
  return [r, n];
}
function Vi(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Qa(e, t) {
  const r = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
  for (const n of e)
    if (!(r ? !n.checkVisibility({ checkVisibilityCSS: !0 }) : tv(n, { upTo: t })))
      return n;
}
function tv(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function rv(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Be(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && rv(e) && t && e.select();
  }
}
var Ja = nv();
function nv() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = es(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = es(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function es(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function ov(e) {
  return e.filter((t) => t.tagName !== "A");
}
const av = ["top", "right", "bottom", "left"], We = Math.min, fe = Math.max, Tr = Math.round, fr = Math.floor, Te = (e) => ({
  x: e,
  y: e
}), sv = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Kn(e, t, r) {
  return fe(e, We(t, r));
}
function ke(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Oe(e) {
  return e.split("-")[0];
}
function Ct(e) {
  return e.split("-")[1];
}
function Do(e) {
  return e === "x" ? "y" : "x";
}
function ko(e) {
  return e === "y" ? "height" : "width";
}
function Pe(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Oo(e) {
  return Do(Pe(e));
}
function iv(e, t, r) {
  r === void 0 && (r = !1);
  const n = Ct(e), o = Oo(e), a = ko(o);
  let i = o === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = _r(i)), [i, _r(i)];
}
function cv(e) {
  const t = _r(e);
  return [jn(e), t, jn(t)];
}
function jn(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const ts = ["left", "right"], rs = ["right", "left"], lv = ["top", "bottom"], dv = ["bottom", "top"];
function uv(e, t, r) {
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? rs : ts : t ? ts : rs;
    case "left":
    case "right":
      return t ? lv : dv;
    default:
      return [];
  }
}
function fv(e, t, r, n) {
  const o = Ct(e);
  let a = uv(Oe(e), r === "start", n);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map(jn)))), a;
}
function _r(e) {
  const t = Oe(e);
  return sv[t] + e.slice(t.length);
}
function pv(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Bi(e) {
  return typeof e != "number" ? pv(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Mr(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: r,
    left: t,
    right: t + n,
    bottom: r + o,
    x: t,
    y: r
  };
}
function ns(e, t, r) {
  let {
    reference: n,
    floating: o
  } = e;
  const a = Pe(t), i = Oo(t), c = ko(i), d = Oe(t), u = a === "y", p = n.x + n.width / 2 - o.width / 2, f = n.y + n.height / 2 - o.height / 2, m = n[c] / 2 - o[c] / 2;
  let v;
  switch (d) {
    case "top":
      v = {
        x: p,
        y: n.y - o.height
      };
      break;
    case "bottom":
      v = {
        x: p,
        y: n.y + n.height
      };
      break;
    case "right":
      v = {
        x: n.x + n.width,
        y: f
      };
      break;
    case "left":
      v = {
        x: n.x - o.width,
        y: f
      };
      break;
    default:
      v = {
        x: n.x,
        y: n.y
      };
  }
  switch (Ct(t)) {
    case "start":
      v[i] -= m * (r && u ? -1 : 1);
      break;
    case "end":
      v[i] += m * (r && u ? -1 : 1);
      break;
  }
  return v;
}
async function mv(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: a,
    rects: i,
    elements: c,
    strategy: d
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: f = "floating",
    altBoundary: m = !1,
    padding: v = 0
  } = ke(t, e), g = Bi(v), b = c[m ? f === "floating" ? "reference" : "floating" : f], w = Mr(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(b))) == null || r ? b : b.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(c.floating)),
    boundary: u,
    rootBoundary: p,
    strategy: d
  })), y = f === "floating" ? {
    x: n,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c.floating)), C = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Mr(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: y,
    offsetParent: x,
    strategy: d
  }) : y);
  return {
    top: (w.top - S.top + g.top) / C.y,
    bottom: (S.bottom - w.bottom + g.bottom) / C.y,
    left: (w.left - S.left + g.left) / C.x,
    right: (S.right - w.right + g.right) / C.x
  };
}
const hv = 50, vv = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = r, c = i.detectOverflow ? i : {
    ...i,
    detectOverflow: mv
  }, d = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let u = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: p,
    y: f
  } = ns(u, n, d), m = n, v = 0;
  const g = {};
  for (let h = 0; h < a.length; h++) {
    const b = a[h];
    if (!b)
      continue;
    const {
      name: w,
      fn: y
    } = b, {
      x,
      y: C,
      data: S,
      reset: R
    } = await y({
      x: p,
      y: f,
      initialPlacement: n,
      placement: m,
      strategy: o,
      middlewareData: g,
      rects: u,
      platform: c,
      elements: {
        reference: e,
        floating: t
      }
    });
    p = x ?? p, f = C ?? f, g[w] = {
      ...g[w],
      ...S
    }, R && v < hv && (v++, typeof R == "object" && (R.placement && (m = R.placement), R.rects && (u = R.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : R.rects), {
      x: p,
      y: f
    } = ns(u, m, d)), h = -1);
  }
  return {
    x: p,
    y: f,
    placement: m,
    strategy: o,
    middlewareData: g
  };
}, gv = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: o,
      rects: a,
      platform: i,
      elements: c,
      middlewareData: d
    } = t, {
      element: u,
      padding: p = 0
    } = ke(e, t) || {};
    if (u == null)
      return {};
    const f = Bi(p), m = {
      x: r,
      y: n
    }, v = Oo(o), g = ko(v), h = await i.getDimensions(u), b = v === "y", w = b ? "top" : "left", y = b ? "bottom" : "right", x = b ? "clientHeight" : "clientWidth", C = a.reference[g] + a.reference[v] - m[v] - a.floating[g], S = m[v] - a.reference[v], R = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let E = R ? R[x] : 0;
    (!E || !await (i.isElement == null ? void 0 : i.isElement(R))) && (E = c.floating[x] || a.floating[g]);
    const T = C / 2 - S / 2, M = E / 2 - h[g] / 2 - 1, O = We(f[w], M), D = We(f[y], M), L = O, H = E - h[g] - D, k = E / 2 - h[g] / 2 + T, B = Kn(L, k, H), $ = !d.arrow && Ct(o) != null && k !== B && a.reference[g] / 2 - (k < L ? O : D) - h[g] / 2 < 0, z = $ ? k < L ? k - L : k - H : 0;
    return {
      [v]: m[v] + z,
      data: {
        [v]: B,
        centerOffset: k - B - z,
        ...$ && {
          alignmentOffset: z
        }
      },
      reset: $
    };
  }
}), bv = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: c,
        platform: d,
        elements: u
      } = t, {
        mainAxis: p = !0,
        crossAxis: f = !0,
        fallbackPlacements: m,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: h = !0,
        ...b
      } = ke(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const w = Oe(o), y = Pe(c), x = Oe(c) === c, C = await (d.isRTL == null ? void 0 : d.isRTL(u.floating)), S = m || (x || !h ? [_r(c)] : cv(c)), R = g !== "none";
      !m && R && S.push(...fv(c, h, g, C));
      const E = [c, ...S], T = await d.detectOverflow(t, b), M = [];
      let O = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (p && M.push(T[w]), f) {
        const k = iv(o, i, C);
        M.push(T[k[0]], T[k[1]]);
      }
      if (O = [...O, {
        placement: o,
        overflows: M
      }], !M.every((k) => k <= 0)) {
        var D, L;
        const k = (((D = a.flip) == null ? void 0 : D.index) || 0) + 1, B = E[k];
        if (B && (!(f === "alignment" ? y !== Pe(B) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        O.every((F) => Pe(F.placement) === y ? F.overflows[0] > 0 : !0)))
          return {
            data: {
              index: k,
              overflows: O
            },
            reset: {
              placement: B
            }
          };
        let $ = (L = O.filter((z) => z.overflows[0] <= 0).sort((z, F) => z.overflows[1] - F.overflows[1])[0]) == null ? void 0 : L.placement;
        if (!$)
          switch (v) {
            case "bestFit": {
              var H;
              const z = (H = O.filter((F) => {
                if (R) {
                  const _ = Pe(F.placement);
                  return _ === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  _ === "y";
                }
                return !0;
              }).map((F) => [F.placement, F.overflows.filter((_) => _ > 0).reduce((_, U) => _ + U, 0)]).sort((F, _) => F[1] - _[1])[0]) == null ? void 0 : H[0];
              z && ($ = z);
              break;
            }
            case "initialPlacement":
              $ = c;
              break;
          }
        if (o !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function os(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function as(e) {
  return av.some((t) => e[t] >= 0);
}
const wv = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r,
        platform: n
      } = t, {
        strategy: o = "referenceHidden",
        ...a
      } = ke(e, t);
      switch (o) {
        case "referenceHidden": {
          const i = await n.detectOverflow(t, {
            ...a,
            elementContext: "reference"
          }), c = os(i, r.reference);
          return {
            data: {
              referenceHiddenOffsets: c,
              referenceHidden: as(c)
            }
          };
        }
        case "escaped": {
          const i = await n.detectOverflow(t, {
            ...a,
            altBoundary: !0
          }), c = os(i, r.floating);
          return {
            data: {
              escapedOffsets: c,
              escaped: as(c)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, zi = /* @__PURE__ */ new Set(["left", "top"]);
async function yv(e, t) {
  const {
    placement: r,
    platform: n,
    elements: o
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), i = Oe(r), c = Ct(r), d = Pe(r) === "y", u = zi.has(i) ? -1 : 1, p = a && d ? -1 : 1, f = ke(t, e);
  let {
    mainAxis: m,
    crossAxis: v,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return c && typeof g == "number" && (v = c === "end" ? g * -1 : g), d ? {
    x: v * p,
    y: m * u
  } : {
    x: m * u,
    y: v * p
  };
}
const xv = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: c
      } = t, d = await yv(t, e);
      return i === ((r = c.offset) == null ? void 0 : r.placement) && (n = c.arrow) != null && n.alignmentOffset ? {} : {
        x: o + d.x,
        y: a + d.y,
        data: {
          ...d,
          placement: i
        }
      };
    }
  };
}, Cv = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: o,
        platform: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: c = !1,
        limiter: d = {
          fn: (w) => {
            let {
              x: y,
              y: x
            } = w;
            return {
              x: y,
              y: x
            };
          }
        },
        ...u
      } = ke(e, t), p = {
        x: r,
        y: n
      }, f = await a.detectOverflow(t, u), m = Pe(Oe(o)), v = Do(m);
      let g = p[v], h = p[m];
      if (i) {
        const w = v === "y" ? "top" : "left", y = v === "y" ? "bottom" : "right", x = g + f[w], C = g - f[y];
        g = Kn(x, g, C);
      }
      if (c) {
        const w = m === "y" ? "top" : "left", y = m === "y" ? "bottom" : "right", x = h + f[w], C = h - f[y];
        h = Kn(x, h, C);
      }
      const b = d.fn({
        ...t,
        [v]: g,
        [m]: h
      });
      return {
        ...b,
        data: {
          x: b.x - r,
          y: b.y - n,
          enabled: {
            [v]: i,
            [m]: c
          }
        }
      };
    }
  };
}, Sv = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: o,
        rects: a,
        middlewareData: i
      } = t, {
        offset: c = 0,
        mainAxis: d = !0,
        crossAxis: u = !0
      } = ke(e, t), p = {
        x: r,
        y: n
      }, f = Pe(o), m = Do(f);
      let v = p[m], g = p[f];
      const h = ke(c, t), b = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (d) {
        const x = m === "y" ? "height" : "width", C = a.reference[m] - a.floating[x] + b.mainAxis, S = a.reference[m] + a.reference[x] - b.mainAxis;
        v < C ? v = C : v > S && (v = S);
      }
      if (u) {
        var w, y;
        const x = m === "y" ? "width" : "height", C = zi.has(Oe(o)), S = a.reference[f] - a.floating[x] + (C && ((w = i.offset) == null ? void 0 : w[f]) || 0) + (C ? 0 : b.crossAxis), R = a.reference[f] + a.reference[x] + (C ? 0 : ((y = i.offset) == null ? void 0 : y[f]) || 0) - (C ? b.crossAxis : 0);
        g < S ? g = S : g > R && (g = R);
      }
      return {
        [m]: v,
        [f]: g
      };
    }
  };
}, Rv = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        rects: a,
        platform: i,
        elements: c
      } = t, {
        apply: d = () => {
        },
        ...u
      } = ke(e, t), p = await i.detectOverflow(t, u), f = Oe(o), m = Ct(o), v = Pe(o) === "y", {
        width: g,
        height: h
      } = a.floating;
      let b, w;
      f === "top" || f === "bottom" ? (b = f, w = m === (await (i.isRTL == null ? void 0 : i.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (w = f, b = m === "end" ? "top" : "bottom");
      const y = h - p.top - p.bottom, x = g - p.left - p.right, C = We(h - p[b], y), S = We(g - p[w], x), R = !t.middlewareData.shift;
      let E = C, T = S;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (T = x), (n = t.middlewareData.shift) != null && n.enabled.y && (E = y), R && !m) {
        const O = fe(p.left, 0), D = fe(p.right, 0), L = fe(p.top, 0), H = fe(p.bottom, 0);
        v ? T = g - 2 * (O !== 0 || D !== 0 ? O + D : fe(p.left, p.right)) : E = h - 2 * (L !== 0 || H !== 0 ? L + H : fe(p.top, p.bottom));
      }
      await d({
        ...t,
        availableWidth: T,
        availableHeight: E
      });
      const M = await i.getDimensions(c.floating);
      return g !== M.width || h !== M.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Zr() {
  return typeof window < "u";
}
function St(e) {
  return Hi(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function pe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Me(e) {
  var t;
  return (t = (Hi(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Hi(e) {
  return Zr() ? e instanceof Node || e instanceof pe(e).Node : !1;
}
function ye(e) {
  return Zr() ? e instanceof Element || e instanceof pe(e).Element : !1;
}
function $e(e) {
  return Zr() ? e instanceof HTMLElement || e instanceof pe(e).HTMLElement : !1;
}
function ss(e) {
  return !Zr() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof pe(e).ShadowRoot;
}
function jt(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: o
  } = xe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && o !== "inline" && o !== "contents";
}
function Nv(e) {
  return /^(table|td|th)$/.test(St(e));
}
function Qr(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Ev = /transform|translate|scale|rotate|perspective|filter/, Pv = /paint|layout|strict|content/, et = (e) => !!e && e !== "none";
let In;
function Lo(e) {
  const t = ye(e) ? xe(e) : e;
  return et(t.transform) || et(t.translate) || et(t.scale) || et(t.rotate) || et(t.perspective) || !$o() && (et(t.backdropFilter) || et(t.filter)) || Ev.test(t.willChange || "") || Pv.test(t.contain || "");
}
function Tv(e) {
  let t = Ue(e);
  for (; $e(t) && !vt(t); ) {
    if (Lo(t))
      return t;
    if (Qr(t))
      return null;
    t = Ue(t);
  }
  return null;
}
function $o() {
  return In == null && (In = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), In;
}
function vt(e) {
  return /^(html|body|#document)$/.test(St(e));
}
function xe(e) {
  return pe(e).getComputedStyle(e);
}
function Jr(e) {
  return ye(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ue(e) {
  if (St(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ss(e) && e.host || // Fallback.
    Me(e)
  );
  return ss(t) ? t.host : t;
}
function Gi(e) {
  const t = Ue(e);
  return vt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : $e(t) && jt(t) ? t : Gi(t);
}
function Lt(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const o = Gi(e), a = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = pe(o);
  if (a) {
    const c = Yn(i);
    return t.concat(i, i.visualViewport || [], jt(o) ? o : [], c && r ? Lt(c) : []);
  } else
    return t.concat(o, Lt(o, [], r));
}
function Yn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Wi(e) {
  const t = xe(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = $e(e), a = o ? e.offsetWidth : r, i = o ? e.offsetHeight : n, c = Tr(r) !== a || Tr(n) !== i;
  return c && (r = a, n = i), {
    width: r,
    height: n,
    $: c
  };
}
function Fo(e) {
  return ye(e) ? e : e.contextElement;
}
function ft(e) {
  const t = Fo(e);
  if (!$e(t))
    return Te(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: a
  } = Wi(t);
  let i = (a ? Tr(r.width) : r.width) / n, c = (a ? Tr(r.height) : r.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: i,
    y: c
  };
}
const _v = /* @__PURE__ */ Te(0);
function Ui(e) {
  const t = pe(e);
  return !$o() || !t.visualViewport ? _v : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Mv(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== pe(e) ? !1 : t;
}
function tt(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), a = Fo(e);
  let i = Te(1);
  t && (n ? ye(n) && (i = ft(n)) : i = ft(e));
  const c = Mv(a, r, n) ? Ui(a) : Te(0);
  let d = (o.left + c.x) / i.x, u = (o.top + c.y) / i.y, p = o.width / i.x, f = o.height / i.y;
  if (a) {
    const m = pe(a), v = n && ye(n) ? pe(n) : n;
    let g = m, h = Yn(g);
    for (; h && n && v !== g; ) {
      const b = ft(h), w = h.getBoundingClientRect(), y = xe(h), x = w.left + (h.clientLeft + parseFloat(y.paddingLeft)) * b.x, C = w.top + (h.clientTop + parseFloat(y.paddingTop)) * b.y;
      d *= b.x, u *= b.y, p *= b.x, f *= b.y, d += x, u += C, g = pe(h), h = Yn(g);
    }
  }
  return Mr({
    width: p,
    height: f,
    x: d,
    y: u
  });
}
function en(e, t) {
  const r = Jr(e).scrollLeft;
  return t ? t.left + r : tt(Me(e)).left + r;
}
function Ki(e, t) {
  const r = e.getBoundingClientRect(), n = r.left + t.scrollLeft - en(e, r), o = r.top + t.scrollTop;
  return {
    x: n,
    y: o
  };
}
function Av(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: o
  } = e;
  const a = o === "fixed", i = Me(n), c = t ? Qr(t.floating) : !1;
  if (n === i || c && a)
    return r;
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Te(1);
  const p = Te(0), f = $e(n);
  if ((f || !f && !a) && ((St(n) !== "body" || jt(i)) && (d = Jr(n)), f)) {
    const v = tt(n);
    u = ft(n), p.x = v.x + n.clientLeft, p.y = v.y + n.clientTop;
  }
  const m = i && !f && !a ? Ki(i, d) : Te(0);
  return {
    width: r.width * u.x,
    height: r.height * u.y,
    x: r.x * u.x - d.scrollLeft * u.x + p.x + m.x,
    y: r.y * u.y - d.scrollTop * u.y + p.y + m.y
  };
}
function Iv(e) {
  return Array.from(e.getClientRects());
}
function Dv(e) {
  const t = Me(e), r = Jr(e), n = e.ownerDocument.body, o = fe(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = fe(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -r.scrollLeft + en(e);
  const c = -r.scrollTop;
  return xe(n).direction === "rtl" && (i += fe(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: c
  };
}
const is = 25;
function kv(e, t) {
  const r = pe(e), n = Me(e), o = r.visualViewport;
  let a = n.clientWidth, i = n.clientHeight, c = 0, d = 0;
  if (o) {
    a = o.width, i = o.height;
    const p = $o();
    (!p || p && t === "fixed") && (c = o.offsetLeft, d = o.offsetTop);
  }
  const u = en(n);
  if (u <= 0) {
    const p = n.ownerDocument, f = p.body, m = getComputedStyle(f), v = p.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, g = Math.abs(n.clientWidth - f.clientWidth - v);
    g <= is && (a -= g);
  } else u <= is && (a += u);
  return {
    width: a,
    height: i,
    x: c,
    y: d
  };
}
function Ov(e, t) {
  const r = tt(e, !0, t === "fixed"), n = r.top + e.clientTop, o = r.left + e.clientLeft, a = $e(e) ? ft(e) : Te(1), i = e.clientWidth * a.x, c = e.clientHeight * a.y, d = o * a.x, u = n * a.y;
  return {
    width: i,
    height: c,
    x: d,
    y: u
  };
}
function cs(e, t, r) {
  let n;
  if (t === "viewport")
    n = kv(e, r);
  else if (t === "document")
    n = Dv(Me(e));
  else if (ye(t))
    n = Ov(t, r);
  else {
    const o = Ui(e);
    n = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Mr(n);
}
function ji(e, t) {
  const r = Ue(e);
  return r === t || !ye(r) || vt(r) ? !1 : xe(r).position === "fixed" || ji(r, t);
}
function Lv(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = Lt(e, [], !1).filter((c) => ye(c) && St(c) !== "body"), o = null;
  const a = xe(e).position === "fixed";
  let i = a ? Ue(e) : e;
  for (; ye(i) && !vt(i); ) {
    const c = xe(i), d = Lo(i);
    !d && c.position === "fixed" && (o = null), (a ? !d && !o : !d && c.position === "static" && !!o && (o.position === "absolute" || o.position === "fixed") || jt(i) && !d && ji(e, i)) ? n = n.filter((p) => p !== i) : o = c, i = Ue(i);
  }
  return t.set(e, n), n;
}
function $v(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: o
  } = e;
  const i = [...r === "clippingAncestors" ? Qr(t) ? [] : Lv(t, this._c) : [].concat(r), n], c = cs(t, i[0], o);
  let d = c.top, u = c.right, p = c.bottom, f = c.left;
  for (let m = 1; m < i.length; m++) {
    const v = cs(t, i[m], o);
    d = fe(v.top, d), u = We(v.right, u), p = We(v.bottom, p), f = fe(v.left, f);
  }
  return {
    width: u - f,
    height: p - d,
    x: f,
    y: d
  };
}
function Fv(e) {
  const {
    width: t,
    height: r
  } = Wi(e);
  return {
    width: t,
    height: r
  };
}
function Vv(e, t, r) {
  const n = $e(t), o = Me(t), a = r === "fixed", i = tt(e, !0, a, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const d = Te(0);
  function u() {
    d.x = en(o);
  }
  if (n || !n && !a)
    if ((St(t) !== "body" || jt(o)) && (c = Jr(t)), n) {
      const v = tt(t, !0, a, t);
      d.x = v.x + t.clientLeft, d.y = v.y + t.clientTop;
    } else o && u();
  a && !n && o && u();
  const p = o && !n && !a ? Ki(o, c) : Te(0), f = i.left + c.scrollLeft - d.x - p.x, m = i.top + c.scrollTop - d.y - p.y;
  return {
    x: f,
    y: m,
    width: i.width,
    height: i.height
  };
}
function Dn(e) {
  return xe(e).position === "static";
}
function ls(e, t) {
  if (!$e(e) || xe(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return Me(e) === r && (r = r.ownerDocument.body), r;
}
function Yi(e, t) {
  const r = pe(e);
  if (Qr(e))
    return r;
  if (!$e(e)) {
    let o = Ue(e);
    for (; o && !vt(o); ) {
      if (ye(o) && !Dn(o))
        return o;
      o = Ue(o);
    }
    return r;
  }
  let n = ls(e, t);
  for (; n && Nv(n) && Dn(n); )
    n = ls(n, t);
  return n && vt(n) && Dn(n) && !Lo(n) ? r : n || Tv(e) || r;
}
const Bv = async function(e) {
  const t = this.getOffsetParent || Yi, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: Vv(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function zv(e) {
  return xe(e).direction === "rtl";
}
const Hv = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Av,
  getDocumentElement: Me,
  getClippingRect: $v,
  getOffsetParent: Yi,
  getElementRects: Bv,
  getClientRects: Iv,
  getDimensions: Fv,
  getScale: ft,
  isElement: ye,
  isRTL: zv
};
function Xi(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Gv(e, t) {
  let r = null, n;
  const o = Me(e);
  function a() {
    var c;
    clearTimeout(n), (c = r) == null || c.disconnect(), r = null;
  }
  function i(c, d) {
    c === void 0 && (c = !1), d === void 0 && (d = 1), a();
    const u = e.getBoundingClientRect(), {
      left: p,
      top: f,
      width: m,
      height: v
    } = u;
    if (c || t(), !m || !v)
      return;
    const g = fr(f), h = fr(o.clientWidth - (p + m)), b = fr(o.clientHeight - (f + v)), w = fr(p), x = {
      rootMargin: -g + "px " + -h + "px " + -b + "px " + -w + "px",
      threshold: fe(0, We(1, d)) || 1
    };
    let C = !0;
    function S(R) {
      const E = R[0].intersectionRatio;
      if (E !== d) {
        if (!C)
          return i();
        E ? i(!1, E) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !Xi(u, e.getBoundingClientRect()) && i(), C = !1;
    }
    try {
      r = new IntersectionObserver(S, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(S, x);
    }
    r.observe(e);
  }
  return i(!0), a;
}
function Wv(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = n, u = Fo(e), p = o || a ? [...u ? Lt(u) : [], ...t ? Lt(t) : []] : [];
  p.forEach((w) => {
    o && w.addEventListener("scroll", r, {
      passive: !0
    }), a && w.addEventListener("resize", r);
  });
  const f = u && c ? Gv(u, r) : null;
  let m = -1, v = null;
  i && (v = new ResizeObserver((w) => {
    let [y] = w;
    y && y.target === u && v && t && (v.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var x;
      (x = v) == null || x.observe(t);
    })), r();
  }), u && !d && v.observe(u), t && v.observe(t));
  let g, h = d ? tt(e) : null;
  d && b();
  function b() {
    const w = tt(e);
    h && !Xi(h, w) && r(), h = w, g = requestAnimationFrame(b);
  }
  return r(), () => {
    var w;
    p.forEach((y) => {
      o && y.removeEventListener("scroll", r), a && y.removeEventListener("resize", r);
    }), f == null || f(), (w = v) == null || w.disconnect(), v = null, d && cancelAnimationFrame(g);
  };
}
const Uv = xv, Kv = Cv, jv = bv, Yv = Rv, Xv = wv, ds = gv, qv = Sv, Zv = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: Hv,
    ...r
  }, a = {
    ...o.platform,
    _c: n
  };
  return vv(e, t, {
    ...o,
    platform: a
  });
};
var Qv = typeof document < "u", Jv = function() {
}, wr = Qv ? tp : Jv;
function Ar(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!Ar(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), r = o.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const a = o[n];
      if (!(a === "_owner" && e.$$typeof) && !Ar(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function qi(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function us(e, t) {
  const r = qi(e);
  return Math.round(t * r) / r;
}
function kn(e) {
  const t = s.useRef(e);
  return wr(() => {
    t.current = e;
  }), t;
}
function eg(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: c = !0,
    whileElementsMounted: d,
    open: u
  } = e, [p, f] = s.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, v] = s.useState(n);
  Ar(m, n) || v(n);
  const [g, h] = s.useState(null), [b, w] = s.useState(null), y = s.useCallback((F) => {
    F !== R.current && (R.current = F, h(F));
  }, []), x = s.useCallback((F) => {
    F !== E.current && (E.current = F, w(F));
  }, []), C = a || g, S = i || b, R = s.useRef(null), E = s.useRef(null), T = s.useRef(p), M = d != null, O = kn(d), D = kn(o), L = kn(u), H = s.useCallback(() => {
    if (!R.current || !E.current)
      return;
    const F = {
      placement: t,
      strategy: r,
      middleware: m
    };
    D.current && (F.platform = D.current), Zv(R.current, E.current, F).then((_) => {
      const U = {
        ..._,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: L.current !== !1
      };
      k.current && !Ar(T.current, U) && (T.current = U, yt.flushSync(() => {
        f(U);
      }));
    });
  }, [m, t, r, D, L]);
  wr(() => {
    u === !1 && T.current.isPositioned && (T.current.isPositioned = !1, f((F) => ({
      ...F,
      isPositioned: !1
    })));
  }, [u]);
  const k = s.useRef(!1);
  wr(() => (k.current = !0, () => {
    k.current = !1;
  }), []), wr(() => {
    if (C && (R.current = C), S && (E.current = S), C && S) {
      if (O.current)
        return O.current(C, S, H);
      H();
    }
  }, [C, S, H, O, M]);
  const B = s.useMemo(() => ({
    reference: R,
    floating: E,
    setReference: y,
    setFloating: x
  }), [y, x]), $ = s.useMemo(() => ({
    reference: C,
    floating: S
  }), [C, S]), z = s.useMemo(() => {
    const F = {
      position: r,
      left: 0,
      top: 0
    };
    if (!$.floating)
      return F;
    const _ = us($.floating, p.x), U = us($.floating, p.y);
    return c ? {
      ...F,
      transform: "translate(" + _ + "px, " + U + "px)",
      ...qi($.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: _,
      top: U
    };
  }, [r, c, $.floating, p.x, p.y]);
  return s.useMemo(() => ({
    ...p,
    update: H,
    refs: B,
    elements: $,
    floatingStyles: z
  }), [p, H, B, $, z]);
}
const tg = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: o
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? ds({
        element: n.current,
        padding: o
      }).fn(r) : {} : n ? ds({
        element: n,
        padding: o
      }).fn(r) : {};
    }
  };
}, rg = (e, t) => {
  const r = Uv(e);
  return {
    name: r.name,
    fn: r.fn,
    options: [e, t]
  };
}, ng = (e, t) => {
  const r = Kv(e);
  return {
    name: r.name,
    fn: r.fn,
    options: [e, t]
  };
}, og = (e, t) => ({
  fn: qv(e).fn,
  options: [e, t]
}), ag = (e, t) => {
  const r = jv(e);
  return {
    name: r.name,
    fn: r.fn,
    options: [e, t]
  };
}, sg = (e, t) => {
  const r = Yv(e);
  return {
    name: r.name,
    fn: r.fn,
    options: [e, t]
  };
}, ig = (e, t) => {
  const r = Xv(e);
  return {
    name: r.name,
    fn: r.fn,
    options: [e, t]
  };
}, cg = (e, t) => {
  const r = tg(e);
  return {
    name: r.name,
    fn: r.fn,
    options: [e, t]
  };
};
var lg = "Arrow", Zi = s.forwardRef((e, t) => {
  const { children: r, width: n = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ l(
    A.svg,
    {
      ...a,
      ref: t,
      width: n,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ l("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Zi.displayName = lg;
var dg = Zi, Vo = "Popper", [Qi, Ae] = ae(Vo), [ug, Ji] = Qi(Vo), ec = (e) => {
  const { __scopePopper: t, children: r } = e, [n, o] = s.useState(null), [a, i] = s.useState(void 0);
  return /* @__PURE__ */ l(
    ug,
    {
      scope: t,
      anchor: n,
      onAnchorChange: o,
      placementState: a,
      setPlacementState: i,
      children: r
    }
  );
};
ec.displayName = Vo;
var tc = "PopperAnchor", rc = s.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: n, ...o } = e, a = Ji(tc, r), i = s.useRef(null), c = a.onAnchorChange, d = s.useCallback(
      (g) => {
        i.current = g, g && c(g);
      },
      [c]
    ), u = V(t, d), p = s.useRef(null);
    s.useEffect(() => {
      if (!n)
        return;
      const g = p.current;
      p.current = n.current, g !== p.current && c(p.current);
    });
    const f = a.placementState && zo(a.placementState), m = f == null ? void 0 : f[0], v = f == null ? void 0 : f[1];
    return n ? null : /* @__PURE__ */ l(
      A.div,
      {
        "data-radix-popper-side": m,
        "data-radix-popper-align": v,
        ...o,
        ref: u
      }
    );
  }
);
rc.displayName = tc;
var Bo = "PopperContent", [fg, pg] = Qi(Bo), nc = s.forwardRef(
  (e, t) => {
    var Z, J, q, Y, Q, Re;
    const {
      __scopePopper: r,
      side: n = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: c = 0,
      avoidCollisions: d = !0,
      collisionBoundary: u = [],
      collisionPadding: p = 0,
      sticky: f = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: v = "optimized",
      onPlaced: g,
      ...h
    } = e, b = Ji(Bo, r), [w, y] = s.useState(null), x = V(t, y), [C, S] = s.useState(null), R = Wt(C), E = (R == null ? void 0 : R.width) ?? 0, T = (R == null ? void 0 : R.height) ?? 0, M = n + (a !== "center" ? "-" + a : ""), O = typeof p == "number" ? p : { top: 0, right: 0, bottom: 0, left: 0, ...p }, D = Array.isArray(u) ? u : [u], L = D.length > 0, H = {
      padding: O,
      boundary: D.filter(hg),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: L
    }, { refs: k, floatingStyles: B, placement: $, isPositioned: z, middlewareData: F } = eg({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: M,
      whileElementsMounted: (...be) => Wv(...be, {
        animationFrame: v === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        rg({ mainAxis: o + T, alignmentAxis: i }),
        d && ng({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? og() : void 0,
          ...H
        }),
        d && ag({ ...H }),
        sg({
          ...H,
          apply: ({ elements: be, rects: it, availableWidth: Tt, availableHeight: _t }) => {
            const { width: Qf, height: Jf } = it.reference, lr = be.floating.style;
            lr.setProperty("--radix-popper-available-width", `${Tt}px`), lr.setProperty("--radix-popper-available-height", `${_t}px`), lr.setProperty("--radix-popper-anchor-width", `${Qf}px`), lr.setProperty("--radix-popper-anchor-height", `${Jf}px`);
          }
        }),
        C && cg({ element: C, padding: c }),
        vg({ arrowWidth: E, arrowHeight: T }),
        m && ig({
          strategy: "referenceHidden",
          ...H,
          // `hide` detects whether the anchor (reference) is clipped, so when
          // no explicit `collisionBoundary` is set we fall back to Floating
          // UI's default clipping ancestors (e.g. a scrollable menu). This
          // lets an occluded submenu hide once its anchor scrolls out of view
          // (#3237). The collision/size middlewares deliberately keep the
          // viewport-based default to avoid clamping content rendered inside
          // transformed or overflow-clipping portal containers.
          boundary: L ? H.boundary : void 0
        })
      ]
    }), _ = b.setPlacementState;
    oe(() => (_($), () => {
      _(void 0);
    }), [$, _]);
    const [U, K] = zo($), j = te(g);
    oe(() => {
      z && (j == null || j());
    }, [z, j]);
    const X = (Z = F.arrow) == null ? void 0 : Z.x, se = (J = F.arrow) == null ? void 0 : J.y, Ie = ((q = F.arrow) == null ? void 0 : q.centerOffset) !== 0, [ue, G] = s.useState();
    return oe(() => {
      w && G(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ l(
      "div",
      {
        ref: k.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...B,
          transform: z ? B.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ue,
          "--radix-popper-transform-origin": [
            (Y = F.transformOrigin) == null ? void 0 : Y.x,
            (Q = F.transformOrigin) == null ? void 0 : Q.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Re = F.hide) == null ? void 0 : Re.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ l(
          fg,
          {
            scope: r,
            placedSide: U,
            placedAlign: K,
            onArrowChange: S,
            arrowX: X,
            arrowY: se,
            shouldHideArrow: Ie,
            children: /* @__PURE__ */ l(
              A.div,
              {
                "data-side": U,
                "data-align": K,
                ...h,
                ref: x,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: z ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
nc.displayName = Bo;
var oc = "PopperArrow", mg = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, ac = s.forwardRef(function(t, r) {
  const { __scopePopper: n, ...o } = t, a = pg(oc, n), i = mg[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ l(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ l(
          dg,
          {
            ...o,
            ref: r,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
ac.displayName = oc;
function hg(e) {
  return e !== null;
}
var vg = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var b, w, y;
    const { placement: r, rects: n, middlewareData: o } = t, i = ((b = o.arrow) == null ? void 0 : b.centerOffset) !== 0, c = i ? 0 : e.arrowWidth, d = i ? 0 : e.arrowHeight, [u, p] = zo(r), f = { start: "0%", center: "50%", end: "100%" }[p], m = (((w = o.arrow) == null ? void 0 : w.x) ?? 0) + c / 2, v = (((y = o.arrow) == null ? void 0 : y.y) ?? 0) + d / 2;
    let g = "", h = "";
    return u === "bottom" ? (g = i ? f : `${m}px`, h = `${-d}px`) : u === "top" ? (g = i ? f : `${m}px`, h = `${n.floating.height + d}px`) : u === "right" ? (g = `${-d}px`, h = i ? f : `${v}px`) : u === "left" && (g = `${n.floating.width + d}px`, h = i ? f : `${v}px`), { data: { x: g, y: h } };
  }
});
function zo(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var Rt = ec, Nt = rc, Yt = nc, Xt = ac, gg = "Portal", Xe = s.forwardRef((e, t) => {
  var c;
  const { container: r, ...n } = e, [o, a] = s.useState(!1);
  oe(() => a(!0), []);
  const i = r || o && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return i ? yt.createPortal(/* @__PURE__ */ l(A.div, { ...n, ref: t }), i) : null;
});
Xe.displayName = gg;
var sc = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), bg = "VisuallyHidden", tn = s.forwardRef(
  (e, t) => /* @__PURE__ */ l(
    A.span,
    {
      ...e,
      ref: t,
      style: { ...sc, ...e.style }
    }
  )
);
tn.displayName = bg;
var wg = tn, yg = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, ct = /* @__PURE__ */ new WeakMap(), pr = /* @__PURE__ */ new WeakMap(), mr = {}, On = 0, ic = function(e) {
  return e && (e.host || ic(e.parentNode));
}, xg = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = ic(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Cg = function(e, t, r, n) {
  var o = xg(t, Array.isArray(e) ? e : [e]);
  mr[r] || (mr[r] = /* @__PURE__ */ new WeakMap());
  var a = mr[r], i = [], c = /* @__PURE__ */ new Set(), d = new Set(o), u = function(f) {
    !f || c.has(f) || (c.add(f), u(f.parentNode));
  };
  o.forEach(u);
  var p = function(f) {
    !f || d.has(f) || Array.prototype.forEach.call(f.children, function(m) {
      if (c.has(m))
        p(m);
      else
        try {
          var v = m.getAttribute(n), g = v !== null && v !== "false", h = (ct.get(m) || 0) + 1, b = (a.get(m) || 0) + 1;
          ct.set(m, h), a.set(m, b), i.push(m), h === 1 && g && pr.set(m, !0), b === 1 && m.setAttribute(r, "true"), g || m.setAttribute(n, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", m, w);
        }
    });
  };
  return p(t), c.clear(), On++, function() {
    i.forEach(function(f) {
      var m = ct.get(f) - 1, v = a.get(f) - 1;
      ct.set(f, m), a.set(f, v), m || (pr.has(f) || f.removeAttribute(n), pr.delete(f)), v || f.removeAttribute(r);
    }), On--, On || (ct = /* @__PURE__ */ new WeakMap(), ct = /* @__PURE__ */ new WeakMap(), pr = /* @__PURE__ */ new WeakMap(), mr = {});
  };
}, rn = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), o = yg(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live], script"))), Cg(n, o, r, "aria-hidden")) : function() {
    return null;
  };
}, Ee = function() {
  return Ee = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, Ee.apply(this, arguments);
};
function cc(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function Sg(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, o = t.length, a; n < o; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var yr = "right-scroll-bar-position", xr = "width-before-scroll-bar", Rg = "with-scroll-bars-hidden", Ng = "--removed-body-scroll-bar-size";
function Ln(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Eg(e, t) {
  var r = vo(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var o = r.value;
          o !== n && (r.value = n, r.callback(n, o));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var Pg = typeof window < "u" ? s.useLayoutEffect : s.useEffect, fs = /* @__PURE__ */ new WeakMap();
function Tg(e, t) {
  var r = Eg(null, function(n) {
    return e.forEach(function(o) {
      return Ln(o, n);
    });
  });
  return Pg(function() {
    var n = fs.get(r);
    if (n) {
      var o = new Set(n), a = new Set(e), i = r.current;
      o.forEach(function(c) {
        a.has(c) || Ln(c, null);
      }), a.forEach(function(c) {
        o.has(c) || Ln(c, i);
      });
    }
    fs.set(r, e);
  }, [e]), r;
}
function _g(e) {
  return e;
}
function Mg(e, t) {
  t === void 0 && (t = _g);
  var r = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, n);
      return r.push(i), function() {
        r = r.filter(function(c) {
          return c !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (n = !0; r.length; ) {
        var i = r;
        r = [], i.forEach(a);
      }
      r = {
        push: function(c) {
          return a(c);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(a) {
      n = !0;
      var i = [];
      if (r.length) {
        var c = r;
        r = [], c.forEach(a), i = r;
      }
      var d = function() {
        var p = i;
        i = [], p.forEach(a);
      }, u = function() {
        return Promise.resolve().then(d);
      };
      u(), r = {
        push: function(p) {
          i.push(p), u();
        },
        filter: function(p) {
          return i = i.filter(p), r;
        }
      };
    }
  };
  return o;
}
function Ag(e) {
  e === void 0 && (e = {});
  var t = Mg(null);
  return t.options = Ee({ async: !0, ssr: !1 }, e), t;
}
var lc = function(e) {
  var t = e.sideCar, r = cc(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return s.createElement(n, Ee({}, r));
};
lc.isSideCarExport = !0;
function Ig(e, t) {
  return e.useMedium(t), lc;
}
var dc = Ag(), $n = function() {
}, nn = s.forwardRef(function(e, t) {
  var r = s.useRef(null), n = s.useState({
    onScrollCapture: $n,
    onWheelCapture: $n,
    onTouchMoveCapture: $n
  }), o = n[0], a = n[1], i = e.forwardProps, c = e.children, d = e.className, u = e.removeScrollBar, p = e.enabled, f = e.shards, m = e.sideCar, v = e.noRelative, g = e.noIsolation, h = e.inert, b = e.allowPinchZoom, w = e.as, y = w === void 0 ? "div" : w, x = e.gapMode, C = cc(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = m, R = Tg([r, t]), E = Ee(Ee({}, C), o);
  return s.createElement(
    s.Fragment,
    null,
    p && s.createElement(S, { sideCar: dc, removeScrollBar: u, shards: f, noRelative: v, noIsolation: g, inert: h, setCallbacks: a, allowPinchZoom: !!b, lockRef: r, gapMode: x }),
    i ? s.cloneElement(s.Children.only(c), Ee(Ee({}, E), { ref: R })) : s.createElement(y, Ee({}, E, { className: d, ref: R }), c)
  );
});
nn.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
nn.classNames = {
  fullWidth: xr,
  zeroRight: yr
};
var Dg = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function kg() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Dg();
  return t && e.setAttribute("nonce", t), e;
}
function Og(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Lg(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var $g = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = kg()) && (Og(t, r), Lg(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Fg = function() {
  var e = $g();
  return function(t, r) {
    s.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, uc = function() {
  var e = Fg(), t = function(r) {
    var n = r.styles, o = r.dynamic;
    return e(n, o), null;
  };
  return t;
}, Vg = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Fn = function(e) {
  return parseInt(e || "", 10) || 0;
}, Bg = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Fn(r), Fn(n), Fn(o)];
}, zg = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Vg;
  var t = Bg(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, Hg = uc(), pt = "data-scroll-locked", Gg = function(e, t, r, n) {
  var o = e.left, a = e.top, i = e.right, c = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(Rg, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(c, "px ").concat(n, `;
  }
  body[`).concat(pt, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(c, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(yr, ` {
    right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(xr, ` {
    margin-right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(yr, " .").concat(yr, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(xr, " .").concat(xr, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(pt, `] {
    `).concat(Ng, ": ").concat(c, `px;
  }
`);
}, ps = function() {
  var e = parseInt(document.body.getAttribute(pt) || "0", 10);
  return isFinite(e) ? e : 0;
}, Wg = function() {
  s.useEffect(function() {
    return document.body.setAttribute(pt, (ps() + 1).toString()), function() {
      var e = ps() - 1;
      e <= 0 ? document.body.removeAttribute(pt) : document.body.setAttribute(pt, e.toString());
    };
  }, []);
}, Ug = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  Wg();
  var a = s.useMemo(function() {
    return zg(o);
  }, [o]);
  return s.createElement(Hg, { styles: Gg(a, !t, o, r ? "" : "!important") });
}, Xn = !1;
if (typeof window < "u")
  try {
    var hr = Object.defineProperty({}, "passive", {
      get: function() {
        return Xn = !0, !0;
      }
    });
    window.addEventListener("test", hr, hr), window.removeEventListener("test", hr, hr);
  } catch {
    Xn = !1;
  }
var lt = Xn ? { passive: !1 } : !1, Kg = function(e) {
  return e.tagName === "TEXTAREA";
}, fc = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !Kg(e) && r[t] === "visible")
  );
}, jg = function(e) {
  return fc(e, "overflowY");
}, Yg = function(e) {
  return fc(e, "overflowX");
}, ms = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = pc(e, n);
    if (o) {
      var a = mc(e, n), i = a[1], c = a[2];
      if (i > c)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, Xg = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, qg = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, pc = function(e, t) {
  return e === "v" ? jg(t) : Yg(t);
}, mc = function(e, t) {
  return e === "v" ? Xg(t) : qg(t);
}, Zg = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Qg = function(e, t, r, n, o) {
  var a = Zg(e, window.getComputedStyle(t).direction), i = a * n, c = r.target, d = t.contains(c), u = !1, p = i > 0, f = 0, m = 0;
  do {
    if (!c)
      break;
    var v = mc(e, c), g = v[0], h = v[1], b = v[2], w = h - b - a * g;
    (g || w) && pc(e, c) && (f += w, m += g);
    var y = c.parentNode;
    c = y && y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? y.host : y;
  } while (
    // portaled content
    !d && c !== document.body || // self content
    d && (t.contains(c) || t === c)
  );
  return (p && Math.abs(f) < 1 || !p && Math.abs(m) < 1) && (u = !0), u;
}, vr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, hs = function(e) {
  return [e.deltaX, e.deltaY];
}, vs = function(e) {
  return e && "current" in e ? e.current : e;
}, Jg = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, eb = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, tb = 0, dt = [];
function rb(e) {
  var t = s.useRef([]), r = s.useRef([0, 0]), n = s.useRef(), o = s.useState(tb++)[0], a = s.useState(uc)[0], i = s.useRef(e);
  s.useEffect(function() {
    i.current = e;
  }, [e]), s.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = Sg([e.lockRef.current], (e.shards || []).map(vs), !0).filter(Boolean);
      return h.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = s.useCallback(function(h, b) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = vr(h), y = r.current, x = "deltaX" in h ? h.deltaX : y[0] - w[0], C = "deltaY" in h ? h.deltaY : y[1] - w[1], S, R = h.target, E = Math.abs(x) > Math.abs(C) ? "h" : "v";
    if ("touches" in h && E === "h" && R.type === "range")
      return !1;
    var T = window.getSelection(), M = T && T.anchorNode, O = M ? M === R || M.contains(R) : !1;
    if (O)
      return !1;
    var D = ms(E, R);
    if (!D)
      return !0;
    if (D ? S = E : (S = E === "v" ? "h" : "v", D = ms(E, R)), !D)
      return !1;
    if (!n.current && "changedTouches" in h && (x || C) && (n.current = S), !S)
      return !0;
    var L = n.current || S;
    return Qg(L, b, h, L === "h" ? x : C);
  }, []), d = s.useCallback(function(h) {
    var b = h;
    if (!(!dt.length || dt[dt.length - 1] !== a)) {
      var w = "deltaY" in b ? hs(b) : vr(b), y = t.current.filter(function(S) {
        return S.name === b.type && (S.target === b.target || b.target === S.shadowParent) && Jg(S.delta, w);
      })[0];
      if (y && y.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!y) {
        var x = (i.current.shards || []).map(vs).filter(Boolean).filter(function(S) {
          return S.contains(b.target);
        }), C = x.length > 0 ? c(b, x[0]) : !i.current.noIsolation;
        C && b.cancelable && b.preventDefault();
      }
    }
  }, []), u = s.useCallback(function(h, b, w, y) {
    var x = { name: h, delta: b, target: w, should: y, shadowParent: nb(w) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(C) {
        return C !== x;
      });
    }, 1);
  }, []), p = s.useCallback(function(h) {
    r.current = vr(h), n.current = void 0;
  }, []), f = s.useCallback(function(h) {
    u(h.type, hs(h), h.target, c(h, e.lockRef.current));
  }, []), m = s.useCallback(function(h) {
    u(h.type, vr(h), h.target, c(h, e.lockRef.current));
  }, []);
  s.useEffect(function() {
    return dt.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", d, lt), document.addEventListener("touchmove", d, lt), document.addEventListener("touchstart", p, lt), function() {
      dt = dt.filter(function(h) {
        return h !== a;
      }), document.removeEventListener("wheel", d, lt), document.removeEventListener("touchmove", d, lt), document.removeEventListener("touchstart", p, lt);
    };
  }, []);
  var v = e.removeScrollBar, g = e.inert;
  return s.createElement(
    s.Fragment,
    null,
    g ? s.createElement(a, { styles: eb(o) }) : null,
    v ? s.createElement(Ug, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function nb(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const ob = Ig(dc, rb);
var qt = s.forwardRef(function(e, t) {
  return s.createElement(nn, Ee({}, e, { ref: t, sideCar: ob }));
});
qt.classNames = nn.classNames;
var ab = [" ", "Enter", "ArrowUp", "ArrowDown"], sb = [" ", "Enter"], rt = "Select", [on, an, ib] = ot(rt), [at] = ae(rt, [
  ib,
  Ae
]), sn = Ae(), [cb, qe] = at(rt), [lb, db] = at(rt), ub = "SelectProvider";
function hc(e) {
  const {
    __scopeSelect: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    value: i,
    defaultValue: c,
    onValueChange: d,
    dir: u,
    name: p,
    autoComplete: f,
    disabled: m,
    required: v,
    form: g,
    // @ts-expect-error internal render prop used by `Select` to compose its default parts
    internal_do_not_use_render: h
  } = e, b = sn(t), [w, y] = s.useState(null), [x, C] = s.useState(null), [S, R] = s.useState(!1), E = Le(u), [T, M] = ie({
    prop: n,
    defaultProp: o ?? !1,
    onChange: a,
    caller: rt
  }), [O, D] = ie({
    prop: i,
    defaultProp: c,
    onChange: d,
    caller: rt
  }), L = s.useRef(null), H = s.useRef(O);
  s.useEffect(() => {
    const j = g ? w == null ? void 0 : w.ownerDocument.getElementById(g) : w == null ? void 0 : w.form;
    if (j instanceof HTMLFormElement) {
      const X = () => D(H.current);
      return j.addEventListener("reset", X), () => j.removeEventListener("reset", X);
    }
  }, [g, w, D]);
  const k = w ? !!g || !!w.closest("form") : !0, [B, $] = s.useState(/* @__PURE__ */ new Set()), z = ce(), F = Array.from(B).map((j) => j.props.value).join(";"), _ = s.useCallback((j) => {
    $((X) => new Set(X).add(j));
  }, []), U = s.useCallback((j) => {
    $((X) => {
      const se = new Set(X);
      return se.delete(j), se;
    });
  }, []), K = {
    required: v,
    trigger: w,
    onTriggerChange: y,
    valueNode: x,
    onValueNodeChange: C,
    valueNodeHasChildren: S,
    onValueNodeHasChildrenChange: R,
    contentId: z,
    value: O,
    onValueChange: D,
    open: T,
    onOpenChange: M,
    dir: E,
    triggerPointerDownPosRef: L,
    disabled: m,
    name: p,
    autoComplete: f,
    form: g,
    nativeOptions: B,
    nativeSelectKey: F,
    isFormControl: k
  };
  return /* @__PURE__ */ l(Rt, { ...b, children: /* @__PURE__ */ l(cb, { scope: t, ...K, children: /* @__PURE__ */ l(on.Provider, { scope: t, children: /* @__PURE__ */ l(
    lb,
    {
      scope: t,
      onNativeOptionAdd: _,
      onNativeOptionRemove: U,
      children: Pb(h) ? h(K) : r
    }
  ) }) }) });
}
hc.displayName = ub;
var vc = (e) => {
  const { __scopeSelect: t, children: r, ...n } = e;
  return /* @__PURE__ */ l(
    hc,
    {
      __scopeSelect: t,
      ...n,
      internal_do_not_use_render: ({ isFormControl: o }) => /* @__PURE__ */ I(ve, { children: [
        r,
        o ? /* @__PURE__ */ l(
          Bc,
          {
            __scopeSelect: t
          }
        ) : null
      ] })
    }
  );
};
vc.displayName = rt;
var gc = "SelectTrigger", Ho = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, disabled: n = !1, ...o } = e, a = sn(r), i = qe(gc, r), c = i.disabled || n, d = V(t, i.onTriggerChange), u = an(r), p = s.useRef("touch"), [f, m, v] = zc((h) => {
      const b = u().filter((x) => !x.disabled), w = b.find((x) => x.value === i.value), y = Hc(b, h, w);
      y !== void 0 && i.onValueChange(y.value);
    }), g = (h) => {
      c || (i.onOpenChange(!0), v()), h && (i.triggerPointerDownPosRef.current = {
        x: Math.round(h.pageX),
        y: Math.round(h.pageY)
      });
    };
    return /* @__PURE__ */ l(Nt, { asChild: !0, ...a, children: /* @__PURE__ */ l(
      A.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.open ? i.contentId : void 0,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: c,
        "data-disabled": c ? "" : void 0,
        "data-placeholder": cn(i.value) ? "" : void 0,
        ...o,
        ref: d,
        onClick: P(o.onClick, (h) => {
          h.currentTarget.focus(), p.current !== "mouse" && g(h);
        }),
        onPointerDown: P(o.onPointerDown, (h) => {
          p.current = h.pointerType;
          const b = h.target;
          b.hasPointerCapture(h.pointerId) && b.releasePointerCapture(h.pointerId), h.button === 0 && h.ctrlKey === !1 && h.pointerType === "mouse" && (g(h), h.preventDefault());
        }),
        onKeyDown: P(o.onKeyDown, (h) => {
          const b = f.current !== "";
          !(h.ctrlKey || h.altKey || h.metaKey) && h.key.length === 1 && m(h.key), !(b && h.key === " ") && ab.includes(h.key) && (g(), h.preventDefault());
        })
      }
    ) });
  }
);
Ho.displayName = gc;
var bc = "SelectValue", wc = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: o, children: a, placeholder: i = "", ...c } = e, d = qe(bc, r), { onValueNodeHasChildrenChange: u } = d, p = a !== void 0, f = V(t, d.onValueNodeChange);
    oe(() => {
      u(p);
    }, [u, p]);
    const m = cn(d.value);
    return /* @__PURE__ */ l(
      A.span,
      {
        ...c,
        asChild: m ? !1 : c.asChild,
        ref: f,
        style: { pointerEvents: "none" },
        children: /* @__PURE__ */ l(s.Fragment, { children: m ? i : a }, m ? "placeholder" : "value")
      }
    );
  }
);
wc.displayName = bc;
var fb = "SelectIcon", yc = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, children: n, ...o } = e;
    return /* @__PURE__ */ l(A.span, { "aria-hidden": !0, ...o, ref: t, children: n || "▼" });
  }
);
yc.displayName = fb;
var xc = "SelectPortal", [pb, mb] = at(xc, {
  forceMount: void 0
}), Cc = (e) => {
  const { __scopeSelect: t, forceMount: r, ...n } = e;
  return /* @__PURE__ */ l(pb, { scope: e.__scopeSelect, forceMount: r, children: /* @__PURE__ */ l(Xe, { asChild: !0, ...n }) });
};
Cc.displayName = xc;
var Ke = "SelectContent", Go = s.forwardRef(
  (e, t) => {
    const r = mb(Ke, e.__scopeSelect), { forceMount: n = r.forceMount, ...o } = e, a = qe(Ke, e.__scopeSelect), [i, c] = s.useState();
    return oe(() => {
      c(new DocumentFragment());
    }, []), /* @__PURE__ */ l(ne, { present: n || a.open, children: ({ present: d }) => d ? /* @__PURE__ */ l(Nc, { ...o, ref: t }) : /* @__PURE__ */ l(Sc, { ...o, fragment: i }) });
  }
);
Go.displayName = Ke;
var Sc = s.forwardRef((e, t) => {
  const { __scopeSelect: r, children: n, fragment: o } = e;
  return o ? yt.createPortal(
    /* @__PURE__ */ l(Rc, { scope: r, children: /* @__PURE__ */ l(on.Slot, { scope: r, children: /* @__PURE__ */ l("div", { ref: t, children: n }) }) }),
    o
  ) : null;
});
Sc.displayName = "SelectContentFragment";
var we = 10, [Rc, Ze] = at(Ke), hb = "SelectContentImpl", vb = /* @__PURE__ */ Ge("SelectContent.RemoveScroll"), Nc = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: r } = e, {
      position: n = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: c,
      sideOffset: d,
      align: u,
      alignOffset: p,
      arrowPadding: f,
      collisionBoundary: m,
      collisionPadding: v,
      sticky: g,
      hideWhenDetached: h,
      avoidCollisions: b,
      //
      ...w
    } = e, y = qe(Ke, r), [x, C] = s.useState(null), [S, R] = s.useState(null), E = V(t, C), [T, M] = s.useState(null), [O, D] = s.useState(
      null
    ), L = an(r), [H, k] = s.useState(!1), B = s.useRef(!1);
    s.useEffect(() => {
      if (x) return rn(x);
    }, [x]), qr();
    const $ = s.useCallback(
      (G) => {
        const [Z, ...J] = L().map((Q) => Q.ref.current), [q] = J.slice(-1), Y = document.activeElement;
        for (const Q of G)
          if (Q === Y || (Q == null || Q.scrollIntoView({ block: "nearest" }), Q === Z && S && (S.scrollTop = 0), Q === q && S && (S.scrollTop = S.scrollHeight), Q == null || Q.focus(), document.activeElement !== Y)) return;
      },
      [L, S]
    ), z = s.useCallback(
      () => $([T, x]),
      [$, T, x]
    );
    s.useEffect(() => {
      H && z();
    }, [H, z]);
    const { onOpenChange: F, triggerPointerDownPosRef: _ } = y;
    s.useEffect(() => {
      if (x) {
        let G = { x: 0, y: 0 };
        const Z = (q) => {
          var Y, Q;
          G = {
            x: Math.abs(Math.round(q.pageX) - (((Y = _.current) == null ? void 0 : Y.x) ?? 0)),
            y: Math.abs(Math.round(q.pageY) - (((Q = _.current) == null ? void 0 : Q.y) ?? 0))
          };
        }, J = (q) => {
          G.x <= 10 && G.y <= 10 ? q.preventDefault() : q.composedPath().includes(x) || F(!1), document.removeEventListener("pointermove", Z), _.current = null;
        };
        return _.current !== null && (document.addEventListener("pointermove", Z), document.addEventListener("pointerup", J, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Z), document.removeEventListener("pointerup", J, { capture: !0 });
        };
      }
    }, [x, F, _]), s.useEffect(() => {
      const G = () => F(!1);
      return window.addEventListener("blur", G), window.addEventListener("resize", G), () => {
        window.removeEventListener("blur", G), window.removeEventListener("resize", G);
      };
    }, [F]);
    const [U, K] = zc((G) => {
      const Z = L().filter((Y) => !Y.disabled), J = Z.find((Y) => Y.ref.current === document.activeElement), q = Hc(Z, G, J);
      q && setTimeout(() => {
        var Y;
        return (Y = q.ref.current) == null ? void 0 : Y.focus();
      });
    }), j = s.useCallback(
      (G, Z, J) => {
        const q = !B.current && !J;
        (y.value !== void 0 && y.value === Z || q) && (M(G), q && (B.current = !0));
      },
      [y.value]
    ), X = s.useCallback(() => x == null ? void 0 : x.focus(), [x]), se = s.useCallback(
      (G, Z, J) => {
        const q = !B.current && !J;
        (y.value !== void 0 && y.value === Z || q) && D(G);
      },
      [y.value]
    ), Ie = n === "popper" ? qn : Ec, ue = Ie === qn ? {
      side: c,
      sideOffset: d,
      align: u,
      alignOffset: p,
      arrowPadding: f,
      collisionBoundary: m,
      collisionPadding: v,
      sticky: g,
      hideWhenDetached: h,
      avoidCollisions: b
    } : {};
    return /* @__PURE__ */ l(
      Rc,
      {
        scope: r,
        content: x,
        viewport: S,
        onViewportChange: R,
        itemRefCallback: j,
        selectedItem: T,
        onItemLeave: X,
        itemTextRefCallback: se,
        focusSelectedItem: z,
        selectedItemText: O,
        position: n,
        isPositioned: H,
        searchRef: U,
        children: /* @__PURE__ */ l(qt, { as: vb, allowPinchZoom: !0, children: /* @__PURE__ */ l(
          Kt,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (G) => {
              G.preventDefault();
            },
            onUnmountAutoFocus: P(o, (G) => {
              var Z;
              (Z = y.trigger) == null || Z.focus({ preventScroll: !0 }), G.preventDefault();
            }),
            children: /* @__PURE__ */ l(
              Ye,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: i,
                onFocusOutside: (G) => G.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ l(
                  Ie,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (G) => G.preventDefault(),
                    ...w,
                    ...ue,
                    onPlaced: () => k(!0),
                    ref: E,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: P(w.onKeyDown, (G) => {
                      const Z = G.ctrlKey || G.altKey || G.metaKey;
                      if (G.key === "Tab" && G.preventDefault(), !Z && G.key.length === 1 && K(G.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(G.key)) {
                        let q = L().filter((Y) => !Y.disabled).map((Y) => Y.ref.current);
                        if (["ArrowUp", "End"].includes(G.key) && (q = q.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(G.key)) {
                          const Y = G.target, Q = q.indexOf(Y);
                          q = q.slice(Q + 1);
                        }
                        setTimeout(() => $(q)), G.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Nc.displayName = hb;
var gb = "SelectItemAlignedPosition", Ec = s.forwardRef((e, t) => {
  const { __scopeSelect: r, onPlaced: n, ...o } = e, a = qe(Ke, r), i = Ze(Ke, r), [c, d] = s.useState(null), [u, p] = s.useState(null), f = V(t, p), m = an(r), v = s.useRef(!1), g = s.useRef(!0), { viewport: h, selectedItem: b, selectedItemText: w, focusSelectedItem: y } = i, x = s.useCallback(() => {
    if (a.trigger && a.valueNode && c && u && h && b && w) {
      const E = a.trigger.getBoundingClientRect(), T = u.getBoundingClientRect(), M = a.valueNode.getBoundingClientRect(), O = w.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const Y = O.left - T.left, Q = M.left - Y, Re = E.left - Q, be = E.width + Re, it = Math.max(be, T.width), Tt = window.innerWidth - we, _t = Ot(Q, [
          we,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(we, Tt - it)
        ]);
        c.style.minWidth = be + "px", c.style.left = _t + "px";
      } else {
        const Y = T.right - O.right, Q = window.innerWidth - M.right - Y, Re = window.innerWidth - E.right - Q, be = E.width + Re, it = Math.max(be, T.width), Tt = window.innerWidth - we, _t = Ot(Q, [
          we,
          Math.max(we, Tt - it)
        ]);
        c.style.minWidth = be + "px", c.style.right = _t + "px";
      }
      const D = m(), L = window.innerHeight - we * 2, H = h.scrollHeight, k = window.getComputedStyle(u), B = parseInt(k.borderTopWidth, 10), $ = parseInt(k.paddingTop, 10), z = parseInt(k.borderBottomWidth, 10), F = parseInt(k.paddingBottom, 10), _ = B + $ + H + F + z, U = Math.min(b.offsetHeight * 5, _), K = window.getComputedStyle(h), j = parseInt(K.paddingTop, 10), X = parseInt(K.paddingBottom, 10), se = E.top + E.height / 2 - we, Ie = L - se, ue = b.offsetHeight / 2, G = b.offsetTop + ue, Z = B + $ + G, J = _ - Z;
      if (Z <= se) {
        const Y = D.length > 0 && b === D[D.length - 1].ref.current;
        c.style.bottom = "0px";
        const Q = u.clientHeight - h.offsetTop - h.offsetHeight, Re = Math.max(
          Ie,
          ue + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Y ? X : 0) + Q + z
        ), be = Z + Re;
        c.style.height = be + "px";
      } else {
        const Y = D.length > 0 && b === D[0].ref.current;
        c.style.top = "0px";
        const Re = Math.max(
          se,
          B + h.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Y ? j : 0) + ue
        ) + J;
        c.style.height = Re + "px", h.scrollTop = Z - se + h.offsetTop;
      }
      c.style.margin = `${we}px 0`, c.style.minHeight = U + "px", c.style.maxHeight = L + "px", n == null || n(), requestAnimationFrame(() => v.current = !0);
    }
  }, [
    m,
    a.trigger,
    a.valueNode,
    c,
    u,
    h,
    b,
    w,
    a.dir,
    n
  ]);
  oe(() => x(), [x]);
  const [C, S] = s.useState();
  oe(() => {
    u && S(window.getComputedStyle(u).zIndex);
  }, [u]);
  const R = s.useCallback(
    (E) => {
      E && g.current === !0 && (x(), y == null || y(), g.current = !1);
    },
    [x, y]
  );
  return /* @__PURE__ */ l(
    wb,
    {
      scope: r,
      contentWrapper: c,
      shouldExpandOnScrollRef: v,
      onScrollButtonChange: R,
      children: /* @__PURE__ */ l(
        "div",
        {
          ref: d,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: C
          },
          children: /* @__PURE__ */ l(
            A.div,
            {
              ...o,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
Ec.displayName = gb;
var bb = "SelectPopperPosition", qn = s.forwardRef((e, t) => {
  const {
    __scopeSelect: r,
    align: n = "start",
    collisionPadding: o = we,
    ...a
  } = e, i = sn(r);
  return /* @__PURE__ */ l(
    Yt,
    {
      ...i,
      ...a,
      ref: t,
      align: n,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
qn.displayName = bb;
var [wb, Wo] = at(Ke, {}), Zn = "SelectViewport", Pc = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, nonce: n, ...o } = e, a = Ze(Zn, r), i = Wo(Zn, r), c = V(t, a.onViewportChange), d = s.useRef(0);
    return /* @__PURE__ */ I(ve, { children: [
      /* @__PURE__ */ l(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ l(on.Slot, { scope: r, children: /* @__PURE__ */ l(
        A.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: c,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: P(o.onScroll, (u) => {
            const p = u.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: m } = i;
            if (m != null && m.current && f) {
              const v = Math.abs(d.current - p.scrollTop);
              if (v > 0) {
                const g = window.innerHeight - we * 2, h = parseFloat(f.style.minHeight), b = parseFloat(f.style.height), w = Math.max(h, b);
                if (w < g) {
                  const y = w + v, x = Math.min(g, y), C = y - x;
                  f.style.height = x + "px", f.style.bottom === "0px" && (p.scrollTop = C > 0 ? C : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            d.current = p.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Pc.displayName = Zn;
var Tc = "SelectGroup", [yb, xb] = at(Tc), _c = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = ce();
    return /* @__PURE__ */ l(yb, { scope: r, id: o, children: /* @__PURE__ */ l(A.div, { role: "group", "aria-labelledby": o, ...n, ref: t }) });
  }
);
_c.displayName = Tc;
var Mc = "SelectLabel", Cb = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = xb(Mc, r);
    return /* @__PURE__ */ l(A.div, { id: o.id, ...n, ref: t });
  }
);
Cb.displayName = Mc;
var Ir = "SelectItem", [Sb, Ac] = at(Ir), Uo = s.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: r,
      value: n,
      disabled: o = !1,
      textValue: a,
      ...i
    } = e, c = qe(Ir, r), d = Ze(Ir, r), u = c.value === n, [p, f] = s.useState(a ?? ""), [m, v] = s.useState(!1), g = te(
      (x) => {
        var C;
        return (C = d.itemRefCallback) == null ? void 0 : C.call(d, x, n, o);
      }
    ), h = V(t, g), b = ce(), w = s.useRef("touch"), y = () => {
      o || (c.onValueChange(n), c.onOpenChange(!1));
    };
    return /* @__PURE__ */ l(
      Sb,
      {
        scope: r,
        value: n,
        disabled: o,
        textId: b,
        isSelected: u,
        onItemTextChange: s.useCallback((x) => {
          f((C) => C || ((x == null ? void 0 : x.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ l(
          on.ItemSlot,
          {
            scope: r,
            value: n,
            disabled: o,
            textValue: p,
            children: /* @__PURE__ */ l(
              A.div,
              {
                role: "option",
                "aria-labelledby": b,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": u && m,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...i,
                ref: h,
                onFocus: P(i.onFocus, () => v(!0)),
                onBlur: P(i.onBlur, () => v(!1)),
                onClick: P(i.onClick, () => {
                  w.current !== "mouse" && y();
                }),
                onPointerUp: P(i.onPointerUp, () => {
                  w.current === "mouse" && y();
                }),
                onPointerDown: P(i.onPointerDown, (x) => {
                  w.current = x.pointerType;
                }),
                onPointerMove: P(i.onPointerMove, (x) => {
                  var C;
                  w.current = x.pointerType, o ? (C = d.onItemLeave) == null || C.call(d) : w.current === "mouse" && x.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: P(i.onPointerLeave, (x) => {
                  var C;
                  x.currentTarget === document.activeElement && ((C = d.onItemLeave) == null || C.call(d));
                }),
                onKeyDown: P(i.onKeyDown, (x) => {
                  var S;
                  o || x.target !== x.currentTarget || ((S = d.searchRef) == null ? void 0 : S.current) !== "" && x.key === " " || (sb.includes(x.key) && y(), x.key === " " && x.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Uo.displayName = Ir;
var Dt = "SelectItemText", Ic = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: o, ...a } = e, i = qe(Dt, r), c = Ze(Dt, r), d = Ac(Dt, r), u = db(Dt, r), [p, f] = s.useState(null), m = te(
      (y) => {
        var x;
        return (x = c.itemTextRefCallback) == null ? void 0 : x.call(c, y, d.value, d.disabled);
      }
    ), v = V(
      t,
      f,
      d.onItemTextChange,
      m
    ), g = p == null ? void 0 : p.textContent, h = s.useMemo(
      () => /* @__PURE__ */ l("option", { value: d.value, disabled: d.disabled, children: g }, d.value),
      [d.disabled, d.value, g]
    ), { onNativeOptionAdd: b, onNativeOptionRemove: w } = u;
    return oe(() => (b(h), () => w(h)), [b, w, h]), /* @__PURE__ */ I(ve, { children: [
      /* @__PURE__ */ l(A.span, { id: d.textId, ...a, ref: v }),
      d.isSelected && i.valueNode && !i.valueNodeHasChildren && !cn(i.value) ? yt.createPortal(a.children, i.valueNode) : null
    ] });
  }
);
Ic.displayName = Dt;
var Dc = "SelectItemIndicator", kc = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return Ac(Dc, r).isSelected ? /* @__PURE__ */ l(A.span, { "aria-hidden": !0, ...n, ref: t }) : null;
  }
);
kc.displayName = Dc;
var Qn = "SelectScrollUpButton", Oc = s.forwardRef((e, t) => {
  const r = Ze(Qn, e.__scopeSelect), n = Wo(Qn, e.__scopeSelect), [o, a] = s.useState(!1), i = V(t, n.onScrollButtonChange);
  return oe(() => {
    if (r.viewport && r.isPositioned) {
      let c = function() {
        const u = d.scrollTop > 0;
        a(u);
      };
      const d = r.viewport;
      return c(), d.addEventListener("scroll", c), () => d.removeEventListener("scroll", c);
    }
  }, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ l(
    $c,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: d } = r;
        c && d && (c.scrollTop = c.scrollTop - d.offsetHeight);
      }
    }
  ) : null;
});
Oc.displayName = Qn;
var Jn = "SelectScrollDownButton", Lc = s.forwardRef((e, t) => {
  const r = Ze(Jn, e.__scopeSelect), n = Wo(Jn, e.__scopeSelect), [o, a] = s.useState(!1), i = V(t, n.onScrollButtonChange);
  return oe(() => {
    if (r.viewport && r.isPositioned) {
      let c = function() {
        const u = d.scrollHeight - d.clientHeight, p = Math.ceil(d.scrollTop) < u;
        a(p);
      };
      const d = r.viewport;
      return c(), d.addEventListener("scroll", c), () => d.removeEventListener("scroll", c);
    }
  }, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ l(
    $c,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: c, selectedItem: d } = r;
        c && d && (c.scrollTop = c.scrollTop + d.offsetHeight);
      }
    }
  ) : null;
});
Lc.displayName = Jn;
var $c = s.forwardRef((e, t) => {
  const { __scopeSelect: r, onAutoScroll: n, ...o } = e, a = Ze("SelectScrollButton", r), i = s.useRef(null), c = an(r), d = s.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return s.useEffect(() => () => d(), [d]), oe(() => {
    var p;
    const u = c().find((f) => f.ref.current === document.activeElement);
    (p = u == null ? void 0 : u.ref.current) == null || p.scrollIntoView({ block: "nearest" });
  }, [c]), /* @__PURE__ */ l(
    A.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: P(o.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerMove: P(o.onPointerMove, () => {
        var u;
        (u = a.onItemLeave) == null || u.call(a), i.current === null && (i.current = window.setInterval(n, 50));
      }),
      onPointerLeave: P(o.onPointerLeave, () => {
        d();
      })
    }
  );
}), Rb = "SelectSeparator", Nb = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return /* @__PURE__ */ l(A.div, { "aria-hidden": !0, ...n, ref: t });
  }
);
Nb.displayName = Rb;
var Fc = "SelectArrow", Eb = s.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = sn(r);
    return Ze(Fc, r).position === "popper" ? /* @__PURE__ */ l(Xt, { ...o, ...n, ref: t }) : null;
  }
);
Eb.displayName = Fc;
var Vc = "SelectBubbleInput", Bc = s.forwardRef(
  ({ __scopeSelect: e, ...t }, r) => {
    const n = qe(Vc, e), { value: o, onValueChange: a, required: i, disabled: c, name: d, autoComplete: u, form: p } = n, { nativeOptions: f, nativeSelectKey: m } = n, v = s.useRef(null), g = V(r, v), h = o ?? "", b = Gt(h), w = Array.from(f).some(
      (y) => (y.props.value ?? "") === ""
    );
    return s.useEffect(() => {
      const y = v.current;
      if (!y) return;
      const x = window.HTMLSelectElement.prototype, S = Object.getOwnPropertyDescriptor(
        x,
        "value"
      ).set;
      if (b !== h && S) {
        const R = new Event("change", { bubbles: !0 });
        S.call(y, h), y.dispatchEvent(R);
      }
    }, [b, h]), /* @__PURE__ */ I(
      A.select,
      {
        "aria-hidden": !0,
        required: i,
        tabIndex: -1,
        name: d,
        autoComplete: u,
        disabled: c,
        form: p,
        onChange: (y) => a(y.target.value),
        ...t,
        style: { ...sc, ...t.style },
        ref: g,
        defaultValue: h,
        children: [
          cn(o) && !w ? /* @__PURE__ */ l("option", { value: "" }) : null,
          Array.from(f)
        ]
      },
      m
    );
  }
);
Bc.displayName = Vc;
function Pb(e) {
  return typeof e == "function";
}
function cn(e) {
  return e === "" || e === void 0;
}
function zc(e) {
  const t = te(e), r = s.useRef(""), n = s.useRef(0), o = s.useCallback(
    (i) => {
      const c = r.current + i;
      t(c), (function d(u) {
        r.current = u, window.clearTimeout(n.current), u !== "" && (n.current = window.setTimeout(() => d(""), 1e3));
      })(c);
    },
    [t]
  ), a = s.useCallback(() => {
    r.current = "", window.clearTimeout(n.current);
  }, []);
  return s.useEffect(() => () => window.clearTimeout(n.current), []), [r, o, a];
}
function Hc(e, t, r) {
  const o = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = r ? e.indexOf(r) : -1;
  let i = Tb(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter((u) => u !== r));
  const d = i.find(
    (u) => u.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return d !== r ? d : void 0;
}
function Tb(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
const TS = vc, _S = _c, MS = wc, _b = s.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ I(
  Ho,
  {
    ref: n,
    className: N(
      "flex h-11 w-full items-center justify-between gap-2 rounded-lg border border-input bg-transparent px-3",
      "py-2 text-base shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-ring",
      "disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    ...r,
    children: [
      t,
      /* @__PURE__ */ l(yc, { asChild: !0, children: /* @__PURE__ */ l(Bt, { className: "size-4 opacity-60" }) })
    ]
  }
));
_b.displayName = Ho.displayName;
const Mb = s.forwardRef(({ className: e, children: t, position: r = "popper", ...n }, o) => /* @__PURE__ */ l(Cc, { children: /* @__PURE__ */ I(
  Go,
  {
    ref: o,
    position: r,
    className: N(
      "relative z-50 max-h-96 min-w-32 overflow-hidden rounded-lg border border-border bg-popover text-popover-foreground shadow-md",
      r === "popper" && "data-[side=bottom]:translate-y-1 data-[side=top]:-translate-y-1",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ l(Oc, { className: "flex items-center justify-center py-1", children: /* @__PURE__ */ l(Mm, { className: "size-4" }) }),
      /* @__PURE__ */ l(
        Pc,
        {
          className: N(
            "p-1",
            r === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ l(Lc, { className: "flex items-center justify-center py-1", children: /* @__PURE__ */ l(Bt, { className: "size-4" }) })
    ]
  }
) }));
Mb.displayName = Go.displayName;
const Ab = s.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ I(
  Uo,
  {
    ref: n,
    className: N(
      "relative flex w-full cursor-pointer select-none items-center rounded-md py-2 pl-8 pr-2 text-sm outline-none",
      "focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ l("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ l(kc, { children: /* @__PURE__ */ l(nt, { className: "size-4" }) }) }),
      /* @__PURE__ */ l(Ic, { children: t })
    ]
  }
));
Ab.displayName = Uo.displayName;
var ln = "Popover", [Gc] = ae(ln, [
  Ae
]), Zt = Ae(), [Ib, Qe] = Gc(ln), Wc = (e) => {
  const {
    __scopePopover: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    modal: i = !1
  } = e, c = Zt(t), d = s.useRef(null), [u, p] = s.useState(!1), [f, m] = ie({
    prop: n,
    defaultProp: o ?? !1,
    onChange: a,
    caller: ln
  });
  return /* @__PURE__ */ l(Rt, { ...c, children: /* @__PURE__ */ l(
    Ib,
    {
      scope: t,
      contentId: ce(),
      triggerRef: d,
      open: f,
      onOpenChange: m,
      onOpenToggle: s.useCallback(() => m((v) => !v), [m]),
      hasCustomAnchor: u,
      onCustomAnchorAdd: s.useCallback(() => p(!0), []),
      onCustomAnchorRemove: s.useCallback(() => p(!1), []),
      modal: i,
      children: r
    }
  ) });
};
Wc.displayName = ln;
var Uc = "PopoverAnchor", Kc = s.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Qe(Uc, r), a = Zt(r), { onCustomAnchorAdd: i, onCustomAnchorRemove: c } = o;
    return s.useEffect(() => (i(), () => c()), [i, c]), /* @__PURE__ */ l(Nt, { ...a, ...n, ref: t });
  }
);
Kc.displayName = Uc;
var jc = "PopoverTrigger", Yc = s.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Qe(jc, r), a = Zt(r), i = V(t, o.triggerRef), c = /* @__PURE__ */ l(
      A.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.open ? o.contentId : void 0,
        "data-state": Jc(o.open),
        ...n,
        ref: i,
        onClick: P(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? c : /* @__PURE__ */ l(Nt, { asChild: !0, ...a, children: c });
  }
);
Yc.displayName = jc;
var Ko = "PopoverPortal", [Db, kb] = Gc(Ko, {
  forceMount: void 0
}), Xc = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: o } = e, a = Qe(Ko, t);
  return /* @__PURE__ */ l(Db, { scope: t, forceMount: r, children: /* @__PURE__ */ l(ne, { present: r || a.open, children: /* @__PURE__ */ l(Xe, { asChild: !0, container: o, children: n }) }) });
};
Xc.displayName = Ko;
var gt = "PopoverContent", qc = s.forwardRef(
  (e, t) => {
    const r = kb(gt, e.__scopePopover), { forceMount: n = r.forceMount, ...o } = e, a = Qe(gt, e.__scopePopover);
    return /* @__PURE__ */ l(ne, { present: n || a.open, children: a.modal ? /* @__PURE__ */ l(Lb, { ...o, ref: t }) : /* @__PURE__ */ l($b, { ...o, ref: t }) });
  }
);
qc.displayName = gt;
var Ob = /* @__PURE__ */ Ge("PopoverContent.RemoveScroll"), Lb = s.forwardRef(
  (e, t) => {
    const r = Qe(gt, e.__scopePopover), n = s.useRef(null), o = V(t, n), a = s.useRef(!1);
    return s.useEffect(() => {
      const i = n.current;
      if (i) return rn(i);
    }, []), /* @__PURE__ */ l(qt, { as: Ob, allowPinchZoom: !0, children: /* @__PURE__ */ l(
      Zc,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: P(e.onCloseAutoFocus, (i) => {
          var c;
          i.preventDefault(), a.current || (c = r.triggerRef.current) == null || c.focus();
        }),
        onPointerDownOutside: P(
          e.onPointerDownOutside,
          (i) => {
            const c = i.detail.originalEvent, d = c.button === 0 && c.ctrlKey === !0, u = c.button === 2 || d;
            a.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: P(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), $b = s.forwardRef(
  (e, t) => {
    const r = Qe(gt, e.__scopePopover), n = s.useRef(!1), o = s.useRef(!1);
    return /* @__PURE__ */ l(
      Zc,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, c;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (n.current || (c = r.triggerRef.current) == null || c.focus(), a.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var d, u;
          (d = e.onInteractOutside) == null || d.call(e, a), a.defaultPrevented || (n.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = a.target;
          ((u = r.triggerRef.current) == null ? void 0 : u.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), Zc = s.forwardRef(
  (e, t) => {
    const {
      __scopePopover: r,
      trapFocus: n,
      onOpenAutoFocus: o,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: c,
      onPointerDownOutside: d,
      onFocusOutside: u,
      onInteractOutside: p,
      ...f
    } = e, m = Qe(gt, r), v = Zt(r);
    return qr(), /* @__PURE__ */ l(
      Kt,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: o,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ l(
          Ye,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: p,
            onEscapeKeyDown: c,
            onPointerDownOutside: d,
            onFocusOutside: u,
            onDismiss: () => m.onOpenChange(!1),
            deferPointerDownOutside: !0,
            children: /* @__PURE__ */ l(
              Yt,
              {
                "data-state": Jc(m.open),
                role: "dialog",
                id: m.contentId,
                ...v,
                ...f,
                ref: t,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Qc = "PopoverClose", Fb = s.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Qe(Qc, r);
    return /* @__PURE__ */ l(
      A.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: P(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Fb.displayName = Qc;
var Vb = "PopoverArrow", Bb = s.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Zt(r);
    return /* @__PURE__ */ l(Xt, { ...o, ...n, ref: t });
  }
);
Bb.displayName = Vb;
function Jc(e) {
  return e ? "open" : "closed";
}
var zb = Wc, Hb = Kc, Gb = Yc, Wb = Xc, el = qc;
const jo = zb, Yo = Gb, AS = Hb, dn = s.forwardRef(({ className: e, align: t = "center", sideOffset: r = 6, ...n }, o) => /* @__PURE__ */ l(Wb, { children: /* @__PURE__ */ l(
  el,
  {
    ref: o,
    align: t,
    sideOffset: r,
    className: N(
      "z-50 w-72 rounded-lg border border-border bg-popover p-4 text-popover-foreground shadow-md outline-none",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
      "data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      e
    ),
    ...n
  }
) }));
dn.displayName = el.displayName;
const Ub = me(
  "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        outline: "border-border text-foreground",
        success: "border-transparent bg-success text-success-foreground",
        warning: "border-transparent bg-warning text-warning-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: { variant: "default" }
  }
);
function eo({ className: e, variant: t, ...r }) {
  return /* @__PURE__ */ l("div", { className: N(Ub({ variant: t }), e), ...r });
}
const Kb = s.forwardRef(
  ({
    options: e,
    value: t,
    defaultValue: r = [],
    onChange: n,
    placeholder: o = "Select options",
    disabled: a,
    className: i,
    maxVisibleChips: c = 3
  }, d) => {
    const u = t !== void 0, [p, f] = s.useState(r), m = u ? t : p, [v, g] = s.useState(!1);
    function h(x) {
      const C = m.includes(x) ? m.filter((S) => S !== x) : [...m, x];
      u || f(C), n == null || n(C);
    }
    function b(x, C) {
      C.stopPropagation();
      const S = m.filter((R) => R !== x);
      u || f(S), n == null || n(S);
    }
    const w = m.slice(0, c), y = m.length - w.length;
    return /* @__PURE__ */ I(jo, { open: v, onOpenChange: g, children: [
      /* @__PURE__ */ l(Yo, { asChild: !0, children: /* @__PURE__ */ I(
        "button",
        {
          ref: d,
          type: "button",
          disabled: a,
          className: N(
            "flex min-h-11 w-full flex-wrap items-center gap-1.5 rounded-lg border border-input bg-transparent",
            "px-3 py-2 text-left text-base shadow-sm transition-colors focus-visible:outline-none",
            "focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            i
          ),
          children: [
            m.length === 0 && /* @__PURE__ */ l("span", { className: "text-muted-foreground", children: o }),
            w.map((x) => {
              const C = e.find((S) => S.value === x);
              return /* @__PURE__ */ I(eo, { variant: "secondary", className: "gap-1 pr-1", children: [
                (C == null ? void 0 : C.label) ?? x,
                /* @__PURE__ */ l(
                  "span",
                  {
                    role: "button",
                    tabIndex: -1,
                    onClick: (S) => b(x, S),
                    "aria-label": `Remove ${(C == null ? void 0 : C.label) ?? x}`,
                    className: "rounded-full hover:bg-black/10",
                    children: /* @__PURE__ */ l(Ht, { className: "size-3" })
                  }
                )
              ] }, x);
            }),
            y > 0 && /* @__PURE__ */ I(eo, { variant: "secondary", children: [
              "+",
              y
            ] }),
            /* @__PURE__ */ l(Bt, { className: "ml-auto size-4 shrink-0 opacity-60" })
          ]
        }
      ) }),
      /* @__PURE__ */ l(dn, { className: "w-[--radix-popover-trigger-width] p-1", align: "start", children: /* @__PURE__ */ l("ul", { role: "listbox", "aria-multiselectable": !0, className: "max-h-60 overflow-auto", children: e.map((x) => {
        const C = m.includes(x.value);
        return /* @__PURE__ */ I(
          "li",
          {
            role: "option",
            "aria-selected": C,
            onClick: () => !x.disabled && h(x.value),
            className: N(
              "flex cursor-pointer items-center gap-2 rounded-md px-2 py-2 text-sm",
              "hover:bg-accent hover:text-accent-foreground",
              x.disabled && "pointer-events-none opacity-50"
            ),
            children: [
              /* @__PURE__ */ l(
                "span",
                {
                  className: N(
                    "flex size-4 items-center justify-center rounded border border-input",
                    C && "border-primary bg-primary text-primary-foreground"
                  ),
                  children: C && /* @__PURE__ */ l(nt, { className: "size-3" })
                }
              ),
              x.label
            ]
          },
          x.value
        );
      }) }) })
    ] });
  }
);
Kb.displayName = "MultiSelect";
const jb = s.forwardRef(
  ({
    options: e,
    value: t,
    defaultValue: r,
    onChange: n,
    placeholder: o = "Select an option",
    searchPlaceholder: a = "Search…",
    emptyText: i = "No results found.",
    disabled: c,
    className: d
  }, u) => {
    var S;
    const p = t !== void 0, [f, m] = s.useState(r), v = p ? t : f, [g, h] = s.useState(!1), [b, w] = s.useState(""), y = e.filter(
      (R) => R.label.toLowerCase().includes(b.toLowerCase())
    );
    function x(R) {
      p || m(R), n == null || n(R), h(!1), w("");
    }
    const C = (S = e.find((R) => R.value === v)) == null ? void 0 : S.label;
    return /* @__PURE__ */ I(jo, { open: g, onOpenChange: h, children: [
      /* @__PURE__ */ l(Yo, { asChild: !0, children: /* @__PURE__ */ I(
        "button",
        {
          ref: u,
          type: "button",
          disabled: c,
          className: N(
            "flex h-11 w-full items-center justify-between gap-2 rounded-lg border border-input bg-transparent",
            "px-3 py-2 text-left text-base shadow-sm transition-colors focus-visible:outline-none",
            "focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            d
          ),
          children: [
            /* @__PURE__ */ l("span", { className: N(!C && "text-muted-foreground"), children: C ?? o }),
            /* @__PURE__ */ l(Bt, { className: "size-4 shrink-0 opacity-60" })
          ]
        }
      ) }),
      /* @__PURE__ */ I(dn, { className: "w-[--radix-popover-trigger-width] p-2", align: "start", children: [
        /* @__PURE__ */ l(
          Hr,
          {
            autoFocus: !0,
            value: b,
            onChange: (R) => w(R.target.value),
            placeholder: a,
            className: "mb-2 h-9"
          }
        ),
        /* @__PURE__ */ I("ul", { role: "listbox", className: "max-h-56 overflow-auto", children: [
          y.length === 0 && /* @__PURE__ */ l("li", { className: "px-2 py-2 text-sm text-muted-foreground", children: i }),
          y.map((R) => {
            const E = R.value === v;
            return /* @__PURE__ */ I(
              "li",
              {
                role: "option",
                "aria-selected": E,
                onClick: () => !R.disabled && x(R.value),
                className: N(
                  "flex cursor-pointer items-center gap-2 rounded-md px-2 py-2 text-sm",
                  "hover:bg-accent hover:text-accent-foreground",
                  R.disabled && "pointer-events-none opacity-50"
                ),
                children: [
                  /* @__PURE__ */ l(nt, { className: N("size-4", E ? "opacity-100" : "opacity-0") }),
                  R.label
                ]
              },
              R.value
            );
          })
        ] })
      ] })
    ] });
  }
);
jb.displayName = "Combobox";
var tl = ["PageUp", "PageDown"], rl = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], nl = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Et = "Slider", [to, Yb, Xb] = ot(Et), [Xo] = ae(Et, [
  Xb
]), [qb, Qt] = Xo(Et), qo = s.forwardRef(
  (e, t) => {
    const {
      name: r,
      min: n = 0,
      max: o = 100,
      step: a = 1,
      orientation: i = "horizontal",
      disabled: c = !1,
      minStepsBetweenThumbs: d = 0,
      defaultValue: u = [n],
      value: p,
      onValueChange: f = () => {
      },
      onValueCommit: m = () => {
      },
      inverted: v = !1,
      form: g,
      ...h
    } = e, b = s.useRef(/* @__PURE__ */ new Set()), w = s.useRef(0), y = s.useRef(!1), C = i === "horizontal" ? Zb : Qb, [S, R] = s.useState(null), E = V(t, R), [T = [], M] = ie({
      prop: p,
      defaultProp: u,
      onChange: ($) => {
        var F;
        (F = [...b.current][w.current]) == null || F.focus({
          preventScroll: !0,
          focusVisible: y.current
        }), y.current = !1, f($);
      }
    }), O = s.useRef(T), D = s.useRef(T);
    s.useEffect(() => {
      const $ = g ? S == null ? void 0 : S.ownerDocument.getElementById(g) : S == null ? void 0 : S.closest("form");
      if ($ instanceof HTMLFormElement) {
        const z = () => M(D.current);
        return $.addEventListener("reset", z), () => $.removeEventListener("reset", z);
      }
    }, [S, g, M]);
    function L($) {
      const z = rw(T, $);
      B($, z);
    }
    function H($) {
      B($, w.current);
    }
    function k() {
      const $ = O.current[w.current];
      T[w.current] !== $ && m(T);
    }
    function B($, z, { commit: F } = { commit: !1 }) {
      const _ = wl(a), U = Sr(Math.round(($ - n) / a) * a + n, _), K = Ot(U, [n, o]);
      M((j = []) => {
        const X = ew(j, K, z);
        if (aw(X, d * a)) {
          w.current = X.indexOf(K);
          const se = String(X) !== String(j);
          return se && F && m(X), se ? X : j;
        } else
          return j;
      });
    }
    return /* @__PURE__ */ l(
      qb,
      {
        scope: e.__scopeSlider,
        name: r,
        disabled: c,
        min: n,
        max: o,
        valueIndexToChangeRef: w,
        thumbs: b.current,
        values: T,
        orientation: i,
        form: g,
        children: /* @__PURE__ */ l(to.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ l(to.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ l(
          C,
          {
            "aria-disabled": c,
            "data-disabled": c ? "" : void 0,
            ...h,
            ref: E,
            onPointerDown: P(h.onPointerDown, () => {
              c || (O.current = T, y.current = !1);
            }),
            min: n,
            max: o,
            inverted: v,
            onSlideStart: c ? void 0 : L,
            onSlideMove: c ? void 0 : H,
            onSlideEnd: c ? void 0 : k,
            onHomeKeyDown: () => {
              c || (y.current = !0, B(n, 0, { commit: !0 }));
            },
            onEndKeyDown: () => {
              c || (y.current = !0, B(o, T.length - 1, { commit: !0 }));
            },
            onStepKeyDown: ({ event: $, direction: z }) => {
              if (!c) {
                y.current = !0;
                const U = tl.includes($.key) || $.shiftKey && rl.includes($.key) ? 10 : 1, K = w.current, j = T[K], X = sw(j, {
                  min: n,
                  step: a,
                  direction: z,
                  multiplier: U
                });
                B(X, K, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
qo.displayName = Et;
var [ol, al] = Xo(Et, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), Zb = s.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: n,
      dir: o,
      inverted: a,
      onSlideStart: i,
      onSlideMove: c,
      onSlideEnd: d,
      onStepKeyDown: u,
      ...p
    } = e, [f, m] = s.useState(null), v = V(t, m), g = s.useRef(void 0), h = Le(o), b = h === "ltr", w = b && !a || !b && a;
    function y(x) {
      const C = g.current || f.getBoundingClientRect(), S = [0, C.width], E = Zo(S, w ? [r, n] : [n, r]);
      return g.current = C, E(x - C.left);
    }
    return /* @__PURE__ */ l(
      ol,
      {
        scope: e.__scopeSlider,
        startEdge: w ? "left" : "right",
        endEdge: w ? "right" : "left",
        direction: w ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ l(
          sl,
          {
            dir: h,
            "data-orientation": "horizontal",
            ...p,
            ref: v,
            style: {
              ...p.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (x) => {
              const C = y(x.clientX);
              i == null || i(C);
            },
            onSlideMove: (x) => {
              const C = y(x.clientX);
              c == null || c(C);
            },
            onSlideEnd: () => {
              g.current = void 0, d == null || d();
            },
            onStepKeyDown: (x) => {
              const S = nl[w ? "from-left" : "from-right"].includes(x.key);
              u == null || u({ event: x, direction: S ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Qb = s.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: n,
      inverted: o,
      onSlideStart: a,
      onSlideMove: i,
      onSlideEnd: c,
      onStepKeyDown: d,
      ...u
    } = e, p = s.useRef(null), f = V(t, p), m = s.useRef(void 0), v = !o;
    function g(h) {
      const b = m.current || p.current.getBoundingClientRect(), w = [0, b.height], x = Zo(w, v ? [n, r] : [r, n]);
      return m.current = b, x(h - b.top);
    }
    return /* @__PURE__ */ l(
      ol,
      {
        scope: e.__scopeSlider,
        startEdge: v ? "bottom" : "top",
        endEdge: v ? "top" : "bottom",
        size: "height",
        direction: v ? 1 : -1,
        children: /* @__PURE__ */ l(
          sl,
          {
            "data-orientation": "vertical",
            ...u,
            ref: f,
            style: {
              ...u.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (h) => {
              const b = g(h.clientY);
              a == null || a(b);
            },
            onSlideMove: (h) => {
              const b = g(h.clientY);
              i == null || i(b);
            },
            onSlideEnd: () => {
              m.current = void 0, c == null || c();
            },
            onStepKeyDown: (h) => {
              const w = nl[v ? "from-bottom" : "from-top"].includes(h.key);
              d == null || d({ event: h, direction: w ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), sl = s.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: r,
      onSlideStart: n,
      onSlideMove: o,
      onSlideEnd: a,
      onHomeKeyDown: i,
      onEndKeyDown: c,
      onStepKeyDown: d,
      ...u
    } = e, p = Qt(Et, r);
    return /* @__PURE__ */ l(
      A.span,
      {
        ...u,
        ref: t,
        onKeyDown: P(e.onKeyDown, (f) => {
          f.key === "Home" ? (i(f), f.preventDefault()) : f.key === "End" ? (c(f), f.preventDefault()) : tl.concat(rl).includes(f.key) && (d(f), f.preventDefault());
        }),
        onPointerDown: P(e.onPointerDown, (f) => {
          const m = f.target;
          m.setPointerCapture(f.pointerId), f.preventDefault(), p.thumbs.has(m) ? m.focus({ preventScroll: !0, focusVisible: !1 }) : n(f);
        }),
        onPointerMove: P(e.onPointerMove, (f) => {
          f.target.hasPointerCapture(f.pointerId) && o(f);
        }),
        onPointerUp: P(e.onPointerUp, (f) => {
          const m = f.target;
          m.hasPointerCapture(f.pointerId) && (m.releasePointerCapture(f.pointerId), a(f));
        })
      }
    );
  }
), il = "SliderTrack", cl = s.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...n } = e, o = Qt(il, r);
    return /* @__PURE__ */ l(
      A.span,
      {
        "data-disabled": o.disabled ? "" : void 0,
        "data-orientation": o.orientation,
        ...n,
        ref: t
      }
    );
  }
);
cl.displayName = il;
var ro = "SliderRange", ll = s.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...n } = e, o = Qt(ro, r), a = al(ro, r), i = s.useRef(null), c = V(t, i), d = o.values.length, u = o.values.map(
      (m) => bl(m, o.min, o.max)
    ), p = d > 1 ? Math.min(...u) : 0, f = 100 - Math.max(...u);
    return /* @__PURE__ */ l(
      A.span,
      {
        "data-orientation": o.orientation,
        "data-disabled": o.disabled ? "" : void 0,
        ...n,
        ref: c,
        style: {
          ...e.style,
          [a.startEdge]: p + "%",
          [a.endEdge]: f + "%"
        }
      }
    );
  }
);
ll.displayName = ro;
var dl = "SliderThumb", [Jb, ul] = Xo(dl), fl = "SliderThumbProvider";
function pl(e) {
  const {
    __scopeSlider: t,
    name: r,
    children: n,
    // @ts-expect-error internal render prop
    internal_do_not_use_render: o
  } = e, a = Qt(fl, t), i = Yb(t), [c, d] = s.useState(null), u = s.useMemo(
    () => c ? i().findIndex((b) => b.ref.current === c) : -1,
    [i, c]
  ), p = Wt(c), f = c ? !!a.form || !!c.closest("form") : !0, m = a.values[u], v = r ?? (a.name ? a.name + (a.values.length > 1 ? "[]" : "") : void 0), g = m === void 0 ? 0 : bl(m, a.min, a.max);
  s.useEffect(() => {
    if (c)
      return a.thumbs.add(c), () => {
        a.thumbs.delete(c);
      };
  }, [c, a.thumbs]);
  const h = {
    value: m,
    name: v,
    form: a.form,
    isFormControl: f,
    index: u,
    thumb: c,
    onThumbChange: d,
    percent: g,
    size: p
  };
  return /* @__PURE__ */ l(Jb, { scope: t, ...h, children: iw(o) ? o(h) : n });
}
pl.displayName = fl;
var Cr = "SliderThumbTrigger", ml = s.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...n } = e, o = Qt(Cr, r), a = al(Cr, r), { index: i, value: c, percent: d, size: u, onThumbChange: p } = ul(
      Cr,
      r
    ), f = V(t, p), m = tw(i, o.values.length), v = u == null ? void 0 : u[a.size], g = v ? nw(v, d, a.direction) : 0;
    return /* @__PURE__ */ l(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [a.startEdge]: `calc(${d}% + ${g}px)`
        },
        children: /* @__PURE__ */ l(to.ItemSlot, { scope: r, children: /* @__PURE__ */ l(
          A.span,
          {
            role: "slider",
            "aria-label": e["aria-label"] || m,
            "aria-valuemin": o.min,
            "aria-valuenow": c,
            "aria-valuemax": o.max,
            "aria-orientation": o.orientation,
            "data-orientation": o.orientation,
            "data-disabled": o.disabled ? "" : void 0,
            tabIndex: o.disabled ? void 0 : 0,
            ...n,
            ref: f,
            style: c === void 0 ? { display: "none" } : e.style,
            onFocus: P(e.onFocus, () => {
              o.valueIndexToChangeRef.current = i;
            })
          }
        ) })
      }
    );
  }
);
ml.displayName = Cr;
var hl = s.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, name: n, ...o } = e;
    return /* @__PURE__ */ l(
      pl,
      {
        __scopeSlider: r,
        name: n,
        internal_do_not_use_render: ({ index: a, isFormControl: i }) => /* @__PURE__ */ I(ve, { children: [
          /* @__PURE__ */ l(
            ml,
            {
              ...o,
              ref: t,
              __scopeSlider: r
            }
          ),
          i ? /* @__PURE__ */ l(
            gl,
            {
              __scopeSlider: r
            },
            a
          ) : null
        ] })
      }
    );
  }
);
hl.displayName = dl;
var vl = "SliderBubbleInput", gl = s.forwardRef(
  ({ __scopeSlider: e, ...t }, r) => {
    const { value: n, name: o, form: a } = ul(vl, e), i = s.useRef(null), c = V(i, r), d = Gt(n);
    return s.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const p = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(p, "value").set;
      if (d !== n && m) {
        const v = new Event("input", { bubbles: !0 });
        m.call(u, n), u.dispatchEvent(v);
      }
    }, [d, n]), /* @__PURE__ */ l(
      A.input,
      {
        style: { display: "none" },
        name: o,
        form: a,
        ...t,
        ref: c,
        defaultValue: n
      }
    );
  }
);
gl.displayName = vl;
function ew(e = [], t, r) {
  const n = [...e];
  return n[r] = t, n.sort((o, a) => o - a);
}
function bl(e, t, r) {
  const a = 100 / (r - t) * (e - t);
  return Ot(a, [0, 100]);
}
function tw(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function rw(e, t) {
  if (e.length === 1) return 0;
  const r = e.map((o) => Math.abs(o - t)), n = Math.min(...r);
  return r.indexOf(n);
}
function nw(e, t, r) {
  const n = e / 2, a = Zo([0, 50], [0, n]);
  return (n - a(t) * r) * r;
}
function ow(e) {
  return e.slice(0, -1).map((t, r) => e[r + 1] - t);
}
function aw(e, t) {
  if (t > 0) {
    const r = ow(e);
    return Math.min(...r) >= t;
  }
  return !0;
}
function Zo(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function wl(e) {
  if (!Number.isFinite(e)) return 0;
  const t = e.toString();
  if (t.includes("e")) {
    const [n, o] = t.split("e"), a = n.split(".")[1] || "", i = Number(o);
    return Math.max(0, a.length - i);
  }
  const r = t.split(".")[1];
  return r ? r.length : 0;
}
function Sr(e, t) {
  const r = Math.pow(10, t);
  return Math.round(e * r) / r;
}
function sw(e, {
  min: t,
  step: r,
  direction: n,
  multiplier: o
}) {
  const a = wl(r), i = (e - t) / r, c = Math.round(i), d = Sr(c * r + t, a) === Sr(e, a);
  let u;
  return d ? u = c + o * n : n > 0 ? u = Math.ceil(i) : u = Math.floor(i), Sr(u * r + t, a);
}
function iw(e) {
  return typeof e == "function";
}
const cw = s.forwardRef(({ className: e, ...t }, r) => {
  const n = t.value ?? t.defaultValue ?? [0];
  return /* @__PURE__ */ I(
    qo,
    {
      ref: r,
      className: N(
        "relative flex w-full touch-none select-none items-center",
        e
      ),
      ...t,
      children: [
        /* @__PURE__ */ l(cl, { className: "relative h-1.5 w-full grow overflow-hidden rounded-full bg-muted", children: /* @__PURE__ */ l(ll, { className: "absolute h-full bg-primary" }) }),
        n.map((o, a) => /* @__PURE__ */ l(
          hl,
          {
            className: N(
              "block h-5 w-5 rounded-full border-2 border-primary bg-background shadow transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              "disabled:pointer-events-none disabled:opacity-50"
            )
          },
          a
        ))
      ]
    }
  );
});
cw.displayName = qo.displayName;
const lw = me(
  "relative flex w-full gap-3 rounded-lg border p-4 text-sm [&>svg]:size-5 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "border-border bg-background text-foreground",
        info: "border-info/30 bg-info/10 text-foreground [&>svg]:text-info",
        success: "border-success/30 bg-success/10 text-foreground [&>svg]:text-success",
        warning: "border-warning/30 bg-warning/10 text-foreground [&>svg]:text-warning",
        destructive: "border-destructive/30 bg-destructive/10 text-foreground [&>svg]:text-destructive"
      }
    },
    defaultVariants: { variant: "default" }
  }
), dw = {
  default: ja,
  info: ja,
  success: Am,
  warning: Hm,
  destructive: Im
}, uw = s.forwardRef(
  ({ className: e, variant: t = "default", showIcon: r = !0, children: n, ...o }, a) => {
    const i = dw[t ?? "default"];
    return /* @__PURE__ */ I("div", { ref: a, role: "alert", className: N(lw({ variant: t }), e), ...o, children: [
      r && /* @__PURE__ */ l(i, { "aria-hidden": !0 }),
      /* @__PURE__ */ l("div", { className: "flex-1", children: n })
    ] });
  }
);
uw.displayName = "Alert";
const fw = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l("h5", { ref: r, className: N("mb-1 font-medium leading-none", e), ...t }));
fw.displayName = "AlertTitle";
const pw = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l("div", { ref: r, className: N("text-muted-foreground [&_p]:leading-relaxed", e), ...t }));
pw.displayName = "AlertDescription";
var Qo = "ToastProvider", [Jo, mw, hw] = ot("Toast"), [yl] = ae("Toast", [hw]), [vw, un] = yl(Qo), xl = (e) => {
  const {
    __scopeToast: t,
    label: r = "Notification",
    duration: n = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: a = 50,
    announcerContainer: i,
    children: c
  } = e, [d, u] = s.useState(null), [p, f] = s.useState(0), m = s.useRef(!1), v = s.useRef(!1);
  return r.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Qo}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ l(Jo.Provider, { scope: t, children: /* @__PURE__ */ l(
    vw,
    {
      scope: t,
      label: r,
      duration: n,
      swipeDirection: o,
      swipeThreshold: a,
      toastCount: p,
      viewport: d,
      onViewportChange: u,
      onToastAdd: s.useCallback(() => f((g) => g + 1), []),
      onToastRemove: s.useCallback(() => f((g) => g - 1), []),
      isFocusedToastEscapeKeyDownRef: m,
      isClosePausedRef: v,
      announcerContainer: i,
      children: c
    }
  ) });
};
xl.displayName = Qo;
var Cl = "ToastViewport", gw = ["F8"], no = "toast.viewportPause", oo = "toast.viewportResume", Sl = s.forwardRef(
  (e, t) => {
    const {
      __scopeToast: r,
      hotkey: n = gw,
      label: o = "Notifications ({hotkey})",
      ...a
    } = e, i = un(Cl, r), c = mw(r), d = s.useRef(null), u = s.useRef(null), p = s.useRef(null), f = s.useRef(null), m = V(t, f, i.onViewportChange), v = n.join("+").replace(/Key/g, "").replace(/Digit/g, ""), g = i.toastCount > 0;
    s.useEffect(() => {
      const b = (w) => {
        var x;
        n.length !== 0 && n.every((C) => w[C] || w.code === C) && ((x = f.current) == null || x.focus());
      };
      return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
    }, [n]), s.useEffect(() => {
      const b = d.current, w = f.current;
      if (g && b && w) {
        const y = () => {
          if (!i.isClosePausedRef.current) {
            const R = new CustomEvent(no);
            w.dispatchEvent(R), i.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (i.isClosePausedRef.current) {
            const R = new CustomEvent(oo);
            w.dispatchEvent(R), i.isClosePausedRef.current = !1;
          }
        }, C = (R) => {
          !b.contains(R.relatedTarget) && x();
        }, S = () => {
          b.contains(document.activeElement) || x();
        };
        return b.addEventListener("focusin", y), b.addEventListener("focusout", C), b.addEventListener("pointermove", y), b.addEventListener("pointerleave", S), window.addEventListener("blur", y), window.addEventListener("focus", x), () => {
          b.removeEventListener("focusin", y), b.removeEventListener("focusout", C), b.removeEventListener("pointermove", y), b.removeEventListener("pointerleave", S), window.removeEventListener("blur", y), window.removeEventListener("focus", x);
        };
      }
    }, [g, i.isClosePausedRef]);
    const h = s.useCallback(
      ({ tabbingDirection: b }) => {
        const y = c().map((x) => {
          const C = x.ref.current, S = [C, ...Mw(C)];
          return b === "forwards" ? S : S.reverse();
        });
        return (b === "forwards" ? y.reverse() : y).flat();
      },
      [c]
    );
    return s.useEffect(() => {
      const b = f.current;
      if (b) {
        const w = (y) => {
          var S, R, E;
          const x = y.altKey || y.ctrlKey || y.metaKey;
          if (y.key === "Tab" && !x) {
            const T = document.activeElement, M = y.shiftKey;
            if (y.target === b && M) {
              (S = u.current) == null || S.focus();
              return;
            }
            const L = h({ tabbingDirection: M ? "backwards" : "forwards" }), H = L.findIndex((k) => k === T);
            Vn(L.slice(H + 1)) ? y.preventDefault() : M ? (R = u.current) == null || R.focus() : (E = p.current) == null || E.focus();
          }
        };
        return b.addEventListener("keydown", w), () => b.removeEventListener("keydown", w);
      }
    }, [c, h]), /* @__PURE__ */ I(
      Zh,
      {
        ref: d,
        role: "region",
        "aria-label": o.replace("{hotkey}", v),
        tabIndex: -1,
        style: { pointerEvents: g ? void 0 : "none" },
        children: [
          g && /* @__PURE__ */ l(
            ao,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const b = h({
                  tabbingDirection: "forwards"
                });
                Vn(b);
              }
            }
          ),
          /* @__PURE__ */ l(Jo.Slot, { scope: r, children: /* @__PURE__ */ l(A.ol, { tabIndex: -1, ...a, ref: m }) }),
          g && /* @__PURE__ */ l(
            ao,
            {
              ref: p,
              onFocusFromOutsideViewport: () => {
                const b = h({
                  tabbingDirection: "backwards"
                });
                Vn(b);
              }
            }
          )
        ]
      }
    );
  }
);
Sl.displayName = Cl;
var Rl = "ToastFocusProxy", ao = s.forwardRef(
  (e, t) => {
    const { __scopeToast: r, onFocusFromOutsideViewport: n, ...o } = e, a = un(Rl, r);
    return /* @__PURE__ */ l(
      tn,
      {
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (i) => {
          var u;
          const c = i.relatedTarget;
          !((u = a.viewport) != null && u.contains(c)) && n();
        }
      }
    );
  }
);
ao.displayName = Rl;
var Jt = "Toast", bw = "toast.swipeStart", ww = "toast.swipeMove", yw = "toast.swipeCancel", xw = "toast.swipeEnd", Nl = s.forwardRef(
  (e, t) => {
    const { forceMount: r, open: n, defaultOpen: o, onOpenChange: a, ...i } = e, [c, d] = ie({
      prop: n,
      defaultProp: o ?? !0,
      onChange: a,
      caller: Jt
    });
    return /* @__PURE__ */ l(ne, { present: r || c, children: /* @__PURE__ */ l(
      Rw,
      {
        open: c,
        ...i,
        ref: t,
        onClose: () => d(!1),
        onPause: te(e.onPause),
        onResume: te(e.onResume),
        onSwipeStart: P(e.onSwipeStart, (u) => {
          u.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: P(e.onSwipeMove, (u) => {
          const { x: p, y: f } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "move"), u.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${p}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${f}px`);
        }),
        onSwipeCancel: P(e.onSwipeCancel, (u) => {
          u.currentTarget.setAttribute("data-swipe", "cancel"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: P(e.onSwipeEnd, (u) => {
          const { x: p, y: f } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "end"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${p}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${f}px`), d(!1);
        })
      }
    ) });
  }
);
Nl.displayName = Jt;
var [Cw, Sw] = yl(Jt, {
  onClose() {
  }
}), Rw = s.forwardRef(
  (e, t) => {
    const {
      __scopeToast: r,
      type: n = "foreground",
      duration: o,
      open: a,
      onClose: i,
      onEscapeKeyDown: c,
      onPause: d,
      onResume: u,
      onSwipeStart: p,
      onSwipeMove: f,
      onSwipeCancel: m,
      onSwipeEnd: v,
      ...g
    } = e, h = un(Jt, r), [b, w] = s.useState(null), y = V(t, w), x = s.useRef(null), C = s.useRef(null), S = o || h.duration, R = s.useRef(0), E = s.useRef(S), T = s.useRef(0), { onToastAdd: M, onToastRemove: O } = h, D = te(() => {
      var B;
      (b == null ? void 0 : b.contains(document.activeElement)) && ((B = h.viewport) == null || B.focus()), i();
    }), L = s.useCallback(
      (k) => {
        !k || k === 1 / 0 || (window.clearTimeout(T.current), R.current = (/* @__PURE__ */ new Date()).getTime(), T.current = window.setTimeout(D, k));
      },
      [D]
    );
    s.useEffect(() => {
      const k = h.viewport;
      if (k) {
        const B = () => {
          L(E.current), u == null || u();
        }, $ = () => {
          const z = (/* @__PURE__ */ new Date()).getTime() - R.current;
          E.current = E.current - z, window.clearTimeout(T.current), d == null || d();
        };
        return k.addEventListener(no, $), k.addEventListener(oo, B), () => {
          k.removeEventListener(no, $), k.removeEventListener(oo, B);
        };
      }
    }, [h.viewport, S, d, u, L]), s.useEffect(() => {
      a && !h.isClosePausedRef.current && L(S);
    }, [a, S, h.isClosePausedRef, L]), s.useEffect(() => () => {
      window.clearTimeout(T.current);
    }, []), s.useEffect(() => (M(), () => O()), [M, O]);
    const H = s.useMemo(() => b ? Il(b) : null, [b]);
    return h.viewport ? /* @__PURE__ */ I(ve, { children: [
      H && /* @__PURE__ */ l(
        Nw,
        {
          __scopeToast: r,
          role: "status",
          "aria-live": n === "foreground" ? "assertive" : "polite",
          children: H
        }
      ),
      /* @__PURE__ */ l(Cw, { scope: r, onClose: D, children: yt.createPortal(
        /* @__PURE__ */ l(Jo.ItemSlot, { scope: r, children: /* @__PURE__ */ l(
          qh,
          {
            asChild: !0,
            onEscapeKeyDown: P(c, () => {
              h.isFocusedToastEscapeKeyDownRef.current || D(), h.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ l(
              A.li,
              {
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": h.swipeDirection,
                ...g,
                ref: y,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: P(e.onKeyDown, (k) => {
                  k.key === "Escape" && (c == null || c(k.nativeEvent), k.nativeEvent.defaultPrevented || (h.isFocusedToastEscapeKeyDownRef.current = !0, D()));
                }),
                onPointerDown: P(e.onPointerDown, (k) => {
                  k.button === 0 && (x.current = { x: k.clientX, y: k.clientY });
                }),
                onPointerMove: P(e.onPointerMove, (k) => {
                  if (!x.current) return;
                  const B = k.clientX - x.current.x, $ = k.clientY - x.current.y, z = !!C.current, F = ["left", "right"].includes(h.swipeDirection), _ = ["left", "up"].includes(h.swipeDirection) ? Math.min : Math.max, U = F ? _(0, B) : 0, K = F ? 0 : _(0, $), j = k.pointerType === "touch" ? 10 : 2, X = { x: U, y: K }, se = { originalEvent: k, delta: X };
                  z ? (C.current = X, gr(ww, f, se, {
                    discrete: !1
                  })) : gs(X, h.swipeDirection, j) ? (C.current = X, gr(bw, p, se, {
                    discrete: !1
                  }), k.target.setPointerCapture(k.pointerId)) : (Math.abs(B) > j || Math.abs($) > j) && (x.current = null);
                }),
                onPointerUp: P(e.onPointerUp, (k) => {
                  const B = C.current, $ = k.target;
                  if ($.hasPointerCapture(k.pointerId) && $.releasePointerCapture(k.pointerId), C.current = null, x.current = null, B) {
                    const z = k.currentTarget, F = { originalEvent: k, delta: B };
                    gs(B, h.swipeDirection, h.swipeThreshold) ? gr(xw, v, F, {
                      discrete: !0
                    }) : gr(
                      yw,
                      m,
                      F,
                      {
                        discrete: !0
                      }
                    ), z.addEventListener("click", (_) => _.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        h.viewport
      ) })
    ] }) : null;
  }
), Nw = (e) => {
  const { __scopeToast: t, children: r, ...n } = e, o = un(Jt, t), [a, i] = s.useState(!1), [c, d] = s.useState(!1);
  return Tw(() => i(!0)), s.useEffect(() => {
    const u = window.setTimeout(() => d(!0), 1e3);
    return () => window.clearTimeout(u);
  }, []), c ? null : /* @__PURE__ */ l(Xe, { asChild: !0, container: o.announcerContainer || void 0, children: /* @__PURE__ */ l(tn, { ...n, children: a && /* @__PURE__ */ I(ve, { children: [
    o.label,
    " ",
    r
  ] }) }) });
}, Ew = "ToastTitle", El = s.forwardRef(
  (e, t) => {
    const { __scopeToast: r, ...n } = e;
    return /* @__PURE__ */ l(A.div, { ...n, ref: t });
  }
);
El.displayName = Ew;
var Pw = "ToastDescription", Pl = s.forwardRef(
  (e, t) => {
    const { __scopeToast: r, ...n } = e;
    return /* @__PURE__ */ l(A.div, { ...n, ref: t });
  }
);
Pl.displayName = Pw;
var Tl = "ToastAction", _l = s.forwardRef(
  (e, t) => {
    const { altText: r, ...n } = e;
    return r.trim() ? /* @__PURE__ */ l(Al, { altText: r, asChild: !0, children: /* @__PURE__ */ l(ea, { ...n, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${Tl}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
_l.displayName = Tl;
var Ml = "ToastClose", ea = s.forwardRef(
  (e, t) => {
    const { __scopeToast: r, ...n } = e, o = Sw(Ml, r);
    return /* @__PURE__ */ l(Al, { asChild: !0, children: /* @__PURE__ */ l(
      A.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: P(e.onClick, o.onClose)
      }
    ) });
  }
);
ea.displayName = Ml;
var Al = s.forwardRef((e, t) => {
  const { __scopeToast: r, altText: n, ...o } = e;
  return /* @__PURE__ */ l(
    A.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": n || void 0,
      ...o,
      ref: t
    }
  );
});
function Il(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((n) => {
    if (n.nodeType === n.TEXT_NODE && n.textContent && t.push(n.textContent), _w(n)) {
      const o = n.ariaHidden || n.hidden || n.style.display === "none", a = n.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (a) {
          const i = n.dataset.radixToastAnnounceAlt;
          i && t.push(i);
        } else
          t.push(...Il(n));
    }
  }), t;
}
function gr(e, t, r, { discrete: n }) {
  const o = r.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? bo(o, a) : o.dispatchEvent(a);
}
var gs = (e, t, r = 0) => {
  const n = Math.abs(e.x), o = Math.abs(e.y), a = n > o;
  return t === "left" || t === "right" ? a && n > r : !a && o > r;
};
function Tw(e = () => {
}) {
  const t = te(e);
  oe(() => {
    let r = 0, n = 0;
    return r = window.requestAnimationFrame(() => n = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(r), window.cancelAnimationFrame(n);
    };
  }, [t]);
}
function _w(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function Mw(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Vn(e) {
  const t = document.activeElement;
  return e.some((r) => r === t ? !0 : (r.focus(), document.activeElement !== t));
}
var Aw = xl, Dl = Sl, kl = Nl, Ol = El, Ll = Pl, Iw = _l, $l = ea;
const Dw = Aw, Fl = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  Dl,
  {
    ref: r,
    className: N(
      "fixed bottom-0 right-0 z-[100] flex max-h-screen w-full flex-col gap-2 p-4 sm:max-w-sm",
      e
    ),
    ...t
  }
));
Fl.displayName = Dl.displayName;
const kw = me(
  "group relative flex w-full items-start gap-3 overflow-hidden rounded-lg border p-4 shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-80 data-[swipe=end]:animate-out data-[state=open]:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border-border bg-background text-foreground",
        success: "border-success/30 bg-success/10 text-foreground",
        warning: "border-warning/30 bg-warning/10 text-foreground",
        destructive: "border-destructive/30 bg-destructive/10 text-foreground"
      }
    },
    defaultVariants: { variant: "default" }
  }
), Vl = s.forwardRef(({ className: e, variant: t, ...r }, n) => /* @__PURE__ */ l(kl, { ref: n, className: N(kw({ variant: t }), e), ...r }));
Vl.displayName = kl.displayName;
const Bl = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(Ol, { ref: r, className: N("text-sm font-semibold", e), ...t }));
Bl.displayName = Ol.displayName;
const zl = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(Ll, { ref: r, className: N("text-sm opacity-90", e), ...t }));
zl.displayName = Ll.displayName;
const Hl = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  $l,
  {
    ref: r,
    "aria-label": "Close",
    className: N(
      "absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity",
      "hover:text-foreground focus:opacity-100 focus:outline-none group-hover:opacity-100",
      e
    ),
    ...t,
    children: /* @__PURE__ */ l(Ht, { className: "size-4" })
  }
));
Hl.displayName = $l.displayName;
const IS = Iw;
let Rr = [], ze = [];
function so() {
  Rr.forEach((e) => e(ze));
}
function DS(e) {
  const t = e.id ?? crypto.randomUUID();
  return ze = [...ze, { ...e, id: t, open: !0 }], so(), t;
}
function Ow(e) {
  ze = ze.map((t) => t.id === e ? { ...t, open: !1 } : t), so(), setTimeout(() => {
    ze = ze.filter((t) => t.id !== e), so();
  }, 200);
}
function Lw() {
  const [e, t] = s.useState(ze);
  return s.useEffect(() => (Rr.push(t), () => {
    Rr = Rr.filter((r) => r !== t);
  }), []), e;
}
function kS() {
  const e = Lw();
  return /* @__PURE__ */ I(Dw, { swipeDirection: "right", children: [
    e.map(({ id: t, title: r, description: n, action: o, duration: a = 5e3, variant: i }) => /* @__PURE__ */ I(
      Vl,
      {
        variant: i,
        duration: a,
        onOpenChange: (c) => !c && Ow(t),
        children: [
          /* @__PURE__ */ I("div", { className: "grid gap-1", children: [
            r && /* @__PURE__ */ l(Bl, { children: r }),
            n && /* @__PURE__ */ l(zl, { children: n })
          ] }),
          o,
          /* @__PURE__ */ l(Hl, {})
        ]
      },
      t
    )),
    /* @__PURE__ */ l(Fl, {})
  ] });
}
var ta = "Progress", ra = 100, [$w] = ae(ta), [Fw, Vw] = $w(ta), Gl = s.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: r,
      value: n = null,
      max: o,
      getValueLabel: a = Bw,
      ...i
    } = e;
    (o || o === 0) && !bs(o) && console.error(zw(`${o}`, "Progress"));
    const c = bs(o) ? o : ra;
    n !== null && !ws(n, c) && console.error(Hw(`${n}`, "Progress"));
    const d = ws(n, c) ? n : null, u = Dr(d) ? a(d, c) : void 0;
    return /* @__PURE__ */ l(Fw, { scope: r, value: d, max: c, children: /* @__PURE__ */ l(
      A.div,
      {
        "aria-valuemax": c,
        "aria-valuemin": 0,
        "aria-valuenow": Dr(d) ? d : void 0,
        "aria-valuetext": u,
        role: "progressbar",
        "data-state": Kl(d, c),
        "data-value": d ?? void 0,
        "data-max": c,
        ...i,
        ref: t
      }
    ) });
  }
);
Gl.displayName = ta;
var Wl = "ProgressIndicator", Ul = s.forwardRef(
  (e, t) => {
    const { __scopeProgress: r, ...n } = e, o = Vw(Wl, r);
    return /* @__PURE__ */ l(
      A.div,
      {
        "data-state": Kl(o.value, o.max),
        "data-value": o.value ?? void 0,
        "data-max": o.max,
        ...n,
        ref: t
      }
    );
  }
);
Ul.displayName = Wl;
function Bw(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function Kl(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function Dr(e) {
  return typeof e == "number";
}
function bs(e) {
  return Dr(e) && !isNaN(e) && e > 0;
}
function ws(e, t) {
  return Dr(e) && !isNaN(e) && e <= t && e >= 0;
}
function zw(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${ra}\`.`;
}
function Hw(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${ra} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var jl = Gl, Gw = Ul;
const Yl = s.forwardRef(({ className: e, value: t = 0, indicatorClassName: r, ...n }, o) => /* @__PURE__ */ l(
  jl,
  {
    ref: o,
    className: N("relative h-2.5 w-full overflow-hidden rounded-full bg-muted", e),
    ...n,
    children: /* @__PURE__ */ l(
      Gw,
      {
        className: N("h-full flex-1 bg-primary transition-transform duration-300 ease-out", r),
        style: { transform: `translateX(-${100 - Math.min(100, Math.max(0, t))}%)` }
      }
    )
  }
));
Yl.displayName = jl.displayName;
const Ww = me("animate-spin rounded-full border-current border-t-transparent", {
  variants: {
    size: {
      sm: "h-4 w-4 border-2",
      md: "h-6 w-6 border-2",
      lg: "h-10 w-10 border-[3px]"
    }
  },
  defaultVariants: { size: "md" }
});
function OS({ className: e, size: t, label: r = "Loading…", ...n }) {
  return /* @__PURE__ */ I("span", { role: "status", className: N("inline-flex text-primary", e), ...n, children: [
    /* @__PURE__ */ l("span", { className: N(Ww({ size: t })) }),
    /* @__PURE__ */ l("span", { className: "sr-only", children: r })
  ] });
}
function Uw({ className: e, ...t }) {
  return /* @__PURE__ */ l("div", { className: N("animate-pulse rounded-md bg-muted", e), ...t });
}
var fn = "Dialog", [Xl] = ae(fn), [Kw, Ce] = Xl(fn), pn = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    modal: i = !0
  } = e, c = s.useRef(null), d = s.useRef(null), [u, p] = ie({
    prop: n,
    defaultProp: o ?? !1,
    onChange: a,
    caller: fn
  });
  return /* @__PURE__ */ l(
    Kw,
    {
      scope: t,
      triggerRef: c,
      contentRef: d,
      contentId: ce(),
      titleId: ce(),
      descriptionId: ce(),
      open: u,
      onOpenChange: p,
      onOpenToggle: s.useCallback(() => p((f) => !f), [p]),
      modal: i,
      children: r
    }
  );
};
pn.displayName = fn;
var ql = "DialogTrigger", mn = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Ce(ql, r), a = V(t, o.triggerRef);
    return /* @__PURE__ */ l(
      A.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.open ? o.contentId : void 0,
        "data-state": aa(o.open),
        ...n,
        ref: a,
        onClick: P(e.onClick, o.onOpenToggle)
      }
    );
  }
);
mn.displayName = ql;
var na = "DialogPortal", [jw, Zl] = Xl(na, {
  forceMount: void 0
}), Ql = (e) => {
  const { __scopeDialog: t, forceMount: r, children: n, container: o } = e, a = Ce(na, t);
  return /* @__PURE__ */ l(jw, { scope: t, forceMount: r, children: s.Children.map(n, (i) => /* @__PURE__ */ l(ne, { present: r || a.open, children: /* @__PURE__ */ l(Xe, { asChild: !0, container: o, children: i }) })) });
};
Ql.displayName = na;
var kr = "DialogOverlay", oa = s.forwardRef(
  (e, t) => {
    const r = Zl(kr, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, a = Ce(kr, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ l(ne, { present: n || a.open, children: /* @__PURE__ */ l(Xw, { ...o, ref: t }) }) : null;
  }
);
oa.displayName = kr;
var Yw = /* @__PURE__ */ Ge("DialogOverlay.RemoveScroll"), Xw = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Ce(kr, r), a = Kh(), i = V(t, a);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ l(qt, { as: Yw, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ l(
        A.div,
        {
          "data-state": aa(o.open),
          ...n,
          ref: i,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), bt = "DialogContent", er = s.forwardRef(
  (e, t) => {
    const r = Zl(bt, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, a = Ce(bt, e.__scopeDialog);
    return /* @__PURE__ */ l(ne, { present: n || a.open, children: a.modal ? /* @__PURE__ */ l(qw, { ...o, ref: t }) : /* @__PURE__ */ l(Zw, { ...o, ref: t }) });
  }
);
er.displayName = bt;
var qw = s.forwardRef(
  (e, t) => {
    const r = Ce(bt, e.__scopeDialog), n = s.useRef(null), o = V(t, r.contentRef, n);
    return s.useEffect(() => {
      const a = n.current;
      if (a) return rn(a);
    }, []), /* @__PURE__ */ l(
      Jl,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: r.open,
        onCloseAutoFocus: P(e.onCloseAutoFocus, (a) => {
          var i;
          a.preventDefault(), (i = r.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: P(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, c = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || c) && a.preventDefault();
        }),
        onFocusOutside: P(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), Zw = s.forwardRef(
  (e, t) => {
    const r = Ce(bt, e.__scopeDialog), n = s.useRef(!1), o = s.useRef(!1);
    return /* @__PURE__ */ l(
      Jl,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, c;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (n.current || (c = r.triggerRef.current) == null || c.focus(), a.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var d, u;
          (d = e.onInteractOutside) == null || d.call(e, a), a.defaultPrevented || (n.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = a.target;
          ((u = r.triggerRef.current) == null ? void 0 : u.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), Jl = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: o, onCloseAutoFocus: a, ...i } = e, c = Ce(bt, r);
    return qr(), /* @__PURE__ */ l(ve, { children: /* @__PURE__ */ l(
      Kt,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: o,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ l(
          Ye,
          {
            role: "dialog",
            id: c.contentId,
            "aria-describedby": c.descriptionId,
            "aria-labelledby": c.titleId,
            "data-state": aa(c.open),
            ...i,
            ref: t,
            deferPointerDownOutside: !0,
            onDismiss: () => c.onOpenChange(!1)
          }
        )
      }
    ) });
  }
), ed = "DialogTitle", tr = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Ce(ed, r);
    return /* @__PURE__ */ l(A.h2, { id: o.titleId, ...n, ref: t });
  }
);
tr.displayName = ed;
var td = "DialogDescription", rr = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Ce(td, r);
    return /* @__PURE__ */ l(A.p, { id: o.descriptionId, ...n, ref: t });
  }
);
rr.displayName = td;
var rd = "DialogClose", Pt = s.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Ce(rd, r);
    return /* @__PURE__ */ l(
      A.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: P(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Pt.displayName = rd;
function aa(e) {
  return e ? "open" : "closed";
}
const LS = pn, $S = mn, sa = Ql, FS = Pt, hn = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  oa,
  {
    ref: r,
    className: N(
      "fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out",
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
hn.displayName = oa.displayName;
const Qw = s.forwardRef(({ className: e, children: t, hideClose: r, ...n }, o) => /* @__PURE__ */ I(sa, { children: [
  /* @__PURE__ */ l(hn, {}),
  /* @__PURE__ */ I(
    er,
    {
      ref: o,
      className: N(
        "fixed left-1/2 top-1/2 z-50 grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4",
        "rounded-xl border border-border bg-card p-6 text-card-foreground shadow-lg duration-200",
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
        "data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        e
      ),
      ...n,
      children: [
        t,
        !r && /* @__PURE__ */ I(Pt, { className: "absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring", children: [
          /* @__PURE__ */ l(Ht, { className: "size-4" }),
          /* @__PURE__ */ l("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Qw.displayName = er.displayName;
function VS({ className: e, ...t }) {
  return /* @__PURE__ */ l("div", { className: N("flex flex-col gap-1.5 text-center sm:text-left", e), ...t });
}
function BS({ className: e, ...t }) {
  return /* @__PURE__ */ l(
    "div",
    {
      className: N("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", e),
      ...t
    }
  );
}
const Jw = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(tr, { ref: r, className: N("text-lg font-semibold", e), ...t }));
Jw.displayName = tr.displayName;
const ey = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  rr,
  {
    ref: r,
    className: N("text-sm text-muted-foreground", e),
    ...t
  }
));
ey.displayName = rr.displayName;
const zS = pn, HS = mn, GS = Pt, ty = s.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ I(sa, { children: [
  /* @__PURE__ */ l(hn, {}),
  /* @__PURE__ */ I(
    er,
    {
      ref: n,
      className: N(
        "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto max-h-[85vh] flex-col rounded-t-2xl border-t",
        "border-border bg-card p-6 text-card-foreground shadow-lg",
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:slide-out-to-bottom",
        "data-[state=open]:slide-in-from-bottom data-[state=closed]:duration-300 data-[state=open]:duration-500",
        e
      ),
      ...r,
      children: [
        /* @__PURE__ */ l("div", { className: "mx-auto mb-4 h-1.5 w-12 shrink-0 rounded-full bg-muted", "aria-hidden": !0 }),
        t
      ]
    }
  )
] }));
ty.displayName = "DrawerContent";
function WS({ className: e, ...t }) {
  return /* @__PURE__ */ l("div", { className: N("grid gap-1.5 text-center sm:text-left", e), ...t });
}
function US({ className: e, ...t }) {
  return /* @__PURE__ */ l("div", { className: N("mt-auto flex flex-col gap-2 pt-4", e), ...t });
}
const ry = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(tr, { ref: r, className: N("text-lg font-semibold", e), ...t }));
ry.displayName = "DrawerTitle";
const ny = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(rr, { ref: r, className: N("text-sm text-muted-foreground", e), ...t }));
ny.displayName = "DrawerDescription";
const KS = pn, jS = mn, YS = Pt, oy = me(
  "fixed z-50 gap-4 border-border bg-card p-6 text-card-foreground shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: { side: "right" }
  }
), ay = s.forwardRef(({ side: e = "right", className: t, children: r, ...n }, o) => /* @__PURE__ */ I(sa, { children: [
  /* @__PURE__ */ l(hn, {}),
  /* @__PURE__ */ I(er, { ref: o, className: N(oy({ side: e }), t), ...n, children: [
    r,
    /* @__PURE__ */ I(Pt, { className: "absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring", children: [
      /* @__PURE__ */ l(Ht, { className: "size-4" }),
      /* @__PURE__ */ l("span", { className: "sr-only", children: "Close" })
    ] })
  ] })
] }));
ay.displayName = "SheetContent";
function XS({ className: e, ...t }) {
  return /* @__PURE__ */ l("div", { className: N("flex flex-col gap-1.5 text-center sm:text-left", e), ...t });
}
function qS({ className: e, ...t }) {
  return /* @__PURE__ */ l("div", { className: N("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", e), ...t });
}
const sy = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(tr, { ref: r, className: N("text-lg font-semibold", e), ...t }));
sy.displayName = "SheetTitle";
const iy = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(rr, { ref: r, className: N("text-sm text-muted-foreground", e), ...t }));
iy.displayName = "SheetDescription";
var [vn] = ae("Tooltip", [
  Ae
]), gn = Ae(), nd = "TooltipProvider", cy = 700, io = "tooltip.open", [ly, ia] = vn(nd), od = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: r = cy,
    skipDelayDuration: n = 300,
    disableHoverableContent: o = !1,
    children: a
  } = e, i = s.useRef(!0), c = s.useRef(!1), d = s.useRef(0);
  return s.useEffect(() => {
    const u = d.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ l(
    ly,
    {
      scope: t,
      isOpenDelayedRef: i,
      delayDuration: r,
      onOpen: s.useCallback(() => {
        n <= 0 || (window.clearTimeout(d.current), i.current = !1);
      }, [n]),
      onClose: s.useCallback(() => {
        n <= 0 || (window.clearTimeout(d.current), d.current = window.setTimeout(
          () => i.current = !0,
          n
        ));
      }, [n]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: s.useCallback((u) => {
        c.current = u;
      }, []),
      disableHoverableContent: o,
      children: a
    }
  );
};
od.displayName = nd;
var $t = "Tooltip", [dy, nr] = vn($t), ad = (e) => {
  const {
    __scopeTooltip: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    disableHoverableContent: i,
    delayDuration: c
  } = e, d = ia($t, e.__scopeTooltip), u = gn(t), [p, f] = s.useState(null), m = ce(), v = s.useRef(0), g = i ?? d.disableHoverableContent, h = c ?? d.delayDuration, b = s.useRef(!1), [w, y] = ie({
    prop: n,
    defaultProp: o ?? !1,
    onChange: (E) => {
      E ? (d.onOpen(), document.dispatchEvent(new CustomEvent(io))) : d.onClose(), a == null || a(E);
    },
    caller: $t
  }), x = s.useMemo(() => w ? b.current ? "delayed-open" : "instant-open" : "closed", [w]), C = s.useCallback(() => {
    window.clearTimeout(v.current), v.current = 0, b.current = !1, y(!0);
  }, [y]), S = s.useCallback(() => {
    window.clearTimeout(v.current), v.current = 0, y(!1);
  }, [y]), R = s.useCallback(() => {
    window.clearTimeout(v.current), v.current = window.setTimeout(() => {
      b.current = !0, y(!0), v.current = 0;
    }, h);
  }, [h, y]);
  return s.useEffect(() => () => {
    v.current && (window.clearTimeout(v.current), v.current = 0);
  }, []), /* @__PURE__ */ l(Rt, { ...u, children: /* @__PURE__ */ l(
    dy,
    {
      scope: t,
      contentId: m,
      open: w,
      stateAttribute: x,
      trigger: p,
      onTriggerChange: f,
      onTriggerEnter: s.useCallback(() => {
        d.isOpenDelayedRef.current ? R() : C();
      }, [d.isOpenDelayedRef, R, C]),
      onTriggerLeave: s.useCallback(() => {
        g ? S() : (window.clearTimeout(v.current), v.current = 0);
      }, [S, g]),
      onOpen: C,
      onClose: S,
      disableHoverableContent: g,
      children: r
    }
  ) });
};
ad.displayName = $t;
var co = "TooltipTrigger", sd = s.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, o = nr(co, r), a = ia(co, r), i = gn(r), c = s.useRef(null), d = V(t, c, o.onTriggerChange), u = s.useRef(!1), p = s.useRef(!1), f = s.useCallback(() => u.current = !1, []);
    return s.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ l(Nt, { asChild: !0, ...i, children: /* @__PURE__ */ l(
      A.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...n,
        ref: d,
        onPointerMove: P(e.onPointerMove, (m) => {
          m.pointerType !== "touch" && !p.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), p.current = !0);
        }),
        onPointerLeave: P(e.onPointerLeave, () => {
          o.onTriggerLeave(), p.current = !1;
        }),
        onPointerDown: P(e.onPointerDown, () => {
          o.open && o.onClose(), u.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: P(e.onFocus, () => {
          u.current || o.onOpen();
        }),
        onBlur: P(e.onBlur, o.onClose),
        onClick: P(e.onClick, o.onClose)
      }
    ) });
  }
);
sd.displayName = co;
var ca = "TooltipPortal", [uy, fy] = vn(ca, {
  forceMount: void 0
}), id = (e) => {
  const { __scopeTooltip: t, forceMount: r, children: n, container: o } = e, a = nr(ca, t);
  return /* @__PURE__ */ l(uy, { scope: t, forceMount: r, children: /* @__PURE__ */ l(ne, { present: r || a.open, children: /* @__PURE__ */ l(Xe, { asChild: !0, container: o, children: n }) }) });
};
id.displayName = ca;
var wt = "TooltipContent", cd = s.forwardRef(
  (e, t) => {
    const r = fy(wt, e.__scopeTooltip), { forceMount: n = r.forceMount, side: o = "top", ...a } = e, i = nr(wt, e.__scopeTooltip);
    return /* @__PURE__ */ l(ne, { present: n || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ l(ld, { side: o, ...a, ref: t }) : /* @__PURE__ */ l(py, { side: o, ...a, ref: t }) });
  }
), py = s.forwardRef((e, t) => {
  const r = nr(wt, e.__scopeTooltip), n = ia(wt, e.__scopeTooltip), o = s.useRef(null), a = V(t, o), [i, c] = s.useState(null), { trigger: d, onClose: u } = r, p = o.current, { onPointerInTransitChange: f } = n, m = s.useCallback(() => {
    c(null), f(!1);
  }, [f]), v = s.useCallback(
    (g, h) => {
      const b = g.currentTarget, w = { x: g.clientX, y: g.clientY }, y = by(w, b.getBoundingClientRect()), x = wy(w, y), C = yy(h.getBoundingClientRect()), S = Cy([...x, ...C]);
      c(S), f(!0);
    },
    [f]
  );
  return s.useEffect(() => () => m(), [m]), s.useEffect(() => {
    if (d && p) {
      const g = (b) => v(b, p), h = (b) => v(b, d);
      return d.addEventListener("pointerleave", g), p.addEventListener("pointerleave", h), () => {
        d.removeEventListener("pointerleave", g), p.removeEventListener("pointerleave", h);
      };
    }
  }, [d, p, v, m]), s.useEffect(() => {
    if (i) {
      const g = (h) => {
        const b = h.target, w = { x: h.clientX, y: h.clientY }, y = (d == null ? void 0 : d.contains(b)) || (p == null ? void 0 : p.contains(b)), x = !xy(w, i);
        y ? m() : x && (m(), u());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [d, p, i, u, m]), /* @__PURE__ */ l(ld, { ...e, ref: a });
}), [my, hy] = vn($t, { isInside: !1 }), vy = /* @__PURE__ */ ks("TooltipContent"), ld = s.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: r,
      children: n,
      "aria-label": o,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      ...c
    } = e, d = nr(wt, r), u = gn(r), { onClose: p } = d;
    return s.useEffect(() => (document.addEventListener(io, p), () => document.removeEventListener(io, p)), [p]), s.useEffect(() => {
      if (d.trigger) {
        const f = (m) => {
          m.target instanceof Node && m.target.contains(d.trigger) && p();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [d.trigger, p]), /* @__PURE__ */ l(
      Ye,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: i,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: p,
        children: /* @__PURE__ */ I(
          Yt,
          {
            "data-state": d.stateAttribute,
            ...u,
            ...c,
            ref: t,
            style: {
              ...c.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ l(vy, { children: n }),
              /* @__PURE__ */ l(my, { scope: r, isInside: !0, children: /* @__PURE__ */ l(wg, { id: d.contentId, role: "tooltip", children: o || n }) })
            ]
          }
        )
      }
    );
  }
);
cd.displayName = wt;
var dd = "TooltipArrow", gy = s.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, o = gn(r);
    return hy(
      dd,
      r
    ).isInside ? null : /* @__PURE__ */ l(Xt, { ...o, ...n, ref: t });
  }
);
gy.displayName = dd;
function by(e, t) {
  const r = Math.abs(t.top - e.y), n = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(r, n, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case r:
      return "top";
    case n:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function wy(e, t, r = 5) {
  const n = [];
  switch (t) {
    case "top":
      n.push(
        { x: e.x - r, y: e.y + r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "bottom":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x + r, y: e.y - r }
      );
      break;
    case "left":
      n.push(
        { x: e.x + r, y: e.y - r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "right":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x - r, y: e.y + r }
      );
      break;
  }
  return n;
}
function yy(e) {
  const { top: t, right: r, bottom: n, left: o } = e;
  return [
    { x: o, y: t },
    { x: r, y: t },
    { x: r, y: n },
    { x: o, y: n }
  ];
}
function xy(e, t) {
  const { x: r, y: n } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const c = t[a], d = t[i], u = c.x, p = c.y, f = d.x, m = d.y;
    p > n != m > n && r < (f - u) * (n - p) / (m - p) + u && (o = !o);
  }
  return o;
}
function Cy(e) {
  const t = e.slice();
  return t.sort((r, n) => r.x < n.x ? -1 : r.x > n.x ? 1 : r.y < n.y ? -1 : r.y > n.y ? 1 : 0), Sy(t);
}
function Sy(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const r = [];
  for (let n = e.length - 1; n >= 0; n--) {
    const o = e[n];
    for (; r.length >= 2; ) {
      const a = r[r.length - 1], i = r[r.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x)) r.pop();
      else break;
    }
    r.push(o);
  }
  return r.pop(), t.length === 1 && r.length === 1 && t[0].x === r[0].x && t[0].y === r[0].y ? t : t.concat(r);
}
var Ry = od, Ny = ad, Ey = sd, Py = id, ud = cd;
const ZS = Ry, QS = Ny, JS = Ey, Ty = s.forwardRef(({ className: e, sideOffset: t = 6, ...r }, n) => /* @__PURE__ */ l(Py, { children: /* @__PURE__ */ l(
  ud,
  {
    ref: n,
    sideOffset: t,
    className: N(
      "z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground shadow-md",
      "data-[state=delayed-open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
      "data-[state=delayed-open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=delayed-open]:zoom-in-95",
      e
    ),
    ...r
  }
) }));
Ty.displayName = ud.displayName;
var Bn, bn = "HoverCard", [fd] = ae(bn, [
  Ae
]), wn = Ae(), [_y, yn] = fd(bn), pd = (e) => {
  const {
    __scopeHoverCard: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    openDelay: i = 700,
    closeDelay: c = 300
  } = e, d = wn(t), u = s.useRef(0), p = s.useRef(0), f = s.useRef(!1), m = s.useRef(!1), [v, g] = ie({
    prop: n,
    defaultProp: o ?? !1,
    onChange: a,
    caller: bn
  }), h = s.useCallback(() => {
    clearTimeout(p.current), u.current = window.setTimeout(() => g(!0), i);
  }, [i, g]), b = s.useCallback(() => {
    clearTimeout(u.current), !f.current && !m.current && (p.current = window.setTimeout(() => g(!1), c));
  }, [c, g]), w = s.useCallback(() => g(!1), [g]);
  return s.useEffect(() => () => {
    clearTimeout(u.current), clearTimeout(p.current);
  }, []), /* @__PURE__ */ l(
    _y,
    {
      scope: t,
      open: v,
      onOpenChange: g,
      onOpen: h,
      onClose: b,
      onDismiss: w,
      hasSelectionRef: f,
      isPointerDownOnContentRef: m,
      children: /* @__PURE__ */ l(Rt, { ...d, children: r })
    }
  );
};
pd.displayName = bn;
var md = "HoverCardTrigger", hd = s.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: r, ...n } = e, o = yn(md, r), a = wn(r);
    return /* @__PURE__ */ l(Nt, { asChild: !0, ...a, children: /* @__PURE__ */ l(
      A.a,
      {
        "data-state": o.open ? "open" : "closed",
        ...n,
        ref: t,
        onPointerEnter: P(e.onPointerEnter, Lr(o.onOpen)),
        onPointerLeave: P(e.onPointerLeave, Lr(o.onClose)),
        onFocus: P(e.onFocus, o.onOpen),
        onBlur: P(e.onBlur, o.onClose),
        onTouchStart: P(e.onTouchStart, (i) => i.preventDefault())
      }
    ) });
  }
);
hd.displayName = md;
var la = "HoverCardPortal", [My, Ay] = fd(la, {
  forceMount: void 0
}), vd = (e) => {
  const { __scopeHoverCard: t, forceMount: r, children: n, container: o } = e, a = yn(la, t);
  return /* @__PURE__ */ l(My, { scope: t, forceMount: r, children: /* @__PURE__ */ l(ne, { present: r || a.open, children: /* @__PURE__ */ l(Xe, { asChild: !0, container: o, children: n }) }) });
};
vd.displayName = la;
var Or = "HoverCardContent", gd = s.forwardRef(
  (e, t) => {
    const r = Ay(Or, e.__scopeHoverCard), { forceMount: n = r.forceMount, ...o } = e, a = yn(Or, e.__scopeHoverCard);
    return /* @__PURE__ */ l(ne, { present: n || a.open, children: /* @__PURE__ */ l(
      Iy,
      {
        "data-state": a.open ? "open" : "closed",
        ...o,
        onPointerEnter: P(e.onPointerEnter, Lr(a.onOpen)),
        onPointerLeave: P(e.onPointerLeave, Lr(a.onClose)),
        ref: t
      }
    ) });
  }
);
gd.displayName = Or;
var Iy = s.forwardRef((e, t) => {
  const {
    __scopeHoverCard: r,
    onEscapeKeyDown: n,
    onPointerDownOutside: o,
    onFocusOutside: a,
    onInteractOutside: i,
    ...c
  } = e, d = yn(Or, r), u = wn(r), p = s.useRef(null), f = V(t, p), [m, v] = s.useState(!1);
  return s.useEffect(() => {
    if (m) {
      const g = document.body;
      return Bn = g.style.userSelect || g.style.webkitUserSelect, g.style.userSelect = "none", g.style.webkitUserSelect = "none", () => {
        g.style.userSelect = Bn, g.style.webkitUserSelect = Bn;
      };
    }
  }, [m]), s.useEffect(() => {
    if (p.current) {
      const g = () => {
        v(!1), d.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var b;
          ((b = document.getSelection()) == null ? void 0 : b.toString()) !== "" && (d.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", g), () => {
        document.removeEventListener("pointerup", g), d.hasSelectionRef.current = !1, d.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [d.isPointerDownOnContentRef, d.hasSelectionRef]), s.useEffect(() => {
    p.current && Oy(p.current).forEach((h) => h.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ l(
    Ye,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: i,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: P(a, (g) => {
        g.preventDefault();
      }),
      onDismiss: d.onDismiss,
      children: /* @__PURE__ */ l(
        Yt,
        {
          ...u,
          ...c,
          onPointerDown: P(c.onPointerDown, (g) => {
            g.currentTarget.contains(g.target) && v(!0), d.hasSelectionRef.current = !1, d.isPointerDownOnContentRef.current = !0;
          }),
          ref: f,
          style: {
            ...c.style,
            userSelect: m ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: m ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), Dy = "HoverCardArrow", ky = s.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: r, ...n } = e, o = wn(r);
    return /* @__PURE__ */ l(Xt, { ...o, ...n, ref: t });
  }
);
ky.displayName = Dy;
function Lr(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function Oy(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
var Ly = pd, $y = hd, Fy = vd, bd = gd;
const eR = Ly, tR = $y, Vy = s.forwardRef(({ className: e, align: t = "center", sideOffset: r = 6, ...n }, o) => /* @__PURE__ */ l(Fy, { children: /* @__PURE__ */ l(
  bd,
  {
    ref: o,
    align: t,
    sideOffset: r,
    className: N(
      "z-50 w-64 rounded-lg border border-border bg-popover p-4 text-popover-foreground shadow-md outline-none",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
      "data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      e
    ),
    ...n
  }
) }));
Vy.displayName = bd.displayName;
var xn = "Tabs", [By] = ae(xn, [
  je
]), wd = je(), [zy, da] = By(xn), yd = s.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: r,
      value: n,
      onValueChange: o,
      defaultValue: a,
      orientation: i = "horizontal",
      dir: c,
      activationMode: d = "automatic",
      ...u
    } = e, p = Le(c), [f, m] = ie({
      prop: n,
      onChange: o,
      defaultProp: a ?? "",
      caller: xn
    });
    return /* @__PURE__ */ l(
      zy,
      {
        scope: r,
        baseId: ce(),
        value: f,
        onValueChange: m,
        orientation: i,
        dir: p,
        activationMode: d,
        children: /* @__PURE__ */ l(
          A.div,
          {
            dir: p,
            "data-orientation": i,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
yd.displayName = xn;
var xd = "TabsList", Cd = s.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, loop: n = !0, ...o } = e, a = da(xd, r), i = wd(r);
    return /* @__PURE__ */ l(
      Wr,
      {
        asChild: !0,
        ...i,
        orientation: a.orientation,
        dir: a.dir,
        loop: n,
        children: /* @__PURE__ */ l(
          A.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
Cd.displayName = xd;
var Sd = "TabsTrigger", Rd = s.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: n, disabled: o = !1, ...a } = e, i = da(Sd, r), c = wd(r), d = Pd(i.baseId, n), u = Td(i.baseId, n), p = n === i.value;
    return /* @__PURE__ */ l(
      Ur,
      {
        asChild: !0,
        ...c,
        focusable: !o,
        active: p,
        children: /* @__PURE__ */ l(
          A.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": p,
            "aria-controls": u,
            "data-state": p ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: d,
            ...a,
            ref: t,
            onMouseDown: P(e.onMouseDown, (f) => {
              !o && f.button === 0 && f.ctrlKey === !1 ? i.onValueChange(n) : f.preventDefault();
            }),
            onKeyDown: P(e.onKeyDown, (f) => {
              o || f.target !== f.currentTarget || [" ", "Enter"].includes(f.key) && i.onValueChange(n);
            }),
            onFocus: P(e.onFocus, () => {
              const f = i.activationMode !== "manual";
              !p && !o && f && i.onValueChange(n);
            })
          }
        )
      }
    );
  }
);
Rd.displayName = Sd;
var Nd = "TabsContent", Ed = s.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: n, forceMount: o, children: a, ...i } = e, c = da(Nd, r), d = Pd(c.baseId, n), u = Td(c.baseId, n), p = n === c.value, f = s.useRef(p);
    return s.useEffect(() => {
      const m = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(m);
    }, []), /* @__PURE__ */ l(ne, { present: o || p, children: ({ present: m }) => /* @__PURE__ */ l(
      A.div,
      {
        "data-state": p ? "active" : "inactive",
        "data-orientation": c.orientation,
        role: "tabpanel",
        "aria-labelledby": d,
        hidden: !m,
        id: u,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: m && a
      }
    ) });
  }
);
Ed.displayName = Nd;
function Pd(e, t) {
  return `${e}-trigger-${t}`;
}
function Td(e, t) {
  return `${e}-content-${t}`;
}
var Hy = yd, _d = Cd, Md = Rd, Ad = Ed;
const rR = Hy, Gy = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  _d,
  {
    ref: r,
    className: N(
      "inline-flex h-11 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground",
      e
    ),
    ...t
  }
));
Gy.displayName = _d.displayName;
const Wy = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  Md,
  {
    ref: r,
    className: N(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium",
      "transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      "disabled:pointer-events-none disabled:opacity-50",
      "data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm",
      e
    ),
    ...t
  }
));
Wy.displayName = Md.displayName;
const Uy = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  Ad,
  {
    ref: r,
    className: N(
      "mt-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      e
    ),
    ...t
  }
));
Uy.displayName = Ad.displayName;
var Cn = "Collapsible", [Ky, Id] = ae(Cn), [jy, ua] = Ky(Cn), Dd = s.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: r,
      open: n,
      defaultOpen: o,
      disabled: a,
      onOpenChange: i,
      ...c
    } = e, [d, u] = ie({
      prop: n,
      defaultProp: o ?? !1,
      onChange: i,
      caller: Cn
    });
    return /* @__PURE__ */ l(
      jy,
      {
        scope: r,
        disabled: a,
        contentId: ce(),
        open: d,
        onOpenToggle: s.useCallback(() => u((p) => !p), [u]),
        children: /* @__PURE__ */ l(
          A.div,
          {
            "data-state": pa(d),
            "data-disabled": a ? "" : void 0,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
Dd.displayName = Cn;
var kd = "CollapsibleTrigger", Od = s.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: r, ...n } = e, o = ua(kd, r);
    return /* @__PURE__ */ l(
      A.button,
      {
        type: "button",
        "aria-controls": o.open ? o.contentId : void 0,
        "aria-expanded": o.open || !1,
        "data-state": pa(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...n,
        ref: t,
        onClick: P(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Od.displayName = kd;
var fa = "CollapsibleContent", Ld = s.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, o = ua(fa, e.__scopeCollapsible);
    return /* @__PURE__ */ l(ne, { present: r || o.open, children: ({ present: a }) => /* @__PURE__ */ l(Yy, { ...n, ref: t, present: a }) });
  }
);
Ld.displayName = fa;
var Yy = s.forwardRef((e, t) => {
  const { __scopeCollapsible: r, present: n, children: o, ...a } = e, i = ua(fa, r), [c, d] = s.useState(n), u = s.useRef(null), p = V(t, u), f = s.useRef(0), m = f.current, v = s.useRef(0), g = v.current, h = i.open || c, b = s.useRef(h), w = s.useRef(void 0);
  return s.useEffect(() => {
    const y = requestAnimationFrame(() => b.current = !1);
    return () => cancelAnimationFrame(y);
  }, []), oe(() => {
    const y = u.current;
    if (y) {
      w.current = w.current || {
        transitionDuration: y.style.transitionDuration,
        animationName: y.style.animationName
      }, y.style.transitionDuration = "0s", y.style.animationName = "none";
      const x = y.getBoundingClientRect();
      f.current = x.height, v.current = x.width, b.current || (y.style.transitionDuration = w.current.transitionDuration, y.style.animationName = w.current.animationName), d(n);
    }
  }, [i.open, n]), /* @__PURE__ */ l(
    A.div,
    {
      "data-state": pa(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !h,
      ...a,
      ref: p,
      style: {
        "--radix-collapsible-content-height": m ? `${m}px` : void 0,
        "--radix-collapsible-content-width": g ? `${g}px` : void 0,
        ...e.style
      },
      children: h && o
    }
  );
});
function pa(e) {
  return e ? "open" : "closed";
}
var Xy = Dd, qy = Od, Zy = Ld, Se = "Accordion", Qy = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [ma, Jy, ex] = ot(Se), [Sn] = ae(Se, [
  ex,
  Id
]), ha = Id(), $d = s.forwardRef(
  (e, t) => {
    const { type: r, ...n } = e, o = n, a = n;
    return /* @__PURE__ */ l(ma.Provider, { scope: e.__scopeAccordion, children: r === "multiple" ? /* @__PURE__ */ l(ox, { ...a, ref: t }) : /* @__PURE__ */ l(nx, { ...o, ref: t }) });
  }
);
$d.displayName = Se;
var [Fd, tx] = Sn(Se), [Vd, rx] = Sn(
  Se,
  { collapsible: !1 }
), nx = s.forwardRef(
  (e, t) => {
    const {
      value: r,
      defaultValue: n,
      onValueChange: o = () => {
      },
      collapsible: a = !1,
      ...i
    } = e, [c, d] = ie({
      prop: r,
      defaultProp: n ?? "",
      onChange: o,
      caller: Se
    });
    return /* @__PURE__ */ l(
      Fd,
      {
        scope: e.__scopeAccordion,
        value: s.useMemo(() => c ? [c] : [], [c]),
        onItemOpen: d,
        onItemClose: s.useCallback(() => a && d(""), [a, d]),
        children: /* @__PURE__ */ l(Vd, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ l(Bd, { ...i, ref: t }) })
      }
    );
  }
), ox = s.forwardRef((e, t) => {
  const {
    value: r,
    defaultValue: n,
    onValueChange: o = () => {
    },
    ...a
  } = e, [i, c] = ie({
    prop: r,
    defaultProp: n ?? [],
    onChange: o,
    caller: Se
  }), d = s.useCallback(
    (p) => c((f = []) => [...f, p]),
    [c]
  ), u = s.useCallback(
    (p) => c((f = []) => f.filter((m) => m !== p)),
    [c]
  );
  return /* @__PURE__ */ l(
    Fd,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: d,
      onItemClose: u,
      children: /* @__PURE__ */ l(Vd, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ l(Bd, { ...a, ref: t }) })
    }
  );
}), [ax, Rn] = Sn(Se), Bd = s.forwardRef(
  (e, t) => {
    const { __scopeAccordion: r, disabled: n, dir: o, orientation: a = "vertical", ...i } = e, c = s.useRef(null), d = V(c, t), u = Jy(r), f = Le(o) === "ltr", m = P(e.onKeyDown, (v) => {
      var T;
      if (!Qy.includes(v.key)) return;
      const g = v.target, h = u().filter((M) => {
        var O;
        return !((O = M.ref.current) != null && O.disabled);
      }), b = h.findIndex((M) => M.ref.current === g), w = h.length;
      if (b === -1) return;
      v.preventDefault();
      let y = b;
      const x = 0, C = w - 1, S = () => {
        y = b + 1, y > C && (y = x);
      }, R = () => {
        y = b - 1, y < x && (y = C);
      };
      switch (v.key) {
        case "Home":
          y = x;
          break;
        case "End":
          y = C;
          break;
        case "ArrowRight":
          a === "horizontal" && (f ? S() : R());
          break;
        case "ArrowDown":
          a === "vertical" && S();
          break;
        case "ArrowLeft":
          a === "horizontal" && (f ? R() : S());
          break;
        case "ArrowUp":
          a === "vertical" && R();
          break;
      }
      const E = y % w;
      (T = h[E].ref.current) == null || T.focus();
    });
    return /* @__PURE__ */ l(
      ax,
      {
        scope: r,
        disabled: n,
        direction: o,
        orientation: a,
        children: /* @__PURE__ */ l(ma.Slot, { scope: r, children: /* @__PURE__ */ l(
          A.div,
          {
            ...i,
            "data-orientation": a,
            ref: d,
            onKeyDown: n ? void 0 : m
          }
        ) })
      }
    );
  }
), $r = "AccordionItem", [sx, va] = Sn($r), zd = s.forwardRef(
  (e, t) => {
    const { __scopeAccordion: r, value: n, ...o } = e, a = Rn($r, r), i = tx($r, r), c = ha(r), d = ce(), u = n && i.value.includes(n) || !1, p = a.disabled || e.disabled;
    return /* @__PURE__ */ l(
      sx,
      {
        scope: r,
        open: u,
        disabled: p,
        triggerId: d,
        children: /* @__PURE__ */ l(
          Xy,
          {
            "data-orientation": a.orientation,
            "data-state": jd(u),
            ...c,
            ...o,
            ref: t,
            disabled: p,
            open: u,
            onOpenChange: (f) => {
              f ? i.onItemOpen(n) : i.onItemClose(n);
            }
          }
        )
      }
    );
  }
);
zd.displayName = $r;
var Hd = "AccordionHeader", Gd = s.forwardRef(
  (e, t) => {
    const { __scopeAccordion: r, ...n } = e, o = Rn(Se, r), a = va(Hd, r);
    return /* @__PURE__ */ l(
      A.h3,
      {
        "data-orientation": o.orientation,
        "data-state": jd(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    );
  }
);
Gd.displayName = Hd;
var lo = "AccordionTrigger", Wd = s.forwardRef(
  (e, t) => {
    const { __scopeAccordion: r, ...n } = e, o = Rn(Se, r), a = va(lo, r), i = rx(lo, r), c = ha(r);
    return /* @__PURE__ */ l(ma.ItemSlot, { scope: r, children: /* @__PURE__ */ l(
      qy,
      {
        "aria-disabled": a.open && !i.collapsible || void 0,
        "data-orientation": o.orientation,
        id: a.triggerId,
        ...c,
        ...n,
        ref: t
      }
    ) });
  }
);
Wd.displayName = lo;
var Ud = "AccordionContent", Kd = s.forwardRef(
  (e, t) => {
    const { __scopeAccordion: r, ...n } = e, o = Rn(Se, r), a = va(Ud, r), i = ha(r);
    return /* @__PURE__ */ l(
      Zy,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": o.orientation,
        ...i,
        ...n,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
Kd.displayName = Ud;
function jd(e) {
  return e ? "open" : "closed";
}
var ix = $d, cx = zd, lx = Gd, Yd = Wd, Xd = Kd;
const nR = ix, dx = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(cx, { ref: r, className: N("border-b border-border", e), ...t }));
dx.displayName = "AccordionItem";
const ux = s.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ l(lx, { className: "flex", children: /* @__PURE__ */ I(
  Yd,
  {
    ref: n,
    className: N(
      "flex flex-1 items-center justify-between py-4 text-left text-sm font-medium transition-all",
      "hover:underline [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...r,
    children: [
      t,
      /* @__PURE__ */ l(Bt, { className: "size-4 shrink-0 text-muted-foreground transition-transform duration-200" })
    ]
  }
) }));
ux.displayName = Yd.displayName;
const fx = s.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ l(
  Xd,
  {
    ref: n,
    className: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...r,
    children: /* @__PURE__ */ l("div", { className: N("pb-4 pt-0", e), children: t })
  }
));
fx.displayName = Xd.displayName;
const px = s.forwardRef(({ ...e }, t) => /* @__PURE__ */ l("nav", { ref: t, "aria-label": "breadcrumb", ...e }));
px.displayName = "Breadcrumb";
const mx = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  "ol",
  {
    ref: r,
    className: N(
      "flex flex-wrap items-center gap-1.5 break-words text-sm text-muted-foreground sm:gap-2.5",
      e
    ),
    ...t
  }
));
mx.displayName = "BreadcrumbList";
const hx = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l("li", { ref: r, className: N("inline-flex items-center gap-1.5", e), ...t }));
hx.displayName = "BreadcrumbItem";
const vx = s.forwardRef(
  ({ asChild: e, className: t, ...r }, n) => /* @__PURE__ */ l(
    e ? Is : "a",
    {
      ref: n,
      className: N("transition-colors hover:text-foreground", t),
      ...r
    }
  )
);
vx.displayName = "BreadcrumbLink";
const gx = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  "span",
  {
    ref: r,
    role: "link",
    "aria-disabled": "true",
    "aria-current": "page",
    className: N("font-medium text-foreground", e),
    ...t
  }
));
gx.displayName = "BreadcrumbPage";
function oR({
  children: e,
  className: t,
  ...r
}) {
  return /* @__PURE__ */ l(
    "li",
    {
      role: "presentation",
      "aria-hidden": "true",
      className: N("[&>svg]:size-3.5", t),
      ...r,
      children: e ?? /* @__PURE__ */ l(zt, {})
    }
  );
}
function aR({ className: e, ...t }) {
  return /* @__PURE__ */ I(
    "span",
    {
      role: "presentation",
      "aria-hidden": "true",
      className: N("flex h-9 w-9 items-center justify-center", e),
      ...t,
      children: [
        /* @__PURE__ */ l(ri, { className: "size-4" }),
        /* @__PURE__ */ l("span", { className: "sr-only", children: "More" })
      ]
    }
  );
}
var uo = ["Enter", " "], bx = ["ArrowDown", "PageUp", "Home"], qd = ["ArrowUp", "PageDown", "End"], wx = [...bx, ...qd], yx = {
  ltr: [...uo, "ArrowRight"],
  rtl: [...uo, "ArrowLeft"]
}, xx = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, or = "Menu", [Ft, Cx, Sx] = ot(or), [st, ga] = ae(or, [
  Sx,
  Ae,
  je
]), ar = Ae(), Zd = je(), [Qd, Je] = st(or), [Rx, sr] = st(or), Jd = (e) => {
  const { __scopeMenu: t, open: r = !1, children: n, dir: o, onOpenChange: a, modal: i = !0 } = e, c = ar(t), [d, u] = s.useState(null), p = s.useRef(!1), f = te(a), m = Le(o);
  return s.useEffect(() => {
    const v = () => {
      p.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => p.current = !1;
    return document.addEventListener("keydown", v, { capture: !0 }), () => {
      document.removeEventListener("keydown", v, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), s.useEffect(() => {
    if (!r)
      return;
    const v = () => f(!1);
    return window.addEventListener("blur", v), () => window.removeEventListener("blur", v);
  }, [r, f]), /* @__PURE__ */ l(Rt, { ...c, children: /* @__PURE__ */ l(
    Qd,
    {
      scope: t,
      open: r,
      onOpenChange: f,
      content: d,
      onContentChange: u,
      children: /* @__PURE__ */ l(
        Rx,
        {
          scope: t,
          onClose: s.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: p,
          dir: m,
          modal: i,
          children: n
        }
      )
    }
  ) });
};
Jd.displayName = or;
var Nx = "MenuAnchor", ba = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e, o = ar(r);
    return /* @__PURE__ */ l(Nt, { ...o, ...n, ref: t });
  }
);
ba.displayName = Nx;
var wa = "MenuPortal", [Ex, eu] = st(wa, {
  forceMount: void 0
}), tu = (e) => {
  const { __scopeMenu: t, forceMount: r, children: n, container: o } = e, a = Je(wa, t);
  return /* @__PURE__ */ l(Ex, { scope: t, forceMount: r, children: /* @__PURE__ */ l(ne, { present: r || a.open, children: /* @__PURE__ */ l(Xe, { asChild: !0, container: o, children: n }) }) });
};
tu.displayName = wa;
var he = "MenuContent", [Px, ya] = st(he), ru = s.forwardRef(
  (e, t) => {
    const r = eu(he, e.__scopeMenu), { forceMount: n = r.forceMount, ...o } = e, a = Je(he, e.__scopeMenu), i = sr(he, e.__scopeMenu);
    return /* @__PURE__ */ l(Ft.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ l(ne, { present: n || a.open, children: /* @__PURE__ */ l(Ft.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ l(Tx, { ...o, ref: t }) : /* @__PURE__ */ l(_x, { ...o, ref: t }) }) }) });
  }
), Tx = s.forwardRef(
  (e, t) => {
    const r = Je(he, e.__scopeMenu), n = s.useRef(null), o = V(t, n);
    return s.useEffect(() => {
      const a = n.current;
      if (a) return rn(a);
    }, []), /* @__PURE__ */ l(
      xa,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: r.open,
        disableOutsideScroll: !0,
        onFocusOutside: P(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => r.onOpenChange(!1)
      }
    );
  }
), _x = s.forwardRef((e, t) => {
  const r = Je(he, e.__scopeMenu);
  return /* @__PURE__ */ l(
    xa,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => r.onOpenChange(!1)
    }
  );
}), Mx = /* @__PURE__ */ Ge("MenuContent.ScrollLock"), xa = s.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: r,
      loop: n = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: c,
      onEntryFocus: d,
      onEscapeKeyDown: u,
      onPointerDownOutside: p,
      onFocusOutside: f,
      onInteractOutside: m,
      onDismiss: v,
      disableOutsideScroll: g,
      ...h
    } = e, b = Je(he, r), w = sr(he, r), y = ar(r), x = Zd(r), C = Cx(r), [S, R] = s.useState(null), E = s.useRef(null), T = V(t, E, b.onContentChange), M = s.useRef(0), O = s.useRef(""), D = s.useRef(0), L = s.useRef(null), H = s.useRef("right"), k = s.useRef(0), B = g ? qt : s.Fragment, $ = g ? { as: Mx, allowPinchZoom: !0 } : void 0, z = (_) => {
      var G, Z;
      const U = O.current + _, K = C().filter((J) => !J.disabled), j = document.activeElement, X = (G = K.find((J) => J.ref.current === j)) == null ? void 0 : G.textValue, se = K.map((J) => J.textValue), Ie = Hx(se, U, X), ue = (Z = K.find((J) => J.textValue === Ie)) == null ? void 0 : Z.ref.current;
      (function J(q) {
        O.current = q, window.clearTimeout(M.current), q !== "" && (M.current = window.setTimeout(() => J(""), 1e3));
      })(U), ue && setTimeout(() => ue.focus());
    };
    s.useEffect(() => () => window.clearTimeout(M.current), []), qr();
    const F = s.useCallback((_) => {
      var K, j;
      return H.current === ((K = L.current) == null ? void 0 : K.side) && Wx(_, (j = L.current) == null ? void 0 : j.area);
    }, []);
    return /* @__PURE__ */ l(
      Px,
      {
        scope: r,
        searchRef: O,
        onItemEnter: s.useCallback(
          (_) => {
            F(_) && _.preventDefault();
          },
          [F]
        ),
        onItemLeave: s.useCallback(
          (_) => {
            var U;
            F(_) || ((U = E.current) == null || U.focus(), R(null));
          },
          [F]
        ),
        onTriggerLeave: s.useCallback(
          (_) => {
            F(_) && _.preventDefault();
          },
          [F]
        ),
        pointerGraceTimerRef: D,
        onPointerGraceIntentChange: s.useCallback((_) => {
          L.current = _;
        }, []),
        children: /* @__PURE__ */ l(B, { ...$, children: /* @__PURE__ */ l(
          Kt,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: P(a, (_) => {
              var U;
              _.preventDefault(), (U = E.current) == null || U.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ l(
              Ye,
              {
                asChild: !0,
                disableOutsidePointerEvents: c,
                onEscapeKeyDown: u,
                onPointerDownOutside: p,
                onFocusOutside: f,
                onInteractOutside: m,
                onDismiss: v,
                children: /* @__PURE__ */ l(
                  Wr,
                  {
                    asChild: !0,
                    ...x,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: n,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: R,
                    onEntryFocus: P(d, (_) => {
                      w.isUsingKeyboardRef.current || _.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ l(
                      Yt,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": wu(b.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ...y,
                        ...h,
                        ref: T,
                        style: { outline: "none", ...h.style },
                        onKeyDown: P(h.onKeyDown, (_) => {
                          const K = _.target.closest("[data-radix-menu-content]") === _.currentTarget, j = _.ctrlKey || _.altKey || _.metaKey, X = _.key.length === 1;
                          K && (_.key === "Tab" && _.preventDefault(), !j && X && z(_.key));
                          const se = E.current;
                          if (_.target !== se || !wx.includes(_.key)) return;
                          _.preventDefault();
                          const ue = C().filter((G) => !G.disabled).map((G) => G.ref.current);
                          qd.includes(_.key) && ue.reverse(), Bx(ue);
                        }),
                        onBlur: P(e.onBlur, (_) => {
                          _.currentTarget.contains(_.target) || (window.clearTimeout(M.current), O.current = "");
                        }),
                        onPointerMove: P(
                          e.onPointerMove,
                          Vt((_) => {
                            const U = _.target, K = k.current !== _.clientX;
                            if (_.currentTarget.contains(U) && K) {
                              const j = _.clientX > k.current ? "right" : "left";
                              H.current = j, k.current = _.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
ru.displayName = he;
var Ax = "MenuGroup", Ca = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ l(A.div, { role: "group", ...n, ref: t });
  }
);
Ca.displayName = Ax;
var Ix = "MenuLabel", nu = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ l(A.div, { ...n, ref: t });
  }
);
nu.displayName = Ix;
var Fr = "MenuItem", ys = "menu.itemSelect", Nn = s.forwardRef(
  (e, t) => {
    const { disabled: r = !1, onSelect: n, ...o } = e, a = s.useRef(null), i = sr(Fr, e.__scopeMenu), c = ya(Fr, e.__scopeMenu), d = V(t, a), u = s.useRef(!1), p = () => {
      const f = a.current;
      if (!r && f) {
        const m = new CustomEvent(ys, { bubbles: !0, cancelable: !0 });
        f.addEventListener(ys, (v) => n == null ? void 0 : n(v), { once: !0 }), bo(f, m), m.defaultPrevented ? u.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ l(
      ou,
      {
        ...o,
        ref: d,
        disabled: r,
        onClick: P(e.onClick, p),
        onPointerDown: (f) => {
          var m;
          (m = e.onPointerDown) == null || m.call(e, f), u.current = !0;
        },
        onPointerUp: P(e.onPointerUp, (f) => {
          var m;
          u.current || (m = f.currentTarget) == null || m.click();
        }),
        onKeyDown: P(e.onKeyDown, (f) => {
          r || f.target !== f.currentTarget || c.searchRef.current !== "" && f.key === " " || uo.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
Nn.displayName = Fr;
var ou = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, disabled: n = !1, textValue: o, ...a } = e, i = ya(Fr, r), c = Zd(r), d = s.useRef(null), u = V(t, d), [p, f] = s.useState(!1), [m, v] = s.useState("");
    return s.useEffect(() => {
      const g = d.current;
      g && v((g.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ l(
      Ft.ItemSlot,
      {
        scope: r,
        disabled: n,
        textValue: o ?? m,
        children: /* @__PURE__ */ l(Ur, { asChild: !0, ...c, focusable: !n, children: /* @__PURE__ */ l(
          A.div,
          {
            role: "menuitem",
            "data-highlighted": p ? "" : void 0,
            "aria-disabled": n || void 0,
            "data-disabled": n ? "" : void 0,
            ...a,
            ref: u,
            onPointerMove: P(
              e.onPointerMove,
              Vt((g) => {
                n ? i.onItemLeave(g) : (i.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: P(
              e.onPointerLeave,
              Vt((g) => i.onItemLeave(g))
            ),
            onFocus: P(e.onFocus, () => f(!0)),
            onBlur: P(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), Dx = "MenuCheckboxItem", au = s.forwardRef(
  (e, t) => {
    const { checked: r = !1, onCheckedChange: n, ...o } = e;
    return /* @__PURE__ */ l(du, { scope: e.__scopeMenu, checked: r, children: /* @__PURE__ */ l(
      Nn,
      {
        role: "menuitemcheckbox",
        "aria-checked": Vr(r) ? "mixed" : r,
        ...o,
        ref: t,
        "data-state": Na(r),
        onSelect: P(
          o.onSelect,
          () => n == null ? void 0 : n(Vr(r) ? !0 : !r),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
au.displayName = Dx;
var su = "MenuRadioGroup", [kx, Ox] = st(
  su,
  { value: void 0, onValueChange: () => {
  } }
), iu = s.forwardRef(
  (e, t) => {
    const { value: r, onValueChange: n, ...o } = e, a = te(n);
    return /* @__PURE__ */ l(kx, { scope: e.__scopeMenu, value: r, onValueChange: a, children: /* @__PURE__ */ l(Ca, { ...o, ref: t }) });
  }
);
iu.displayName = su;
var cu = "MenuRadioItem", lu = s.forwardRef(
  (e, t) => {
    const { value: r, ...n } = e, o = Ox(cu, e.__scopeMenu), a = r === o.value;
    return /* @__PURE__ */ l(du, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ l(
      Nn,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...n,
        ref: t,
        "data-state": Na(a),
        onSelect: P(
          n.onSelect,
          () => {
            var i;
            return (i = o.onValueChange) == null ? void 0 : i.call(o, r);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
lu.displayName = cu;
var Sa = "MenuItemIndicator", [du, Lx] = st(
  Sa,
  { checked: !1 }
), uu = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, forceMount: n, ...o } = e, a = Lx(Sa, r);
    return /* @__PURE__ */ l(
      ne,
      {
        present: n || Vr(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ l(
          A.span,
          {
            ...o,
            ref: t,
            "data-state": Na(a.checked)
          }
        )
      }
    );
  }
);
uu.displayName = Sa;
var $x = "MenuSeparator", fu = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ l(
      A.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...n,
        ref: t
      }
    );
  }
);
fu.displayName = $x;
var Fx = "MenuArrow", pu = s.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e, o = ar(r);
    return /* @__PURE__ */ l(Xt, { ...o, ...n, ref: t });
  }
);
pu.displayName = Fx;
var Ra = "MenuSub", [Vx, mu] = st(Ra), hu = (e) => {
  const { __scopeMenu: t, children: r, open: n = !1, onOpenChange: o } = e, a = Je(Ra, t), i = ar(t), [c, d] = s.useState(null), [u, p] = s.useState(null), f = te(o);
  return s.useEffect(() => (a.open === !1 && f(!1), () => f(!1)), [a.open, f]), /* @__PURE__ */ l(Rt, { ...i, children: /* @__PURE__ */ l(
    Qd,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: u,
      onContentChange: p,
      children: /* @__PURE__ */ l(
        Vx,
        {
          scope: t,
          contentId: ce(),
          triggerId: ce(),
          trigger: c,
          onTriggerChange: d,
          children: r
        }
      )
    }
  ) });
};
hu.displayName = Ra;
var kt = "MenuSubTrigger", vu = s.forwardRef(
  (e, t) => {
    const r = Je(kt, e.__scopeMenu), n = sr(kt, e.__scopeMenu), o = mu(kt, e.__scopeMenu), a = ya(kt, e.__scopeMenu), i = s.useRef(null), { pointerGraceTimerRef: c, onPointerGraceIntentChange: d } = a, u = { __scopeMenu: e.__scopeMenu }, p = s.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    s.useEffect(() => p, [p]), s.useEffect(() => {
      const m = c.current;
      return () => {
        window.clearTimeout(m), d(null);
      };
    }, [c, d]);
    const f = V(t, o.onTriggerChange);
    return /* @__PURE__ */ l(ba, { asChild: !0, ...u, children: /* @__PURE__ */ l(
      ou,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": r.open,
        "aria-controls": r.open ? o.contentId : void 0,
        "data-state": wu(r.open),
        ...e,
        ref: f,
        onClick: (m) => {
          var v;
          (v = e.onClick) == null || v.call(e, m), !(e.disabled || m.defaultPrevented) && (m.currentTarget.focus(), r.open || r.onOpenChange(!0));
        },
        onPointerMove: P(
          e.onPointerMove,
          Vt((m) => {
            a.onItemEnter(m), !m.defaultPrevented && !e.disabled && !r.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              r.onOpenChange(!0), p();
            }, 100));
          })
        ),
        onPointerLeave: P(
          e.onPointerLeave,
          Vt((m) => {
            var g, h;
            p();
            const v = (g = r.content) == null ? void 0 : g.getBoundingClientRect();
            if (v) {
              const b = (h = r.content) == null ? void 0 : h.dataset.side, w = b === "right", y = w ? -5 : 5, x = v[w ? "left" : "right"], C = v[w ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: m.clientX + y, y: m.clientY },
                  { x, y: v.top },
                  { x: C, y: v.top },
                  { x: C, y: v.bottom },
                  { x, y: v.bottom }
                ],
                side: b
              }), window.clearTimeout(c.current), c.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(m), m.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: P(e.onKeyDown, (m) => {
          var g;
          e.disabled || m.target !== m.currentTarget || a.searchRef.current !== "" && m.key === " " || yx[n.dir].includes(m.key) && (r.onOpenChange(!0), (g = r.content) == null || g.focus(), m.preventDefault());
        })
      }
    ) });
  }
);
vu.displayName = kt;
var gu = "MenuSubContent", bu = s.forwardRef(
  (e, t) => {
    const r = eu(he, e.__scopeMenu), { forceMount: n = r.forceMount, align: o = "start", ...a } = e, i = Je(he, e.__scopeMenu), c = sr(he, e.__scopeMenu), d = mu(gu, e.__scopeMenu), u = s.useRef(null), p = V(t, u);
    return /* @__PURE__ */ l(Ft.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ l(ne, { present: n || i.open, children: /* @__PURE__ */ l(Ft.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ l(
      xa,
      {
        id: d.contentId,
        "aria-labelledby": d.triggerId,
        ...a,
        ref: p,
        align: o,
        side: c.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (f) => {
          var m;
          c.isUsingKeyboardRef.current && ((m = u.current) == null || m.focus()), f.preventDefault();
        },
        onCloseAutoFocus: (f) => f.preventDefault(),
        onFocusOutside: P(e.onFocusOutside, (f) => {
          f.target !== d.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: P(e.onEscapeKeyDown, (f) => {
          c.onClose(), f.preventDefault();
        }),
        onKeyDown: P(e.onKeyDown, (f) => {
          var g;
          const m = f.currentTarget.contains(f.target), v = xx[c.dir].includes(f.key);
          m && v && (i.onOpenChange(!1), (g = d.trigger) == null || g.focus(), f.preventDefault());
        })
      }
    ) }) }) });
  }
);
bu.displayName = gu;
function wu(e) {
  return e ? "open" : "closed";
}
function Vr(e) {
  return e === "indeterminate";
}
function Na(e) {
  return Vr(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Bx(e) {
  const t = document.activeElement;
  for (const r of e)
    if (r === t || (r.focus(), document.activeElement !== t)) return;
}
function zx(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
function Hx(e, t, r) {
  const o = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = r ? e.indexOf(r) : -1;
  let i = zx(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter((u) => u !== r));
  const d = i.find(
    (u) => u.toLowerCase().startsWith(o.toLowerCase())
  );
  return d !== r ? d : void 0;
}
function Gx(e, t) {
  const { x: r, y: n } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const c = t[a], d = t[i], u = c.x, p = c.y, f = d.x, m = d.y;
    p > n != m > n && r < (f - u) * (n - p) / (m - p) + u && (o = !o);
  }
  return o;
}
function Wx(e, t) {
  if (!t) return !1;
  const r = { x: e.clientX, y: e.clientY };
  return Gx(r, t);
}
function Vt(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var yu = Jd, xu = ba, Cu = tu, Su = ru, Ru = Ca, Nu = nu, Eu = Nn, Pu = au, Tu = iu, _u = lu, Mu = uu, Au = fu, Iu = pu, Du = hu, ku = vu, Ou = bu, En = "DropdownMenu", [Ux] = ae(
  En,
  [ga]
), le = ga(), [Kx, Lu] = Ux(En), $u = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: r,
    dir: n,
    open: o,
    defaultOpen: a,
    onOpenChange: i,
    modal: c = !0
  } = e, d = le(t), u = s.useRef(null), [p, f] = ie({
    prop: o,
    defaultProp: a ?? !1,
    onChange: i,
    caller: En
  });
  return /* @__PURE__ */ l(
    Kx,
    {
      scope: t,
      triggerId: ce(),
      triggerRef: u,
      contentId: ce(),
      open: p,
      onOpenChange: f,
      onOpenToggle: s.useCallback(() => f((m) => !m), [f]),
      modal: c,
      children: /* @__PURE__ */ l(yu, { ...d, open: p, onOpenChange: f, dir: n, modal: c, children: r })
    }
  );
};
$u.displayName = En;
var Fu = "DropdownMenuTrigger", Vu = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, disabled: n = !1, ...o } = e, a = Lu(Fu, r), i = le(r), c = V(t, a.triggerRef);
    return /* @__PURE__ */ l(xu, { asChild: !0, ...i, children: /* @__PURE__ */ l(
      A.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": n ? "" : void 0,
        disabled: n,
        ...o,
        ref: c,
        onPointerDown: P(e.onPointerDown, (d) => {
          !n && d.button === 0 && d.ctrlKey === !1 && (a.onOpenToggle(), a.open || d.preventDefault());
        }),
        onKeyDown: P(e.onKeyDown, (d) => {
          n || (["Enter", " "].includes(d.key) && a.onOpenToggle(), d.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(d.key) && d.preventDefault());
        })
      }
    ) });
  }
);
Vu.displayName = Fu;
var jx = "DropdownMenuPortal", Bu = (e) => {
  const { __scopeDropdownMenu: t, ...r } = e, n = le(t);
  return /* @__PURE__ */ l(Cu, { ...n, ...r });
};
Bu.displayName = jx;
var zu = "DropdownMenuContent", Hu = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = Lu(zu, r), a = le(r), i = s.useRef(!1);
    return /* @__PURE__ */ l(
      Su,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...a,
        ...n,
        ref: t,
        onCloseAutoFocus: P(e.onCloseAutoFocus, (c) => {
          var d;
          i.current || (d = o.triggerRef.current) == null || d.focus(), i.current = !1, c.preventDefault();
        }),
        onInteractOutside: P(e.onInteractOutside, (c) => {
          const d = c.detail.originalEvent, u = d.button === 0 && d.ctrlKey === !0, p = d.button === 2 || u;
          (!o.modal || p) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Hu.displayName = zu;
var Yx = "DropdownMenuGroup", Gu = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = le(r);
    return /* @__PURE__ */ l(Ru, { ...o, ...n, ref: t });
  }
);
Gu.displayName = Yx;
var Xx = "DropdownMenuLabel", Wu = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = le(r);
    return /* @__PURE__ */ l(Nu, { ...o, ...n, ref: t });
  }
);
Wu.displayName = Xx;
var qx = "DropdownMenuItem", Uu = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = le(r);
    return /* @__PURE__ */ l(Eu, { ...o, ...n, ref: t });
  }
);
Uu.displayName = qx;
var Zx = "DropdownMenuCheckboxItem", Ku = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = le(r);
  return /* @__PURE__ */ l(Pu, { ...o, ...n, ref: t });
});
Ku.displayName = Zx;
var Qx = "DropdownMenuRadioGroup", ju = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = le(r);
  return /* @__PURE__ */ l(Tu, { ...o, ...n, ref: t });
});
ju.displayName = Qx;
var Jx = "DropdownMenuRadioItem", Yu = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = le(r);
  return /* @__PURE__ */ l(_u, { ...o, ...n, ref: t });
});
Yu.displayName = Jx;
var eC = "DropdownMenuItemIndicator", Xu = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = le(r);
  return /* @__PURE__ */ l(Mu, { ...o, ...n, ref: t });
});
Xu.displayName = eC;
var tC = "DropdownMenuSeparator", qu = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = le(r);
  return /* @__PURE__ */ l(Au, { ...o, ...n, ref: t });
});
qu.displayName = tC;
var rC = "DropdownMenuArrow", nC = s.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = le(r);
    return /* @__PURE__ */ l(Iu, { ...o, ...n, ref: t });
  }
);
nC.displayName = rC;
var oC = (e) => {
  const { __scopeDropdownMenu: t, children: r, open: n, onOpenChange: o, defaultOpen: a } = e, i = le(t), [c, d] = ie({
    prop: n,
    defaultProp: a ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ l(Du, { ...i, open: c, onOpenChange: d, children: r });
}, aC = "DropdownMenuSubTrigger", Zu = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = le(r);
  return /* @__PURE__ */ l(ku, { ...o, ...n, ref: t });
});
Zu.displayName = aC;
var sC = "DropdownMenuSubContent", Qu = s.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = le(r);
  return /* @__PURE__ */ l(
    Ou,
    {
      ...o,
      ...n,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Qu.displayName = sC;
var iC = $u, cC = Vu, Ju = Bu, ef = Hu, lC = Gu, tf = Wu, rf = Uu, nf = Ku, dC = ju, of = Yu, af = Xu, sf = qu, uC = oC, cf = Zu, lf = Qu;
const sR = iC, iR = cC, cR = lC, lR = Ju, dR = uC, uR = dC, fC = s.forwardRef(({ className: e, inset: t, children: r, ...n }, o) => /* @__PURE__ */ I(
  cf,
  {
    ref: o,
    className: N(
      "flex cursor-pointer select-none items-center rounded-md px-2 py-1.5 text-sm outline-none",
      "focus:bg-accent data-[state=open]:bg-accent",
      t && "pl-8",
      e
    ),
    ...n,
    children: [
      r,
      /* @__PURE__ */ l(zt, { className: "ml-auto size-4" })
    ]
  }
));
fC.displayName = cf.displayName;
const pC = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  lf,
  {
    ref: r,
    className: N(
      "z-50 min-w-32 overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-md",
      e
    ),
    ...t
  }
));
pC.displayName = lf.displayName;
const mC = s.forwardRef(({ className: e, sideOffset: t = 6, ...r }, n) => /* @__PURE__ */ l(Ju, { children: /* @__PURE__ */ l(
  ef,
  {
    ref: n,
    sideOffset: t,
    className: N(
      "z-50 min-w-40 overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
      "data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
      e
    ),
    ...r
  }
) }));
mC.displayName = ef.displayName;
const hC = s.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ l(
  rf,
  {
    ref: n,
    className: N(
      "relative flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none",
      "transition-colors focus:bg-accent focus:text-accent-foreground",
      "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t && "pl-8",
      e
    ),
    ...r
  }
));
hC.displayName = rf.displayName;
const vC = s.forwardRef(({ className: e, children: t, checked: r, ...n }, o) => /* @__PURE__ */ I(
  nf,
  {
    ref: o,
    checked: r,
    className: N(
      "relative flex cursor-pointer select-none items-center rounded-md py-1.5 pl-8 pr-2 text-sm outline-none",
      "transition-colors focus:bg-accent focus:text-accent-foreground",
      "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ l("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ l(af, { children: /* @__PURE__ */ l(nt, { className: "size-4" }) }) }),
      t
    ]
  }
));
vC.displayName = nf.displayName;
const gC = s.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ I(
  of,
  {
    ref: n,
    className: N(
      "relative flex cursor-pointer select-none items-center rounded-md py-1.5 pl-8 pr-2 text-sm outline-none",
      "transition-colors focus:bg-accent focus:text-accent-foreground",
      "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ l("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ l(af, { children: /* @__PURE__ */ l(ti, { className: "size-2 fill-current" }) }) }),
      t
    ]
  }
));
gC.displayName = of.displayName;
const bC = s.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ l(
  tf,
  {
    ref: n,
    className: N("px-2 py-1.5 text-xs font-semibold text-muted-foreground", t && "pl-8", e),
    ...r
  }
));
bC.displayName = tf.displayName;
const wC = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(sf, { ref: r, className: N("-mx-1 my-1 h-px bg-border", e), ...t }));
wC.displayName = sf.displayName;
function fR({ className: e, ...t }) {
  return /* @__PURE__ */ l("span", { className: N("ml-auto text-xs tracking-widest opacity-60", e), ...t });
}
var ir = "Menubar", [fo, yC, xC] = ot(ir), [df] = ae(ir, [
  xC,
  je
]), de = ga(), uf = je(), [CC, Ea] = df(ir), ff = s.forwardRef(
  (e, t) => {
    const {
      __scopeMenubar: r,
      value: n,
      onValueChange: o,
      defaultValue: a,
      loop: i = !0,
      dir: c,
      ...d
    } = e, u = Le(c), p = uf(r), [f, m] = ie({
      prop: n,
      onChange: o,
      defaultProp: a ?? "",
      caller: ir
    }), [v, g] = s.useState(null);
    return /* @__PURE__ */ l(
      CC,
      {
        scope: r,
        value: f,
        onMenuOpen: s.useCallback(
          (h) => {
            m(h), g(h);
          },
          [m]
        ),
        onMenuClose: s.useCallback(() => m(""), [m]),
        onMenuToggle: s.useCallback(
          (h) => {
            m((b) => b ? "" : h), g(h);
          },
          [m]
        ),
        dir: u,
        loop: i,
        children: /* @__PURE__ */ l(fo.Provider, { scope: r, children: /* @__PURE__ */ l(fo.Slot, { scope: r, children: /* @__PURE__ */ l(
          Wr,
          {
            asChild: !0,
            ...p,
            orientation: "horizontal",
            loop: i,
            dir: u,
            currentTabStopId: v,
            onCurrentTabStopIdChange: g,
            children: /* @__PURE__ */ l(A.div, { role: "menubar", ...d, ref: t })
          }
        ) }) })
      }
    );
  }
);
ff.displayName = ir;
var Pa = "MenubarMenu", [SC, pf] = df(Pa), mf = (e) => {
  const { __scopeMenubar: t, value: r, ...n } = e, o = ce(), a = r || o || "LEGACY_REACT_AUTO_VALUE", i = Ea(Pa, t), c = de(t), d = s.useRef(null), u = s.useRef(!1), p = i.value === a;
  return s.useEffect(() => {
    p || (u.current = !1);
  }, [p]), /* @__PURE__ */ l(
    SC,
    {
      scope: t,
      value: a,
      triggerId: ce(),
      triggerRef: d,
      contentId: ce(),
      wasKeyboardTriggerOpenRef: u,
      children: /* @__PURE__ */ l(
        yu,
        {
          ...c,
          open: p,
          onOpenChange: (f) => {
            f || i.onMenuClose();
          },
          modal: !1,
          dir: i.dir,
          ...n
        }
      )
    }
  );
};
mf.displayName = Pa;
var po = "MenubarTrigger", hf = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, disabled: n = !1, ...o } = e, a = uf(r), i = de(r), c = Ea(po, r), d = pf(po, r), u = s.useRef(null), p = V(t, u, d.triggerRef), [f, m] = s.useState(!1), v = c.value === d.value;
    return /* @__PURE__ */ l(fo.ItemSlot, { scope: r, value: d.value, disabled: n, children: /* @__PURE__ */ l(
      Ur,
      {
        asChild: !0,
        ...a,
        focusable: !n,
        tabStopId: d.value,
        children: /* @__PURE__ */ l(xu, { asChild: !0, ...i, children: /* @__PURE__ */ l(
          A.button,
          {
            type: "button",
            role: "menuitem",
            id: d.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": v,
            "aria-controls": v ? d.contentId : void 0,
            "data-highlighted": f ? "" : void 0,
            "data-state": v ? "open" : "closed",
            "data-disabled": n ? "" : void 0,
            disabled: n,
            ...o,
            ref: p,
            onPointerDown: P(e.onPointerDown, (g) => {
              !n && g.button === 0 && g.ctrlKey === !1 && (c.onMenuOpen(d.value), v || g.preventDefault());
            }),
            onPointerEnter: P(e.onPointerEnter, () => {
              var h;
              !!c.value && !v && (c.onMenuOpen(d.value), (h = u.current) == null || h.focus());
            }),
            onKeyDown: P(e.onKeyDown, (g) => {
              n || (["Enter", " "].includes(g.key) && c.onMenuToggle(d.value), g.key === "ArrowDown" && c.onMenuOpen(d.value), ["Enter", " ", "ArrowDown"].includes(g.key) && (d.wasKeyboardTriggerOpenRef.current = !0, g.preventDefault()));
            }),
            onFocus: P(e.onFocus, () => m(!0)),
            onBlur: P(e.onBlur, () => m(!1))
          }
        ) })
      }
    ) });
  }
);
hf.displayName = po;
var RC = "MenubarPortal", vf = (e) => {
  const { __scopeMenubar: t, ...r } = e, n = de(t);
  return /* @__PURE__ */ l(Cu, { ...n, ...r });
};
vf.displayName = RC;
var mo = "MenubarContent", gf = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, align: n = "start", ...o } = e, a = de(r), i = Ea(mo, r), c = pf(mo, r), d = yC(r), u = s.useRef(!1);
    return /* @__PURE__ */ l(
      Su,
      {
        id: c.contentId,
        "aria-labelledby": c.triggerId,
        "data-radix-menubar-content": "",
        ...a,
        ...o,
        ref: t,
        align: n,
        onCloseAutoFocus: P(e.onCloseAutoFocus, (p) => {
          var m;
          !!!i.value && !u.current && ((m = c.triggerRef.current) == null || m.focus()), u.current = !1, p.preventDefault();
        }),
        onFocusOutside: P(e.onFocusOutside, (p) => {
          const f = p.target;
          d().some((v) => {
            var g;
            return (g = v.ref.current) == null ? void 0 : g.contains(f);
          }) && p.preventDefault();
        }),
        onInteractOutside: P(e.onInteractOutside, () => {
          u.current = !0;
        }),
        onEntryFocus: (p) => {
          c.wasKeyboardTriggerOpenRef.current || p.preventDefault();
        },
        onKeyDown: P(
          e.onKeyDown,
          (p) => {
            if (["ArrowRight", "ArrowLeft"].includes(p.key)) {
              const f = p.target, m = f.hasAttribute("data-radix-menubar-subtrigger"), v = f.closest("[data-radix-menubar-content]") !== p.currentTarget, h = (i.dir === "rtl" ? "ArrowRight" : "ArrowLeft") === p.key;
              if (!h && m || v && h) return;
              let y = d().filter((S) => !S.disabled).map((S) => S.value);
              h && y.reverse();
              const x = y.indexOf(c.value);
              y = i.loop ? $C(y, x + 1) : y.slice(x + 1);
              const [C] = y;
              C && i.onMenuOpen(C);
            }
          },
          { checkForDefaultPrevented: !1 }
        ),
        style: {
          ...e.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
gf.displayName = mo;
var NC = "MenubarGroup", bf = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, ...n } = e, o = de(r);
    return /* @__PURE__ */ l(Ru, { ...o, ...n, ref: t });
  }
);
bf.displayName = NC;
var EC = "MenubarLabel", wf = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, ...n } = e, o = de(r);
    return /* @__PURE__ */ l(Nu, { ...o, ...n, ref: t });
  }
);
wf.displayName = EC;
var PC = "MenubarItem", yf = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, ...n } = e, o = de(r);
    return /* @__PURE__ */ l(Eu, { ...o, ...n, ref: t });
  }
);
yf.displayName = PC;
var TC = "MenubarCheckboxItem", xf = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, ...n } = e, o = de(r);
    return /* @__PURE__ */ l(Pu, { ...o, ...n, ref: t });
  }
);
xf.displayName = TC;
var _C = "MenubarRadioGroup", Cf = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, ...n } = e, o = de(r);
    return /* @__PURE__ */ l(Tu, { ...o, ...n, ref: t });
  }
);
Cf.displayName = _C;
var MC = "MenubarRadioItem", Sf = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, ...n } = e, o = de(r);
    return /* @__PURE__ */ l(_u, { ...o, ...n, ref: t });
  }
);
Sf.displayName = MC;
var AC = "MenubarItemIndicator", Rf = s.forwardRef((e, t) => {
  const { __scopeMenubar: r, ...n } = e, o = de(r);
  return /* @__PURE__ */ l(Mu, { ...o, ...n, ref: t });
});
Rf.displayName = AC;
var IC = "MenubarSeparator", Nf = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, ...n } = e, o = de(r);
    return /* @__PURE__ */ l(Au, { ...o, ...n, ref: t });
  }
);
Nf.displayName = IC;
var DC = "MenubarArrow", kC = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, ...n } = e, o = de(r);
    return /* @__PURE__ */ l(Iu, { ...o, ...n, ref: t });
  }
);
kC.displayName = DC;
var Ef = "MenubarSub", Pf = (e) => {
  const { __scopeMenubar: t, children: r, open: n, onOpenChange: o, defaultOpen: a } = e, i = de(t), [c, d] = ie({
    prop: n,
    defaultProp: a ?? !1,
    onChange: o,
    caller: Ef
  });
  return /* @__PURE__ */ l(Du, { ...i, open: c, onOpenChange: d, children: r });
};
Pf.displayName = Ef;
var OC = "MenubarSubTrigger", Tf = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, ...n } = e, o = de(r);
    return /* @__PURE__ */ l(
      ku,
      {
        "data-radix-menubar-subtrigger": "",
        ...o,
        ...n,
        ref: t
      }
    );
  }
);
Tf.displayName = OC;
var LC = "MenubarSubContent", _f = s.forwardRef(
  (e, t) => {
    const { __scopeMenubar: r, ...n } = e, o = de(r);
    return /* @__PURE__ */ l(
      Ou,
      {
        ...o,
        "data-radix-menubar-content": "",
        ...n,
        ref: t,
        style: {
          ...e.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
_f.displayName = LC;
function $C(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var Mf = ff, FC = mf, Af = hf, If = vf, Df = gf, VC = bf, kf = wf, Of = yf, Lf = xf, BC = Cf, $f = Sf, Ff = Rf, Vf = Nf, zC = Pf, Bf = Tf, zf = _f;
const HC = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  Mf,
  {
    ref: r,
    className: N("flex h-11 items-center gap-1 rounded-lg border border-border bg-background p-1 shadow-sm", e),
    ...t
  }
));
HC.displayName = Mf.displayName;
const pR = FC, mR = VC, hR = If, vR = zC, gR = BC, GC = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  Af,
  {
    ref: r,
    className: N(
      "flex cursor-pointer select-none items-center rounded-md px-3 py-1.5 text-sm font-medium outline-none",
      "focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground",
      e
    ),
    ...t
  }
));
GC.displayName = Af.displayName;
const WC = s.forwardRef(({ className: e, align: t = "start", alignOffset: r = -4, sideOffset: n = 8, ...o }, a) => /* @__PURE__ */ l(If, { children: /* @__PURE__ */ l(
  Df,
  {
    ref: a,
    align: t,
    alignOffset: r,
    sideOffset: n,
    className: N(
      "z-50 min-w-48 overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...o
  }
) }));
WC.displayName = Df.displayName;
const UC = s.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ l(
  Of,
  {
    ref: n,
    className: N(
      "flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none",
      "focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t && "pl-8",
      e
    ),
    ...r
  }
));
UC.displayName = Of.displayName;
const KC = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(Vf, { ref: r, className: N("-mx-1 my-1 h-px bg-border", e), ...t }));
KC.displayName = Vf.displayName;
const jC = s.forwardRef(({ className: e, children: t, checked: r, ...n }, o) => /* @__PURE__ */ I(
  Lf,
  {
    ref: o,
    checked: r,
    className: N(
      "relative flex cursor-pointer select-none items-center rounded-md py-1.5 pl-8 pr-2 text-sm outline-none",
      "focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ l("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ l(Ff, { children: /* @__PURE__ */ l(nt, { className: "size-4" }) }) }),
      t
    ]
  }
));
jC.displayName = Lf.displayName;
const YC = s.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ I(
  $f,
  {
    ref: n,
    className: N(
      "relative flex cursor-pointer select-none items-center rounded-md py-1.5 pl-8 pr-2 text-sm outline-none",
      "focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ l("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ l(Ff, { children: /* @__PURE__ */ l(ti, { className: "size-2 fill-current" }) }) }),
      t
    ]
  }
));
YC.displayName = $f.displayName;
const XC = s.forwardRef(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ l(
  kf,
  {
    ref: n,
    className: N("px-2 py-1.5 text-xs font-semibold text-muted-foreground", t && "pl-8", e),
    ...r
  }
));
XC.displayName = kf.displayName;
const qC = s.forwardRef(({ className: e, inset: t, children: r, ...n }, o) => /* @__PURE__ */ I(
  Bf,
  {
    ref: o,
    className: N(
      "flex cursor-pointer select-none items-center rounded-md px-2 py-1.5 text-sm outline-none",
      "focus:bg-accent data-[state=open]:bg-accent",
      t && "pl-8",
      e
    ),
    ...n,
    children: [
      r,
      /* @__PURE__ */ l(zt, { className: "ml-auto size-4" })
    ]
  }
));
qC.displayName = Bf.displayName;
const ZC = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  zf,
  {
    ref: r,
    className: N(
      "z-50 min-w-40 overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-md",
      e
    ),
    ...t
  }
));
ZC.displayName = zf.displayName;
function bR({ className: e, ...t }) {
  return /* @__PURE__ */ l("span", { className: N("ml-auto text-xs tracking-widest opacity-60", e), ...t });
}
var Ta = "Avatar", [QC] = ae(Ta), JC = [
  0,
  () => {
  }
], [eS, Hf] = QC(Ta), _a = s.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, ...n } = e, [o, a] = s.useState("idle"), [i, c] = rS();
    return /* @__PURE__ */ l(
      eS,
      {
        scope: r,
        imageLoadingStatus: o,
        setImageLoadingStatus: a,
        imageCount: i,
        setImageCount: c,
        children: /* @__PURE__ */ l(A.span, { ...n, ref: t })
      }
    );
  }
);
_a.displayName = Ta;
var Gf = "AvatarImage", Ma = s.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, src: n, onLoadingStatusChange: o, ...a } = e, i = Hf(Gf, r);
    nS(i.setImageCount);
    const c = tS(n, {
      referrerPolicy: a.referrerPolicy,
      crossOrigin: a.crossOrigin,
      loadingStatus: i.imageLoadingStatus,
      setLoadingStatus: i.setImageLoadingStatus
    }), d = te((p) => {
      o == null || o(p);
    }), u = s.useRef(c);
    return oe(() => {
      const p = u.current;
      u.current = c, c !== p && d(c);
    }, [c, d]), c === "loaded" ? /* @__PURE__ */ l(A.img, { ...a, ref: t, src: n }) : null;
  }
);
Ma.displayName = Gf;
var Wf = "AvatarFallback", Aa = s.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, delayMs: n, ...o } = e, a = Hf(Wf, r), [i, c] = s.useState(n === void 0);
    return s.useEffect(() => {
      if (n !== void 0) {
        const d = window.setTimeout(() => c(!0), n);
        return () => window.clearTimeout(d);
      }
    }, [n]), i && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ l(A.span, { ...o, ref: t }) : null;
  }
);
Aa.displayName = Wf;
function tS(e, {
  loadingStatus: t,
  setLoadingStatus: r,
  referrerPolicy: n,
  crossOrigin: o
}) {
  return oe(() => {
    if (!e) {
      r("error");
      return;
    }
    const a = new window.Image(), i = (d) => {
      const u = d.currentTarget;
      r(xs(u));
    }, c = () => r("error");
    return a.addEventListener("load", i), a.addEventListener("error", c), n && (a.referrerPolicy = n), a.crossOrigin = o ?? null, a.src = e, r(xs(a)), () => {
      a.removeEventListener("load", i), a.removeEventListener("error", c), r("idle");
    };
  }, [e, o, n, r]), t;
}
function xs(e) {
  return e.complete ? e.naturalWidth > 0 ? "loaded" : "error" : "loading";
}
function rS() {
  let e = JC;
  {
    e = s.useState(0);
    const [t] = e, r = s.useRef(!1);
    s.useEffect(() => {
      t > 1 && !r.current && (r.current = !0, console.warn(
        "Avatar: Only one `Avatar.Image` component should be rendered per `Avatar.Root`, but multiple were detected. This will lead to unexpected behavior."
      ));
    }, [t]);
  }
  return e;
}
function nS(e) {
  s.useEffect(() => (e((t) => t + 1), () => {
    e((t) => t - 1);
  }), [e]);
}
const oS = me("relative flex shrink-0 overflow-hidden rounded-full", {
  variants: {
    size: {
      sm: "h-8 w-8",
      md: "h-10 w-10",
      lg: "h-14 w-14",
      xl: "h-20 w-20"
    }
  },
  defaultVariants: { size: "md" }
}), aS = s.forwardRef(
  ({ className: e, size: t, ...r }, n) => /* @__PURE__ */ l(_a, { ref: n, className: N(oS({ size: t }), e), ...r })
);
aS.displayName = _a.displayName;
const sS = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(Ma, { ref: r, className: N("aspect-square h-full w-full object-cover", e), ...t }));
sS.displayName = Ma.displayName;
const iS = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  Aa,
  {
    ref: r,
    className: N(
      "flex h-full w-full items-center justify-center rounded-full bg-secondary text-sm font-semibold text-secondary-foreground",
      e
    ),
    ...t
  }
));
iS.displayName = Aa.displayName;
const cr = s.forwardRef(
  ({ className: e, ...t }, r) => /* @__PURE__ */ l(
    "div",
    {
      ref: r,
      className: N("rounded-xl border border-border bg-card text-card-foreground shadow-sm", e),
      ...t
    }
  )
);
cr.displayName = "Card";
const cS = s.forwardRef(
  ({ className: e, ...t }, r) => /* @__PURE__ */ l("div", { ref: r, className: N("flex flex-col gap-1.5 p-5", e), ...t })
);
cS.displayName = "CardHeader";
const lS = s.forwardRef(
  ({ className: e, ...t }, r) => /* @__PURE__ */ l("h3", { ref: r, className: N("text-lg font-medium leading-snug", e), ...t })
);
lS.displayName = "CardTitle";
const dS = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l("p", { ref: r, className: N("text-sm text-muted-foreground", e), ...t }));
dS.displayName = "CardDescription";
const uS = s.forwardRef(
  ({ className: e, ...t }, r) => /* @__PURE__ */ l("div", { ref: r, className: N("p-5 pt-0", e), ...t })
);
uS.displayName = "CardContent";
const fS = s.forwardRef(
  ({ className: e, ...t }, r) => /* @__PURE__ */ l("div", { ref: r, className: N("flex items-center p-5 pt-0", e), ...t })
);
fS.displayName = "CardFooter";
const Uf = s.forwardRef(
  ({ className: e, ...t }, r) => /* @__PURE__ */ l("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ l("table", { ref: r, className: N("w-full caption-bottom text-sm", e), ...t }) })
);
Uf.displayName = "Table";
const Kf = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l("thead", { ref: r, className: N("[&_tr]:border-b [&_tr]:border-border", e), ...t }));
Kf.displayName = "TableHeader";
const jf = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l("tbody", { ref: r, className: N("[&_tr:last-child]:border-0", e), ...t }));
jf.displayName = "TableBody";
const pS = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  "tfoot",
  {
    ref: r,
    className: N("border-t border-border bg-muted/50 font-medium [&>tr]:last:border-b-0", e),
    ...t
  }
));
pS.displayName = "TableFooter";
const Nr = s.forwardRef(
  ({ className: e, ...t }, r) => /* @__PURE__ */ l(
    "tr",
    {
      ref: r,
      className: N("border-b border-border transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", e),
      ...t
    }
  )
);
Nr.displayName = "TableRow";
const Yf = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l(
  "th",
  {
    ref: r,
    className: N(
      "h-11 px-4 text-left align-middle text-xs font-semibold uppercase tracking-wide text-muted-foreground",
      "[&:has([role=checkbox])]:pr-0",
      e
    ),
    ...t
  }
));
Yf.displayName = "TableHead";
const ho = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l("td", { ref: r, className: N("p-4 align-middle [&:has([role=checkbox])]:pr-0", e), ...t }));
ho.displayName = "TableCell";
const mS = s.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ l("caption", { ref: r, className: N("mt-4 text-sm text-muted-foreground", e), ...t }));
mS.displayName = "TableCaption";
function hS(e, t, r) {
  const n = r * 2 + 5;
  if (t <= n)
    return Array.from({ length: t }, (c, d) => d + 1);
  const o = Math.max(e - r, 2), a = Math.min(e + r, t - 1), i = [1];
  o > 2 && i.push("ellipsis");
  for (let c = o; c <= a; c++) i.push(c);
  return a < t - 1 && i.push("ellipsis"), i.push(t), i;
}
const Xf = s.forwardRef(
  ({ page: e, pageCount: t, onPageChange: r, siblingCount: n = 1, className: o, ...a }, i) => {
    const c = hS(e, t, n);
    return /* @__PURE__ */ I(
      "nav",
      {
        ref: i,
        "aria-label": "Pagination",
        className: N("flex items-center justify-center gap-1", o),
        ...a,
        children: [
          /* @__PURE__ */ l(
            ht,
            {
              "aria-label": "Previous page",
              icon: /* @__PURE__ */ l(ei, {}),
              variant: "outline",
              size: "sm",
              disabled: e <= 1,
              onClick: () => r(e - 1)
            }
          ),
          c.map(
            (d, u) => d === "ellipsis" ? /* @__PURE__ */ l("span", { className: "flex h-8 w-8 items-center justify-center text-muted-foreground", children: /* @__PURE__ */ l(ri, { className: "size-4" }) }, `e-${u}`) : /* @__PURE__ */ l(
              Co,
              {
                size: "sm",
                variant: d === e ? "primary" : "outline",
                className: "h-8 w-8 px-0",
                "aria-current": d === e ? "page" : void 0,
                onClick: () => r(d),
                children: d
              },
              d
            )
          ),
          /* @__PURE__ */ l(
            ht,
            {
              "aria-label": "Next page",
              icon: /* @__PURE__ */ l(zt, {}),
              variant: "outline",
              size: "sm",
              disabled: e >= t,
              onClick: () => r(e + 1)
            }
          )
        ]
      }
    );
  }
);
Xf.displayName = "Pagination";
const qf = s.forwardRef(
  ({ className: e, icon: t, title: r, description: n, action: o, ...a }, i) => /* @__PURE__ */ I(
    "div",
    {
      ref: i,
      className: N(
        "flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-border p-10 text-center",
        e
      ),
      ...a,
      children: [
        /* @__PURE__ */ l("div", { className: "flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground [&_svg]:size-6", children: t ?? /* @__PURE__ */ l(Om, {}) }),
        /* @__PURE__ */ I("div", { className: "space-y-1", children: [
          /* @__PURE__ */ l("p", { className: "font-medium text-foreground", children: r }),
          n && /* @__PURE__ */ l("p", { className: "text-sm text-muted-foreground", children: n })
        ] }),
        o
      ]
    }
  )
);
qf.displayName = "EmptyState";
function wR({
  columns: e,
  data: t,
  rowKey: r,
  isLoading: n,
  emptyTitle: o = "No data yet",
  emptyDescription: a = "There's nothing to show here right now.",
  pageSize: i = 10,
  onRowClick: c,
  className: d
}) {
  const [u, p] = s.useState(null), [f, m] = s.useState("asc"), [v, g] = s.useState(1), h = s.useMemo(() => {
    if (!u) return t;
    const C = e.find((R) => R.key === u);
    if (!C || typeof C.accessor != "string") return t;
    const S = C.accessor;
    return [...t].sort((R, E) => {
      const T = R[S], M = E[S];
      return T == null ? 1 : M == null ? -1 : T < M ? f === "asc" ? -1 : 1 : T > M ? f === "asc" ? 1 : -1 : 0;
    });
  }, [t, u, f, e]), b = Math.max(1, Math.ceil(h.length / i)), w = h.slice((v - 1) * i, v * i);
  function y(C) {
    C.sortable && (u !== C.key ? (p(C.key), m("asc")) : m((S) => S === "asc" ? "desc" : "asc"));
  }
  function x(C, S) {
    return typeof S.accessor == "function" ? S.accessor(C) : C[S.accessor];
  }
  return /* @__PURE__ */ I("div", { className: N("space-y-4", d), children: [
    /* @__PURE__ */ l("div", { className: "rounded-xl border border-border", children: /* @__PURE__ */ I(Uf, { children: [
      /* @__PURE__ */ l(Kf, { children: /* @__PURE__ */ l(Nr, { children: e.map((C) => /* @__PURE__ */ l(
        Yf,
        {
          onClick: () => y(C),
          className: N(
            C.sortable && "cursor-pointer select-none",
            C.align === "center" && "text-center",
            C.align === "right" && "text-right",
            C.className
          ),
          children: /* @__PURE__ */ I("span", { className: "inline-flex items-center gap-1", children: [
            C.header,
            C.sortable && (u === C.key ? f === "asc" ? /* @__PURE__ */ l(Js, { className: "size-3.5" }) : /* @__PURE__ */ l(Qs, { className: "size-3.5" }) : /* @__PURE__ */ l(Tm, { className: "size-3.5 opacity-40" }))
          ] })
        },
        C.key
      )) }) }),
      /* @__PURE__ */ I(jf, { children: [
        n && Array.from({ length: i }).map((C, S) => /* @__PURE__ */ l(Nr, { children: e.map((R) => /* @__PURE__ */ l(ho, { children: /* @__PURE__ */ l(Uw, { className: "h-4 w-full" }) }, R.key)) }, `skeleton-${S}`)),
        !n && w.map((C, S) => /* @__PURE__ */ l(
          Nr,
          {
            onClick: () => c == null ? void 0 : c(C),
            className: N(c && "cursor-pointer"),
            children: e.map((R) => /* @__PURE__ */ l(
              ho,
              {
                className: N(
                  R.align === "center" && "text-center",
                  R.align === "right" && "text-right"
                ),
                children: x(C, R)
              },
              R.key
            ))
          },
          r ? r(C, S) : S
        ))
      ] })
    ] }) }),
    !n && t.length === 0 && /* @__PURE__ */ l(qf, { title: o, description: a }),
    !n && b > 1 && /* @__PURE__ */ l(Xf, { page: v, pageCount: b, onPageChange: g })
  ] });
}
const vS = s.forwardRef(
  ({ className: e, label: t, value: r, delta: n, trend: o = "flat", icon: a, ...i }, c) => /* @__PURE__ */ I(cr, { ref: c, className: N("p-5", e), ...i, children: [
    /* @__PURE__ */ I("div", { className: "flex items-start justify-between", children: [
      /* @__PURE__ */ l("p", { className: "text-sm font-medium text-muted-foreground", children: t }),
      a && /* @__PURE__ */ l("span", { className: "text-muted-foreground [&_svg]:size-5", children: a })
    ] }),
    /* @__PURE__ */ l("p", { className: "mt-2 text-2xl font-semibold tracking-tight", children: r }),
    n && /* @__PURE__ */ I(
      "p",
      {
        className: N(
          "mt-2 inline-flex items-center gap-1 text-xs font-medium",
          o === "up" && "text-success",
          o === "down" && "text-destructive",
          o === "flat" && "text-muted-foreground"
        ),
        children: [
          o === "up" && /* @__PURE__ */ l(Js, { className: "size-3" }),
          o === "down" && /* @__PURE__ */ l(Qs, { className: "size-3" }),
          n
        ]
      }
    )
  ] })
);
vS.displayName = "KPICard";
const gS = s.forwardRef(
  ({ className: e, title: t, value: r, subtitle: n, progress: o, icon: a, ...i }, c) => /* @__PURE__ */ I(cr, { ref: c, className: N("space-y-3 p-5", e), ...i, children: [
    /* @__PURE__ */ I("div", { className: "flex items-center gap-3", children: [
      a && /* @__PURE__ */ l("span", { className: "flex size-10 items-center justify-center rounded-lg bg-accent text-accent-foreground [&_svg]:size-5", children: a }),
      /* @__PURE__ */ I("div", { children: [
        /* @__PURE__ */ l("p", { className: "text-sm font-medium text-muted-foreground", children: t }),
        /* @__PURE__ */ l("p", { className: "text-xl font-semibold", children: r })
      ] })
    ] }),
    typeof o == "number" && /* @__PURE__ */ I("div", { className: "space-y-1", children: [
      /* @__PURE__ */ l(Yl, { value: o }),
      n && /* @__PURE__ */ l("p", { className: "text-xs text-muted-foreground", children: n })
    ] }),
    typeof o != "number" && n && /* @__PURE__ */ l("p", { className: "text-xs text-muted-foreground", children: n })
  ] })
);
gS.displayName = "MetricCard";
const bS = me("flex flex-col gap-1 rounded-xl border p-4", {
  variants: {
    tone: {
      neutral: "border-border bg-card text-card-foreground",
      primary: "border-transparent bg-primary text-primary-foreground",
      accent: "border-transparent bg-accent text-accent-foreground"
    }
  },
  defaultVariants: { tone: "neutral" }
}), wS = s.forwardRef(
  ({ className: e, tone: t, stat: r, label: n, ...o }, a) => /* @__PURE__ */ I("div", { ref: a, className: N(bS({ tone: t }), e), ...o, children: [
    /* @__PURE__ */ l("span", { className: "text-2xl font-semibold leading-none", children: r }),
    /* @__PURE__ */ l("span", { className: "text-xs font-medium uppercase tracking-wide opacity-70", children: n })
  ] })
);
wS.displayName = "StatCard";
const yS = s.forwardRef(
  ({ className: e, title: t, description: r, actions: n, footer: o, children: a, ...i }, c) => /* @__PURE__ */ I(cr, { ref: c, className: N("flex flex-col", e), ...i, children: [
    /* @__PURE__ */ I("div", { className: "flex items-start justify-between gap-4 p-5 pb-0", children: [
      /* @__PURE__ */ I("div", { children: [
        /* @__PURE__ */ l("h3", { className: "text-base font-semibold", children: t }),
        r && /* @__PURE__ */ l("p", { className: "mt-0.5 text-sm text-muted-foreground", children: r })
      ] }),
      n && /* @__PURE__ */ l("div", { className: "shrink-0", children: n })
    ] }),
    /* @__PURE__ */ l("div", { className: "flex-1 p-5", children: a }),
    o && /* @__PURE__ */ l("div", { className: "border-t border-border p-4", children: o })
  ] })
);
yS.displayName = "DashboardCard";
const xS = s.forwardRef(
  ({
    className: e,
    planName: t,
    price: r,
    priceSuffix: n,
    description: o,
    features: a,
    ctaLabel: i = "Get started",
    onCtaClick: c,
    highlighted: d,
    badgeLabel: u = "Most popular",
    ...p
  }, f) => /* @__PURE__ */ I(
    cr,
    {
      ref: f,
      className: N(
        "relative flex flex-col gap-5 p-6",
        d && "border-primary shadow-md",
        e
      ),
      ...p,
      children: [
        d && /* @__PURE__ */ l(eo, { className: "absolute -top-3 left-1/2 -translate-x-1/2", children: u }),
        /* @__PURE__ */ I("div", { children: [
          /* @__PURE__ */ l("h3", { className: "text-lg font-semibold", children: t }),
          o && /* @__PURE__ */ l("p", { className: "mt-1 text-sm text-muted-foreground", children: o })
        ] }),
        /* @__PURE__ */ I("div", { className: "flex items-end gap-1", children: [
          /* @__PURE__ */ l("span", { className: "text-3xl font-bold tracking-tight", children: r }),
          n && /* @__PURE__ */ l("span", { className: "pb-1 text-sm text-muted-foreground", children: n })
        ] }),
        /* @__PURE__ */ l("ul", { className: "flex-1 space-y-2.5", children: a.map((m) => /* @__PURE__ */ I("li", { className: "flex items-start gap-2 text-sm", children: [
          /* @__PURE__ */ l(nt, { className: "mt-0.5 size-4 shrink-0 text-success" }),
          /* @__PURE__ */ l("span", { children: m })
        ] }, m)) }),
        /* @__PURE__ */ l(Co, { variant: d ? "primary" : "outline", fullWidth: !0, onClick: c, children: i })
      ]
    }
  )
);
xS.displayName = "PricingCard";
function zn(e, t) {
  return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
const CS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], Zf = s.forwardRef(
  ({ value: e, defaultValue: t, onChange: r, highlightedDates: n = [], minDate: o, maxDate: a, className: i }, c) => {
    const d = e !== void 0, [u, p] = s.useState(t), f = d ? e : u, [m, v] = s.useState(f ?? /* @__PURE__ */ new Date()), g = m.getFullYear(), h = m.getMonth(), w = new Date(g, h, 1).getDay(), y = new Date(g, h + 1, 0).getDate();
    function x(R) {
      const E = new Date(g, h, R);
      o && E < o || a && E > a || (d || p(E), r == null || r(E));
    }
    const C = /* @__PURE__ */ new Date(), S = [
      ...Array(w).fill(null),
      ...Array.from({ length: y }, (R, E) => E + 1)
    ];
    return /* @__PURE__ */ I("div", { ref: c, className: N("w-72 rounded-xl border border-border bg-card p-4 shadow-sm", i), children: [
      /* @__PURE__ */ I("div", { className: "mb-3 flex items-center justify-between", children: [
        /* @__PURE__ */ l(
          ht,
          {
            "aria-label": "Previous month",
            icon: /* @__PURE__ */ l(ei, {}),
            size: "sm",
            variant: "ghost",
            onClick: () => v(new Date(g, h - 1, 1))
          }
        ),
        /* @__PURE__ */ l("span", { className: "text-sm font-semibold", children: m.toLocaleString(void 0, { month: "long", year: "numeric" }) }),
        /* @__PURE__ */ l(
          ht,
          {
            "aria-label": "Next month",
            icon: /* @__PURE__ */ l(zt, {}),
            size: "sm",
            variant: "ghost",
            onClick: () => v(new Date(g, h + 1, 1))
          }
        )
      ] }),
      /* @__PURE__ */ l("div", { className: "grid grid-cols-7 gap-1 text-center text-xs font-medium text-muted-foreground", children: CS.map((R) => /* @__PURE__ */ l("span", { className: "py-1", children: R }, R)) }),
      /* @__PURE__ */ l("div", { className: "grid grid-cols-7 gap-1", children: S.map((R, E) => {
        if (R === null) return /* @__PURE__ */ l("span", {}, `empty-${E}`);
        const T = new Date(g, h, R), M = zn(T, C), O = f ? zn(T, f) : !1, D = n.some((H) => zn(H, T)), L = o && T < o || a && T > a;
        return /* @__PURE__ */ I(
          "button",
          {
            type: "button",
            disabled: !!L,
            onClick: () => x(R),
            className: N(
              "relative flex h-9 w-9 items-center justify-center rounded-full text-sm transition-colors",
              "hover:bg-accent hover:text-accent-foreground disabled:pointer-events-none disabled:opacity-30",
              M && !O && "border border-primary",
              O && "bg-primary text-primary-foreground hover:opacity-90",
              D && !O && "bg-accent text-accent-foreground"
            ),
            children: [
              R,
              D && !O && /* @__PURE__ */ l("span", { className: "absolute -top-0.5 right-0.5 text-[8px] text-bp-ausp-gold", children: "★" })
            ]
          },
          R
        );
      }) })
    ] });
  }
);
Zf.displayName = "Calendar";
const SS = (e) => e.toLocaleDateString(void 0, { year: "numeric", month: "short", day: "numeric" }), RS = s.forwardRef(
  ({
    value: e,
    defaultValue: t,
    onChange: r,
    placeholder: n = "Pick a date",
    disabled: o,
    className: a,
    formatDate: i = SS,
    minDate: c,
    maxDate: d,
    highlightedDates: u
  }, p) => {
    const f = e !== void 0, [m, v] = s.useState(t), g = f ? e : m, [h, b] = s.useState(!1);
    return /* @__PURE__ */ I(jo, { open: h, onOpenChange: b, children: [
      /* @__PURE__ */ l(Yo, { asChild: !0, children: /* @__PURE__ */ I(
        "button",
        {
          ref: p,
          type: "button",
          disabled: o,
          className: N(
            "flex h-11 w-full items-center gap-2 rounded-lg border border-input bg-transparent px-3",
            "text-left text-base shadow-sm transition-colors focus-visible:outline-none",
            "focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            a
          ),
          children: [
            /* @__PURE__ */ l(_m, { className: "size-4 text-muted-foreground" }),
            /* @__PURE__ */ l("span", { className: N(!g && "text-muted-foreground"), children: g ? i(g) : n })
          ]
        }
      ) }),
      /* @__PURE__ */ l(dn, { className: "w-auto p-0", align: "start", children: /* @__PURE__ */ l(
        Zf,
        {
          value: g,
          minDate: c,
          maxDate: d,
          highlightedDates: u,
          onChange: (w) => {
            f || v(w), r == null || r(w), b(!1);
          },
          className: "border-none shadow-none"
        }
      ) })
    ] });
  }
);
RS.displayName = "DatePicker";
const br = ["light", "dark", "system"], Cs = {
  light: /* @__PURE__ */ l(zm, {}),
  dark: /* @__PURE__ */ l(Vm, {}),
  system: /* @__PURE__ */ l(Fm, {})
};
function yR({ className: e, variant: t = "cycle" }) {
  const { theme: r, setTheme: n } = kp();
  return t === "segmented" ? /* @__PURE__ */ l("div", { className: N("inline-flex items-center gap-0.5 rounded-full border border-border bg-muted p-1", e), children: br.map((o) => /* @__PURE__ */ l(
    "button",
    {
      type: "button",
      onClick: () => n(o),
      "aria-pressed": r === o,
      "aria-label": `Use ${o} theme`,
      className: N(
        "flex size-8 items-center justify-center rounded-full transition-colors [&_svg]:size-4",
        r === o ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"
      ),
      children: Cs[o]
    },
    o
  )) }) : /* @__PURE__ */ l(
    ht,
    {
      "aria-label": `Switch theme (current: ${r})`,
      icon: Cs[r],
      variant: "outline",
      shape: "circle",
      className: e,
      onClick: () => n(br[(br.indexOf(r) + 1) % br.length])
    }
  );
}
export {
  nR as Accordion,
  fx as AccordionContent,
  dx as AccordionItem,
  ux as AccordionTrigger,
  uw as Alert,
  pw as AlertDescription,
  fw as AlertTitle,
  aS as Avatar,
  iS as AvatarFallback,
  sS as AvatarImage,
  eo as Badge,
  px as Breadcrumb,
  aR as BreadcrumbEllipsis,
  hx as BreadcrumbItem,
  vx as BreadcrumbLink,
  mx as BreadcrumbList,
  gx as BreadcrumbPage,
  oR as BreadcrumbSeparator,
  Co as Button,
  Um as ButtonGroup,
  Zf as Calendar,
  cr as Card,
  uS as CardContent,
  dS as CardDescription,
  fS as CardFooter,
  cS as CardHeader,
  lS as CardTitle,
  nh as Checkbox,
  jb as Combobox,
  Lp as Container,
  yS as DashboardCard,
  wR as DataTable,
  RS as DatePicker,
  LS as Dialog,
  FS as DialogClose,
  Qw as DialogContent,
  ey as DialogDescription,
  BS as DialogFooter,
  VS as DialogHeader,
  hn as DialogOverlay,
  sa as DialogPortal,
  Jw as DialogTitle,
  $S as DialogTrigger,
  zS as Drawer,
  GS as DrawerClose,
  ty as DrawerContent,
  ny as DrawerDescription,
  US as DrawerFooter,
  WS as DrawerHeader,
  ry as DrawerTitle,
  HS as DrawerTrigger,
  sR as DropdownMenu,
  vC as DropdownMenuCheckboxItem,
  mC as DropdownMenuContent,
  cR as DropdownMenuGroup,
  hC as DropdownMenuItem,
  bC as DropdownMenuLabel,
  lR as DropdownMenuPortal,
  uR as DropdownMenuRadioGroup,
  gC as DropdownMenuRadioItem,
  wC as DropdownMenuSeparator,
  fR as DropdownMenuShortcut,
  dR as DropdownMenuSub,
  pC as DropdownMenuSubContent,
  fC as DropdownMenuSubTrigger,
  iR as DropdownMenuTrigger,
  qf as EmptyState,
  Hp as Flex,
  Bp as Grid,
  eR as HoverCard,
  Vy as HoverCardContent,
  tR as HoverCardTrigger,
  ht as IconButton,
  Hr as Input,
  vS as KPICard,
  zh as Label,
  HC as Menubar,
  jC as MenubarCheckboxItem,
  WC as MenubarContent,
  mR as MenubarGroup,
  UC as MenubarItem,
  XC as MenubarLabel,
  pR as MenubarMenu,
  hR as MenubarPortal,
  gR as MenubarRadioGroup,
  YC as MenubarRadioItem,
  KC as MenubarSeparator,
  bR as MenubarShortcut,
  vR as MenubarSub,
  ZC as MenubarSubContent,
  qC as MenubarSubTrigger,
  GC as MenubarTrigger,
  gS as MetricCard,
  Kb as MultiSelect,
  Xm as OTPInput,
  Xf as Pagination,
  jm as PasswordInput,
  jo as Popover,
  AS as PopoverAnchor,
  dn as PopoverContent,
  Yo as PopoverTrigger,
  xS as PricingCard,
  Yl as Progress,
  Dh as RadioGroup,
  kh as RadioGroupItem,
  Rm as ScrollArea,
  Ym as SearchInput,
  TS as Select,
  Mb as SelectContent,
  _S as SelectGroup,
  Ab as SelectItem,
  _b as SelectTrigger,
  MS as SelectValue,
  nm as Separator,
  KS as Sheet,
  YS as SheetClose,
  ay as SheetContent,
  iy as SheetDescription,
  qS as SheetFooter,
  XS as SheetHeader,
  sy as SheetTitle,
  jS as SheetTrigger,
  Uw as Skeleton,
  cw as Slider,
  OS as Spinner,
  Fp as Stack,
  wS as StatCard,
  Vh as Switch,
  Uf as Table,
  jf as TableBody,
  mS as TableCaption,
  ho as TableCell,
  pS as TableFooter,
  Yf as TableHead,
  Kf as TableHeader,
  Nr as TableRow,
  rR as Tabs,
  Uy as TabsContent,
  Gy as TabsList,
  Wy as TabsTrigger,
  Km as Textarea,
  yR as ThemeToggle,
  Vl as Toast,
  IS as ToastAction,
  Hl as ToastClose,
  zl as ToastDescription,
  Dw as ToastProvider,
  Bl as ToastTitle,
  Fl as ToastViewport,
  kS as Toaster,
  QS as Tooltip,
  Ty as TooltipContent,
  ZS as TooltipProvider,
  JS as TooltipTrigger,
  Gm as buttonVariants,
  N as cn,
  DS as toast,
  PS as useControllableState,
  kp as useTheme,
  Lw as useToasts
};
//# sourceMappingURL=index.js.map
